/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type AdditionalDataHolder, type ApiError, type DateOnly, type Guid, type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

export interface Account extends AdditionalDataHolder, Parsable {
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The balance property
     */
    balance?: AccountBalance | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The ledgerId property
     */
    ledgerId?: Guid | null;
    /**
     * The ledgerName property
     */
    ledgerName?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface AccountBalance extends AdditionalDataHolder, Parsable {
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The creditsCount property
     */
    creditsCount?: number | null;
    /**
     * The date property
     */
    date?: Date | null;
    /**
     * The debitsCount property
     */
    debitsCount?: number | null;
    /**
     * The pendingBalance property
     */
    pendingBalance?: number | null;
    /**
     * The pendingCreditsCount property
     */
    pendingCreditsCount?: number | null;
    /**
     * The pendingDebitsCount property
     */
    pendingDebitsCount?: number | null;
}
export interface AccountEntrySummary extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The committedDate property
     */
    committedDate?: Date | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isCommitted property
     */
    isCommitted?: boolean | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The precededBy property
     */
    precededBy?: Guid | null;
    /**
     * The type property
     */
    type?: AccountEntryType | null;
}
export type AccountEntryType = (typeof AccountEntryTypeObject)[keyof typeof AccountEntryTypeObject];
export interface AccountSummary extends AdditionalDataHolder, Parsable {
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The pendingBalance property
     */
    pendingBalance?: number | null;
    /**
     * The pendingCreditsCount property
     */
    pendingCreditsCount?: number | null;
    /**
     * The pendingDebitsCount property
     */
    pendingDebitsCount?: number | null;
}
export interface ActiveCustomersInPeriod extends AdditionalDataHolder, Parsable {
    /**
     * The activeCustomers property
     */
    activeCustomers?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: DateOnly | null;
}
export type ActivityGranularity = (typeof ActivityGranularityObject)[keyof typeof ActivityGranularityObject];
export interface AddBackDatedChargePointConsumptionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The consumptionDate property
     */
    consumptionDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: Guid | null;
}
export interface AddCreditCommand extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isCommitted property
     */
    isCommitted?: boolean | null;
}
export interface AddDebitCommand extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isCommitted property
     */
    isCommitted?: boolean | null;
}
export interface AddressSummary extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The province property
     */
    province?: string | null;
    /**
     * The street property
     */
    street?: string | null;
}
export type AddressType = (typeof AddressTypeObject)[keyof typeof AddressTypeObject];
export interface Affiliate extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The businessCondition property
     */
    businessCondition?: AffiliateTermsDto | null;
    /**
     * The consumerCondition property
     */
    consumerCondition?: AffiliateTermsDto | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface AffiliateContractCount extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The contracts property
     */
    contracts?: number | null;
}
export interface AffiliateSummary extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The businessCondition property
     */
    businessCondition?: AffiliateTermsDto | null;
    /**
     * The consumerCondition property
     */
    consumerCondition?: AffiliateTermsDto | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface AffiliateTermsDto extends AdditionalDataHolder, Parsable {
    /**
     * The discountPercentage property
     */
    discountPercentage?: number | null;
    /**
     * The kickbackPercentage property
     */
    kickbackPercentage?: number | null;
}
export type ApprovalStatus = (typeof ApprovalStatusObject)[keyof typeof ApprovalStatusObject];
export interface AssociateDocumentCommand extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointId property
     */
    chargePointId?: Guid | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The type property
     */
    type?: ContractDocumentType | null;
}
export interface AuditEntrySummary extends AdditionalDataHolder, Parsable {
    /**
     * The action property
     */
    action?: string | null;
    /**
     * The auditEntryType property
     */
    auditEntryType?: AuditEntryType | null;
    /**
     * The changedColumns property
     */
    changedColumns?: string[] | null;
    /**
     * The correlationId property
     */
    correlationId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The newValues property
     */
    newValues?: AuditEntrySummary_newValues | null;
    /**
     * The oldValues property
     */
    oldValues?: AuditEntrySummary_oldValues | null;
    /**
     * The timestamp property
     */
    timestamp?: Date | null;
    /**
     * The userName property
     */
    userName?: string | null;
}
export interface AuditEntrySummary_newValues extends AdditionalDataHolder, Parsable {
}
export interface AuditEntrySummary_oldValues extends AdditionalDataHolder, Parsable {
}
export type AuditEntryType = (typeof AuditEntryTypeObject)[keyof typeof AuditEntryTypeObject];
export interface BackfillCallCustomersResult extends AdditionalDataHolder, Parsable {
    /**
     * The ambiguous property
     */
    ambiguous?: number | null;
    /**
     * The answered property
     */
    answered?: number | null;
    /**
     * The linked property
     */
    linked?: number | null;
    /**
     * The unmatched property
     */
    unmatched?: number | null;
}
export interface BackfillChargePointDeviceIdLine extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointId property
     */
    chargePointId?: Guid | null;
    /**
     * The chargerName property
     */
    chargerName?: string | null;
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The outcome property
     */
    outcome?: BackfillChargePointDeviceIdOutcome | null;
    /**
     * The previousDeviceId property
     */
    previousDeviceId?: string | null;
    /**
     * The reason property
     */
    reason?: DeviceIdMatchReason | null;
}
export type BackfillChargePointDeviceIdOutcome = (typeof BackfillChargePointDeviceIdOutcomeObject)[keyof typeof BackfillChargePointDeviceIdOutcomeObject];
export interface BackfillChargePointDeviceIdsCommand extends AdditionalDataHolder, Parsable {
    /**
     * The dryRun property
     */
    dryRun?: boolean | null;
    /**
     * The provider property
     */
    provider?: OAuthProviderType | null;
}
export interface BackfillChargePointDeviceIdsResult extends AdditionalDataHolder, Parsable {
    /**
     * The alreadyCorrect property
     */
    alreadyCorrect?: number | null;
    /**
     * The conflict property
     */
    conflict?: number | null;
    /**
     * The fixed property
     */
    fixed?: number | null;
    /**
     * The lines property
     */
    lines?: BackfillChargePointDeviceIdLine[] | null;
    /**
     * The undecided property
     */
    undecided?: number | null;
}
export interface BackfillChargerDefinitionLinksCommand extends AdditionalDataHolder, Parsable {
    /**
     * The dryRun property
     */
    dryRun?: boolean | null;
}
export interface BackfillChargerDefinitionLinksResult extends AdditionalDataHolder, Parsable {
    /**
     * The linked property
     */
    linked?: number | null;
    /**
     * The midMeterChanged property
     */
    midMeterChanged?: number | null;
    /**
     * The withoutDefinition property
     */
    withoutDefinition?: number | null;
}
export interface BackfillSessionDatesResult extends AdditionalDataHolder, Parsable {
    /**
     * The ambiguous property
     */
    ambiguous?: number | null;
    /**
     * The filled property
     */
    filled?: number | null;
    /**
     * The skipped property
     */
    skipped?: number | null;
}
export interface CallAnswerer extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export type CallDirection = (typeof CallDirectionObject)[keyof typeof CallDirectionObject];
export interface CallLineSummary extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The number property
     */
    number?: string | null;
}
export interface CallSummary extends AdditionalDataHolder, Parsable {
    /**
     * The answeredBy property
     */
    answeredBy?: string | null;
    /**
     * The calledBy property
     */
    calledBy?: string | null;
    /**
     * The calledNumber property
     */
    calledNumber?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The direction property
     */
    direction?: CallDirection | null;
    /**
     * The duration property
     */
    duration?: string | null;
    /**
     * The endedDate property
     */
    endedDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The lineName property
     */
    lineName?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
    /**
     * The receivedDate property
     */
    receivedDate?: Date | null;
}
export interface CancelPendingEntriesCommand extends AdditionalDataHolder, Parsable {
    /**
     * The entries property
     */
    entries?: Guid[] | null;
    /**
     * The id property
     */
    id?: Guid | null;
}
export interface ChargePoint extends AdditionalDataHolder, Parsable {
    /**
     * The charger property
     */
    charger?: Charger | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ChargePointConnection extends AdditionalDataHolder, Parsable {
    /**
     * The actionRequired property
     */
    actionRequired?: boolean | null;
    /**
     * The chargerId property
     */
    chargerId?: string | null;
    /**
     * The connectedAt property
     */
    connectedAt?: Date | null;
    /**
     * The connectedDate property
     */
    connectedDate?: DateOnly | null;
    /**
     * The deviceIdLocked property
     */
    deviceIdLocked?: boolean | null;
    /**
     * The firstSessionDate property
     */
    firstSessionDate?: Date | null;
    /**
     * The lastFetchedDate property
     */
    lastFetchedDate?: Date | null;
    /**
     * The lastSessionDate property
     */
    lastSessionDate?: Date | null;
    /**
     * The provider property
     */
    provider?: ConsumptionProvider | null;
    /**
     * The reason property
     */
    reason?: string | null;
    /**
     * The source property
     */
    source?: ConsumptionSource | null;
    /**
     * The status property
     */
    status?: ChargerConnectionStatus | null;
    /**
     * The statusDate property
     */
    statusDate?: Date | null;
}
export interface ChargePointConsumption extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The lastConsumptionDate property
     */
    lastConsumptionDate?: Date | null;
    /**
     * The units property
     */
    units?: number | null;
}
export interface ChargePointConsumptionSources extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The sources property
     */
    sources?: ConsumptionSourceTotals[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface ChargePointConsumptionWithProjection extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointId property
     */
    chargePointId?: Guid | null;
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The expectedConsumption property
     */
    expectedConsumption?: number | null;
    /**
     * The expectedPayoutAmount property
     */
    expectedPayoutAmount?: number | null;
    /**
     * The expectedUnits property
     */
    expectedUnits?: number | null;
    /**
     * The expectedYield property
     */
    expectedYield?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The payoutAmount property
     */
    payoutAmount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The projectionDate property
     */
    projectionDate?: DateOnly | null;
    /**
     * The registeredConsumption property
     */
    registeredConsumption?: number | null;
    /**
     * The registeredPayoutAmount property
     */
    registeredPayoutAmount?: number | null;
    /**
     * The registeredTo property
     */
    registeredTo?: DateOnly | null;
    /**
     * The registeredUnits property
     */
    registeredUnits?: number | null;
    /**
     * The registeredYield property
     */
    registeredYield?: number | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export interface ChargePointSummary extends AdditionalDataHolder, Parsable {
    /**
     * The charger property
     */
    charger?: ChargePointSummaryCharger | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ChargePointSummaryCharger extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface ChargePointVolume extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The chargePoints property
     */
    chargePoints?: number | null;
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The erePrice property
     */
    erePrice?: number | null;
    /**
     * The expectedAmount property
     */
    expectedAmount?: number | null;
    /**
     * The expectedConsumption property
     */
    expectedConsumption?: number | null;
    /**
     * The expectedUnits property
     */
    expectedUnits?: number | null;
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The projectionDate property
     */
    projectionDate?: DateOnly | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface Charger extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export type ChargerConnectionStatus = (typeof ChargerConnectionStatusObject)[keyof typeof ChargerConnectionStatusObject];
export interface ChargerCount extends AdditionalDataHolder, Parsable {
    /**
     * The date property
     */
    date?: DateOnly | null;
    /**
     * The makes property
     */
    makes?: ChargerMakeCount[] | null;
}
export interface ChargerDefinition extends AdditionalDataHolder, Parsable {
    /**
     * The chargeType property
     */
    chargeType?: ChargeType | null;
    /**
     * The conformityStatement property
     */
    conformityStatement?: ConformityStatementDto | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The datasheetUrl property
     */
    datasheetUrl?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The meterMake property
     */
    meterMake?: string | null;
    /**
     * The meterModel property
     */
    meterModel?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The source property
     */
    source?: string | null;
}
export interface ChargerDefinitionSummary extends AdditionalDataHolder, Parsable {
    /**
     * The chargeType property
     */
    chargeType?: ChargeType | null;
    /**
     * The conformityStatement property
     */
    conformityStatement?: ConformityStatementDto | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The datasheetUrl property
     */
    datasheetUrl?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The meterMake property
     */
    meterMake?: string | null;
    /**
     * The meterModel property
     */
    meterModel?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The source property
     */
    source?: string | null;
}
export interface ChargerMakeCount extends AdditionalDataHolder, Parsable {
    /**
     * The chargePoints property
     */
    chargePoints?: number | null;
    /**
     * The make property
     */
    make?: string | null;
}
export interface ChargerMakeVolume extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The make property
     */
    make?: string | null;
}
export interface ChargerVolume extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The makes property
     */
    makes?: ChargerMakeVolume[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
}
export type ChargeType = (typeof ChargeTypeObject)[keyof typeof ChargeTypeObject];
export interface CommitPendingEntriesCommand extends AdditionalDataHolder, Parsable {
    /**
     * The entries property
     */
    entries?: Guid[] | null;
    /**
     * The id property
     */
    id?: Guid | null;
}
export interface CompanyRegistrationSummary extends AdditionalDataHolder, Parsable {
    /**
     * The addressType property
     */
    addressType?: string | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The officeNumber property
     */
    officeNumber?: string | null;
    /**
     * The officeType property
     */
    officeType?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The registrationNumber property
     */
    registrationNumber?: string | null;
    /**
     * The street property
     */
    street?: string | null;
}
export type ComplianceActor = (typeof ComplianceActorObject)[keyof typeof ComplianceActorObject];
export type ComplianceItem = (typeof ComplianceItemObject)[keyof typeof ComplianceItemObject];
export type ComplianceStatus = (typeof ComplianceStatusObject)[keyof typeof ComplianceStatusObject];
export interface ConformityStatementDto extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The fileSize property
     */
    fileSize?: number | null;
}
export type ConnectionType = (typeof ConnectionTypeObject)[keyof typeof ConnectionTypeObject];
export type ConsumptionGranularity = (typeof ConsumptionGranularityObject)[keyof typeof ConsumptionGranularityObject];
export interface ConsumptionHistory extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The granularity property
     */
    granularity?: ConsumptionGranularity | null;
    /**
     * The points property
     */
    points?: ConsumptionHistoryPoint[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
}
export interface ConsumptionHistoryPoint extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: DateOnly | null;
    /**
     * The units property
     */
    units?: number | null;
}
export type ConsumptionProvider = (typeof ConsumptionProviderObject)[keyof typeof ConsumptionProviderObject];
export type ConsumptionSource = (typeof ConsumptionSourceObject)[keyof typeof ConsumptionSourceObject];
export interface ConsumptionSourceTotals extends AdditionalDataHolder, Parsable {
    /**
     * The chargerCount property
     */
    chargerCount?: number | null;
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The provider property
     */
    provider?: ConsumptionProvider | null;
    /**
     * The source property
     */
    source?: ConsumptionSource | null;
}
export type ConsumptionType = (typeof ConsumptionTypeObject)[keyof typeof ConsumptionTypeObject];
export interface Contract extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCondition property
     */
    affiliateCondition?: ContractAffiliateCondition | null;
    /**
     * The commissionPercentage property
     */
    commissionPercentage?: number | null;
    /**
     * The complianceStatus property
     */
    complianceStatus?: ComplianceStatus | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The contractRevokedDate property
     */
    contractRevokedDate?: DateOnly | null;
    /**
     * The contractSignedBy property
     */
    contractSignedBy?: string | null;
    /**
     * The contractSignedDate property
     */
    contractSignedDate?: DateOnly | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isEligibleForPayout property
     */
    isEligibleForPayout?: boolean | null;
    /**
     * The isEligibleForRegistration property
     */
    isEligibleForRegistration?: boolean | null;
    /**
     * The isEligibleForTransaction property
     */
    isEligibleForTransaction?: boolean | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The mandateRevokedDate property
     */
    mandateRevokedDate?: DateOnly | null;
    /**
     * The mandateSignedBy property
     */
    mandateSignedBy?: string | null;
    /**
     * The mandateSignedDate property
     */
    mandateSignedDate?: DateOnly | null;
    /**
     * The nextContractId property
     */
    nextContractId?: Guid | null;
    /**
     * The openItems property
     */
    openItems?: ContractComplianceItem[] | null;
    /**
     * The previousContractId property
     */
    previousContractId?: Guid | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface ContractAffiliateCondition extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The discountPercentage property
     */
    discountPercentage?: number | null;
    /**
     * The kickbackPercentage property
     */
    kickbackPercentage?: number | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ContractAffiliateCount extends AdditionalDataHolder, Parsable {
    /**
     * The affiliates property
     */
    affiliates?: AffiliateContractCount[] | null;
    /**
     * The contracts property
     */
    contracts?: number | null;
    /**
     * The date property
     */
    date?: DateOnly | null;
}
export interface ContractComplianceItem extends AdditionalDataHolder, Parsable {
    /**
     * The actor property
     */
    actor?: ComplianceActor | null;
    /**
     * The item property
     */
    item?: ComplianceItem | null;
}
export interface ContractConsumptionWithProjection extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The expectedConsumption property
     */
    expectedConsumption?: number | null;
    /**
     * The expectedPayoutAmount property
     */
    expectedPayoutAmount?: number | null;
    /**
     * The expectedUnits property
     */
    expectedUnits?: number | null;
    /**
     * The expectedYield property
     */
    expectedYield?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The payoutAmount property
     */
    payoutAmount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The projectionDate property
     */
    projectionDate?: DateOnly | null;
    /**
     * The registeredConsumption property
     */
    registeredConsumption?: number | null;
    /**
     * The registeredPayoutAmount property
     */
    registeredPayoutAmount?: number | null;
    /**
     * The registeredTo property
     */
    registeredTo?: DateOnly | null;
    /**
     * The registeredUnits property
     */
    registeredUnits?: number | null;
    /**
     * The registeredYield property
     */
    registeredYield?: number | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export type ContractDocumentType = (typeof ContractDocumentTypeObject)[keyof typeof ContractDocumentTypeObject];
export interface ContractEligibility extends AdditionalDataHolder, Parsable {
    /**
     * The eligibleForPayout property
     */
    eligibleForPayout?: number | null;
    /**
     * The eligibleForRegistration property
     */
    eligibleForRegistration?: number | null;
    /**
     * The eligibleForTransaction property
     */
    eligibleForTransaction?: number | null;
    /**
     * The notEligible property
     */
    notEligible?: number | null;
}
export interface ContractListItem extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: string | null;
    /**
     * The chargePointCount property
     */
    chargePointCount?: number | null;
    /**
     * The complianceStatus property
     */
    complianceStatus?: ComplianceStatus | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The customer property
     */
    customer?: ContractListItemCustomer | null;
    /**
     * The eanCode property
     */
    eanCode?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The openItems property
     */
    openItems?: ContractComplianceItem[] | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface ContractListItemCustomer extends AdditionalDataHolder, Parsable {
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The customerType property
     */
    customerType?: CustomerType | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ContractOverview extends AdditionalDataHolder, Parsable {
    /**
     * The commission property
     */
    commission?: number | null;
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The costs property
     */
    costs?: number | null;
    /**
     * The payoutAmount property
     */
    payoutAmount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The registrationId property
     */
    registrationId?: Guid | null;
    /**
     * The registrationReference property
     */
    registrationReference?: string | null;
    /**
     * The status property
     */
    status?: ContractOverviewStatus | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export type ContractOverviewStatus = (typeof ContractOverviewStatusObject)[keyof typeof ContractOverviewStatusObject];
export interface ContractsCreatedInPeriod extends AdditionalDataHolder, Parsable {
    /**
     * The contractsCreated property
     */
    contractsCreated?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: DateOnly | null;
    /**
     * The toDate property
     */
    toDate?: number | null;
}
export interface ContractsToDate extends AdditionalDataHolder, Parsable {
    /**
     * The current property
     */
    current?: number | null;
    /**
     * The last30Days property
     */
    last30Days?: number | null;
    /**
     * The last7Days property
     */
    last7Days?: number | null;
    /**
     * The today property
     */
    today?: number | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface ContractsToDateHistory extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The granularity property
     */
    granularity?: ActivityGranularity | null;
    /**
     * The points property
     */
    points?: ContractsCreatedInPeriod[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
}
export interface ContractSummary extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCondition property
     */
    affiliateCondition?: ContractSummaryAffiliateCondition | null;
    /**
     * The chargePointCount property
     */
    chargePointCount?: number | null;
    /**
     * The complianceStatus property
     */
    complianceStatus?: ComplianceStatus | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The customer property
     */
    customer?: ContractSummaryCustomer | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isEligibleForPayout property
     */
    isEligibleForPayout?: boolean | null;
    /**
     * The isEligibleForRegistration property
     */
    isEligibleForRegistration?: boolean | null;
    /**
     * The isEligibleForTransaction property
     */
    isEligibleForTransaction?: boolean | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The openItems property
     */
    openItems?: ContractComplianceItem[] | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface ContractSummaryAffiliateCondition extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The discountPercentage property
     */
    discountPercentage?: number | null;
    /**
     * The kickbackPercentage property
     */
    kickbackPercentage?: number | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ContractSummaryCustomer extends AdditionalDataHolder, Parsable {
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface ConversionFactor extends AdditionalDataHolder, Parsable {
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The expectedErePrice property
     */
    expectedErePrice?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The netConsumptionFactor property
     */
    netConsumptionFactor?: number | null;
    /**
     * The renewableConsumptionFactor property
     */
    renewableConsumptionFactor?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface ConversionFactorSummary extends AdditionalDataHolder, Parsable {
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The expectedErePrice property
     */
    expectedErePrice?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The netConsumptionFactor property
     */
    netConsumptionFactor?: number | null;
    /**
     * The renewableConsumptionFactor property
     */
    renewableConsumptionFactor?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface ConvertCustomerToBusinessCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyRegistrationNumber property
     */
    companyRegistrationNumber?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
}
export interface ConvertCustomerToConsumerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountBalance}
 */
// @ts-ignore
export function createAccountBalanceFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountBalance;
}
export interface CreateAccountCommand extends AdditionalDataHolder, Parsable {
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The initialBalance property
     */
    initialBalance?: number | null;
    /**
     * The ledgerId property
     */
    ledgerId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountEntrySummary}
 */
// @ts-ignore
export function createAccountEntrySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountEntrySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Account}
 */
// @ts-ignore
export function createAccountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AccountSummary}
 */
// @ts-ignore
export function createAccountSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAccountSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ActiveCustomersInPeriod}
 */
// @ts-ignore
export function createActiveCustomersInPeriodFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoActiveCustomersInPeriod;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddBackDatedChargePointConsumptionCommand}
 */
// @ts-ignore
export function createAddBackDatedChargePointConsumptionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddBackDatedChargePointConsumptionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddCreditCommand}
 */
// @ts-ignore
export function createAddCreditCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddCreditCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddDebitCommand}
 */
// @ts-ignore
export function createAddDebitCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddDebitCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddressSummary}
 */
// @ts-ignore
export function createAddressSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddressSummary;
}
export interface CreateAffiliateCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The businessCondition property
     */
    businessCondition?: AffiliateTermsDto | null;
    /**
     * The consumerCondition property
     */
    consumerCondition?: AffiliateTermsDto | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AffiliateContractCount}
 */
// @ts-ignore
export function createAffiliateContractCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAffiliateContractCount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Affiliate}
 */
// @ts-ignore
export function createAffiliateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAffiliate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AffiliateSummary}
 */
// @ts-ignore
export function createAffiliateSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAffiliateSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AffiliateTermsDto}
 */
// @ts-ignore
export function createAffiliateTermsDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAffiliateTermsDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AssociateDocumentCommand}
 */
// @ts-ignore
export function createAssociateDocumentCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAssociateDocumentCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AuditEntrySummary_newValues}
 */
// @ts-ignore
export function createAuditEntrySummary_newValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAuditEntrySummary_newValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AuditEntrySummary_oldValues}
 */
// @ts-ignore
export function createAuditEntrySummary_oldValuesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAuditEntrySummary_oldValues;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AuditEntrySummary}
 */
// @ts-ignore
export function createAuditEntrySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAuditEntrySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillCallCustomersResult}
 */
// @ts-ignore
export function createBackfillCallCustomersResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillCallCustomersResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillChargePointDeviceIdLine}
 */
// @ts-ignore
export function createBackfillChargePointDeviceIdLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillChargePointDeviceIdLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillChargePointDeviceIdsCommand}
 */
// @ts-ignore
export function createBackfillChargePointDeviceIdsCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillChargePointDeviceIdsCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillChargePointDeviceIdsResult}
 */
// @ts-ignore
export function createBackfillChargePointDeviceIdsResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillChargePointDeviceIdsResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillChargerDefinitionLinksCommand}
 */
// @ts-ignore
export function createBackfillChargerDefinitionLinksCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillChargerDefinitionLinksCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillChargerDefinitionLinksResult}
 */
// @ts-ignore
export function createBackfillChargerDefinitionLinksResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillChargerDefinitionLinksResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BackfillSessionDatesResult}
 */
// @ts-ignore
export function createBackfillSessionDatesResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBackfillSessionDatesResult;
}
export interface CreateBusinessCustomerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The companyRegistration property
     */
    companyRegistration?: SignupCompanyRegistration | null;
    /**
     * The contact property
     */
    contact?: SignupContact | null;
}
export interface CreateBusinessCustomerResult extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
}
export interface CreateBusinessCustomerWithContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: SignupAddress | null;
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The bankAccount property
     */
    bankAccount?: SignupBankAccount | null;
    /**
     * The chargePoints property
     */
    chargePoints?: SignupChargePoint[] | null;
    /**
     * The companyRegistration property
     */
    companyRegistration?: SignupCompanyRegistration | null;
    /**
     * The contact property
     */
    contact?: SignupContact | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface CreateBusinessCustomerWithContractResult extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointIds property
     */
    chargePointIds?: Guid[] | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CallAnswerer}
 */
// @ts-ignore
export function createCallAnswererFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCallAnswerer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CallLineSummary}
 */
// @ts-ignore
export function createCallLineSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCallLineSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CallSummary}
 */
// @ts-ignore
export function createCallSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCallSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CancelPendingEntriesCommand}
 */
// @ts-ignore
export function createCancelPendingEntriesCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCancelPendingEntriesCommand;
}
export interface CreateChargePointCommand extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The skipVerification property
     */
    skipVerification?: boolean | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointConnection}
 */
// @ts-ignore
export function createChargePointConnectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointConnection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointConsumption}
 */
// @ts-ignore
export function createChargePointConsumptionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointConsumption;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointConsumptionSources}
 */
// @ts-ignore
export function createChargePointConsumptionSourcesFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointConsumptionSources;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointConsumptionWithProjection}
 */
// @ts-ignore
export function createChargePointConsumptionWithProjectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointConsumptionWithProjection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePoint}
 */
// @ts-ignore
export function createChargePointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointSummaryCharger}
 */
// @ts-ignore
export function createChargePointSummaryChargerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointSummaryCharger;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointSummary}
 */
// @ts-ignore
export function createChargePointSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargePointVolume}
 */
// @ts-ignore
export function createChargePointVolumeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargePointVolume;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerCount}
 */
// @ts-ignore
export function createChargerCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerCount;
}
export interface CreateChargerDefinitionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The chargeType property
     */
    chargeType?: ChargeType | null;
    /**
     * The datasheetUrl property
     */
    datasheetUrl?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The meterMake property
     */
    meterMake?: string | null;
    /**
     * The meterModel property
     */
    meterModel?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The source property
     */
    source?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerDefinition}
 */
// @ts-ignore
export function createChargerDefinitionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerDefinition;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerDefinitionSummary}
 */
// @ts-ignore
export function createChargerDefinitionSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerDefinitionSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Charger}
 */
// @ts-ignore
export function createChargerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCharger;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerMakeCount}
 */
// @ts-ignore
export function createChargerMakeCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerMakeCount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerMakeVolume}
 */
// @ts-ignore
export function createChargerMakeVolumeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerMakeVolume;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChargerVolume}
 */
// @ts-ignore
export function createChargerVolumeFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChargerVolume;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CommitPendingEntriesCommand}
 */
// @ts-ignore
export function createCommitPendingEntriesCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCommitPendingEntriesCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompanyRegistrationSummary}
 */
// @ts-ignore
export function createCompanyRegistrationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompanyRegistrationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConformityStatementDto}
 */
// @ts-ignore
export function createConformityStatementDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConformityStatementDto;
}
export interface CreateConsumerCustomerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The contact property
     */
    contact?: SignupContact | null;
}
export interface CreateConsumerCustomerResult extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
}
export interface CreateConsumerCustomerWithContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: SignupAddress | null;
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The bankAccount property
     */
    bankAccount?: SignupBankAccount | null;
    /**
     * The chargePoints property
     */
    chargePoints?: SignupChargePoint[] | null;
    /**
     * The contact property
     */
    contact?: SignupContact | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface CreateConsumerCustomerWithContractResult extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointIds property
     */
    chargePointIds?: Guid[] | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConsumptionHistory}
 */
// @ts-ignore
export function createConsumptionHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConsumptionHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConsumptionHistoryPoint}
 */
// @ts-ignore
export function createConsumptionHistoryPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConsumptionHistoryPoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConsumptionSourceTotals}
 */
// @ts-ignore
export function createConsumptionSourceTotalsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConsumptionSourceTotals;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractAffiliateCondition}
 */
// @ts-ignore
export function createContractAffiliateConditionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractAffiliateCondition;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractAffiliateCount}
 */
// @ts-ignore
export function createContractAffiliateCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractAffiliateCount;
}
export interface CreateContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractComplianceItem}
 */
// @ts-ignore
export function createContractComplianceItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractComplianceItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractConsumptionWithProjection}
 */
// @ts-ignore
export function createContractConsumptionWithProjectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractConsumptionWithProjection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractEligibility}
 */
// @ts-ignore
export function createContractEligibilityFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractEligibility;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Contract}
 */
// @ts-ignore
export function createContractFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContract;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractListItemCustomer}
 */
// @ts-ignore
export function createContractListItemCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractListItemCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractListItem}
 */
// @ts-ignore
export function createContractListItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractListItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractOverview}
 */
// @ts-ignore
export function createContractOverviewFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractOverview;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractsCreatedInPeriod}
 */
// @ts-ignore
export function createContractsCreatedInPeriodFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractsCreatedInPeriod;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractsToDate}
 */
// @ts-ignore
export function createContractsToDateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractsToDate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractsToDateHistory}
 */
// @ts-ignore
export function createContractsToDateHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractsToDateHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractSummaryAffiliateCondition}
 */
// @ts-ignore
export function createContractSummaryAffiliateConditionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractSummaryAffiliateCondition;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractSummaryCustomer}
 */
// @ts-ignore
export function createContractSummaryCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractSummaryCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ContractSummary}
 */
// @ts-ignore
export function createContractSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoContractSummary;
}
export interface CreateConversionFactorCommand extends AdditionalDataHolder, Parsable {
    /**
     * The expectedErePrice property
     */
    expectedErePrice?: number | null;
    /**
     * The netConsumptionFactor property
     */
    netConsumptionFactor?: number | null;
    /**
     * The renewableConsumptionFactor property
     */
    renewableConsumptionFactor?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConversionFactor}
 */
// @ts-ignore
export function createConversionFactorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConversionFactor;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConversionFactorSummary}
 */
// @ts-ignore
export function createConversionFactorSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConversionFactorSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConvertCustomerToBusinessCommand}
 */
// @ts-ignore
export function createConvertCustomerToBusinessCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConvertCustomerToBusinessCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ConvertCustomerToConsumerCommand}
 */
// @ts-ignore
export function createConvertCustomerToConsumerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoConvertCustomerToConsumerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateAccountCommand}
 */
// @ts-ignore
export function createCreateAccountCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateAccountCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateAffiliateCommand}
 */
// @ts-ignore
export function createCreateAffiliateCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateAffiliateCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateBusinessCustomerCommand}
 */
// @ts-ignore
export function createCreateBusinessCustomerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateBusinessCustomerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateBusinessCustomerResult}
 */
// @ts-ignore
export function createCreateBusinessCustomerResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateBusinessCustomerResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateBusinessCustomerWithContractCommand}
 */
// @ts-ignore
export function createCreateBusinessCustomerWithContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateBusinessCustomerWithContractCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateBusinessCustomerWithContractResult}
 */
// @ts-ignore
export function createCreateBusinessCustomerWithContractResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateBusinessCustomerWithContractResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateChargePointCommand}
 */
// @ts-ignore
export function createCreateChargePointCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateChargePointCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateChargerDefinitionCommand}
 */
// @ts-ignore
export function createCreateChargerDefinitionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateChargerDefinitionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateConsumerCustomerCommand}
 */
// @ts-ignore
export function createCreateConsumerCustomerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateConsumerCustomerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateConsumerCustomerResult}
 */
// @ts-ignore
export function createCreateConsumerCustomerResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateConsumerCustomerResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateConsumerCustomerWithContractCommand}
 */
// @ts-ignore
export function createCreateConsumerCustomerWithContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateConsumerCustomerWithContractCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateConsumerCustomerWithContractResult}
 */
// @ts-ignore
export function createCreateConsumerCustomerWithContractResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateConsumerCustomerWithContractResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateContractCommand}
 */
// @ts-ignore
export function createCreateContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateContractCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateConversionFactorCommand}
 */
// @ts-ignore
export function createCreateConversionFactorCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateConversionFactorCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateLedgerCommand}
 */
// @ts-ignore
export function createCreateLedgerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateLedgerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateLocationCommand}
 */
// @ts-ignore
export function createCreateLocationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateLocationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateLocationResult}
 */
// @ts-ignore
export function createCreateLocationResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateLocationResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreatePayoutCommand}
 */
// @ts-ignore
export function createCreatePayoutCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreatePayoutCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateRegistrationCommand}
 */
// @ts-ignore
export function createCreateRegistrationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateRegistrationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateTransactionCommand}
 */
// @ts-ignore
export function createCreateTransactionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateTransactionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CurrentUser}
 */
// @ts-ignore
export function createCurrentUserFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCurrentUser;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerActivity}
 */
// @ts-ignore
export function createCustomerActivityFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerActivity;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerActivityHistory}
 */
// @ts-ignore
export function createCustomerActivityHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerActivityHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerAddress}
 */
// @ts-ignore
export function createCustomerAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerBankAccount}
 */
// @ts-ignore
export function createCustomerBankAccountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerBankAccount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerCompanyRegistration}
 */
// @ts-ignore
export function createCustomerCompanyRegistrationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerCompanyRegistration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerConsumptionWithProjection}
 */
// @ts-ignore
export function createCustomerConsumptionWithProjectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerConsumptionWithProjection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerContact}
 */
// @ts-ignore
export function createCustomerContactFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerContact;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Customer}
 */
// @ts-ignore
export function createCustomerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomer;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerOAuthConnection}
 */
// @ts-ignore
export function createCustomerOAuthConnectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerOAuthConnection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomersCreatedInPeriod}
 */
// @ts-ignore
export function createCustomersCreatedInPeriodFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomersCreatedInPeriod;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomersToDate}
 */
// @ts-ignore
export function createCustomersToDateFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomersToDate;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomersToDateHistory}
 */
// @ts-ignore
export function createCustomersToDateHistoryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomersToDateHistory;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummaryAddress}
 */
// @ts-ignore
export function createCustomerSummaryAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummaryAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummaryCharger}
 */
// @ts-ignore
export function createCustomerSummaryChargerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummaryCharger;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummaryCompanyRegistration}
 */
// @ts-ignore
export function createCustomerSummaryCompanyRegistrationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummaryCompanyRegistration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummaryContact}
 */
// @ts-ignore
export function createCustomerSummaryContactFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummaryContact;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummaryCurrentContract}
 */
// @ts-ignore
export function createCustomerSummaryCurrentContractFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummaryCurrentContract;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerSummary}
 */
// @ts-ignore
export function createCustomerSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CustomerTagCount}
 */
// @ts-ignore
export function createCustomerTagCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCustomerTagCount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DataSharingGrantSummary}
 */
// @ts-ignore
export function createDataSharingGrantSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDataSharingGrantSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentChargePoint}
 */
// @ts-ignore
export function createDocumentChargePointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentChargePoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentRejectionReasons}
 */
// @ts-ignore
export function createDocumentRejectionReasonsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentRejectionReasons;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentReview}
 */
// @ts-ignore
export function createDocumentReviewFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentReview;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DocumentSummary}
 */
// @ts-ignore
export function createDocumentSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDocumentSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnqueueBackfillChargerMakesAndModelsResult}
 */
// @ts-ignore
export function createEnqueueBackfillChargerMakesAndModelsResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnqueueBackfillChargerMakesAndModelsResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnqueueFetchChargePointConsumptionCommand}
 */
// @ts-ignore
export function createEnqueueFetchChargePointConsumptionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnqueueFetchChargePointConsumptionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EnqueueFetchChargePointConsumptionResult}
 */
// @ts-ignore
export function createEnqueueFetchChargePointConsumptionResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEnqueueFetchChargePointConsumptionResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FetchChargePointConsumptionCommand}
 */
// @ts-ignore
export function createFetchChargePointConsumptionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFetchChargePointConsumptionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FetchChargePointConsumptionResult}
 */
// @ts-ignore
export function createFetchChargePointConsumptionResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFetchChargePointConsumptionResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestAffiliateCustomerOrchestrationResult}
 */
// @ts-ignore
export function createIngestAffiliateCustomerOrchestrationResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestAffiliateCustomerOrchestrationResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestAffiliateCustomerReport}
 */
// @ts-ignore
export function createIngestAffiliateCustomerReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestAffiliateCustomerReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestBusinessCustomerReport}
 */
// @ts-ignore
export function createIngestBusinessCustomerReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestBusinessCustomerReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestBusinessCustomerWithContractOrchestrationResult}
 */
// @ts-ignore
export function createIngestBusinessCustomerWithContractOrchestrationResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestBusinessCustomerWithContractOrchestrationResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestBusinessLocationReport}
 */
// @ts-ignore
export function createIngestBusinessLocationReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestBusinessLocationReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestChargePointReport}
 */
// @ts-ignore
export function createIngestChargePointReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestChargePointReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestConsumerCustomerReport}
 */
// @ts-ignore
export function createIngestConsumerCustomerReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestConsumerCustomerReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestConsumerCustomerWithContractOrchestrationResult}
 */
// @ts-ignore
export function createIngestConsumerCustomerWithContractOrchestrationResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestConsumerCustomerWithContractOrchestrationResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestManualChargePointConsumptionResult}
 */
// @ts-ignore
export function createIngestManualChargePointConsumptionResultFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestManualChargePointConsumptionResult;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestManualConsumptionCustomerReport}
 */
// @ts-ignore
export function createIngestManualConsumptionCustomerReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestManualConsumptionCustomerReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IngestManualConsumptionReadingReport}
 */
// @ts-ignore
export function createIngestManualConsumptionReadingReportFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIngestManualConsumptionReadingReport;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LedgerAccount}
 */
// @ts-ignore
export function createLedgerAccountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLedgerAccount;
}
export interface CreateLedgerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The currency property
     */
    currency?: CurrencyType | null;
    /**
     * The name property
     */
    name?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Ledger}
 */
// @ts-ignore
export function createLedgerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLedger;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LedgerSummary}
 */
// @ts-ignore
export function createLedgerSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLedgerSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LinkCallToCustomerCommand}
 */
// @ts-ignore
export function createLinkCallToCustomerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLinkCallToCustomerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationAddress}
 */
// @ts-ignore
export function createLocationAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationChargePoint}
 */
// @ts-ignore
export function createLocationChargePointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationChargePoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationCharger}
 */
// @ts-ignore
export function createLocationChargerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationCharger;
}
export interface CreateLocationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The connectionType property
     */
    connectionType?: ConnectionType | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointGridOperator property
     */
    meteringPointGridOperator?: string | null;
    /**
     * The meteringPointGridOperatorEanCode property
     */
    meteringPointGridOperatorEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The meteringPointVerified property
     */
    meteringPointVerified?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The skipMeteringPointVerification property
     */
    skipMeteringPointVerification?: boolean | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationConsumptionWithProjection}
 */
// @ts-ignore
export function createLocationConsumptionWithProjectionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationConsumptionWithProjection;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationContractAffiliateCondition}
 */
// @ts-ignore
export function createLocationContractAffiliateConditionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationContractAffiliateCondition;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationContract}
 */
// @ts-ignore
export function createLocationContractFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationContract;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Location}
 */
// @ts-ignore
export function createLocationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocation;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationInstallation}
 */
// @ts-ignore
export function createLocationInstallationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationInstallation;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationMeteringPoint}
 */
// @ts-ignore
export function createLocationMeteringPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationMeteringPoint;
}
export interface CreateLocationResult extends AdditionalDataHolder, Parsable {
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationSummaryAddress}
 */
// @ts-ignore
export function createLocationSummaryAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationSummaryAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationSummary}
 */
// @ts-ignore
export function createLocationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {LocationSummaryMeteringPoint}
 */
// @ts-ignore
export function createLocationSummaryMeteringPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoLocationSummaryMeteringPoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MandateSigningCount}
 */
// @ts-ignore
export function createMandateSigningCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMandateSigningCount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ManualConsumptionEntry}
 */
// @ts-ignore
export function createManualConsumptionEntryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoManualConsumptionEntry;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MessageDetail}
 */
// @ts-ignore
export function createMessageDetailFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMessageDetail;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MessageSummary}
 */
// @ts-ignore
export function createMessageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMessageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MeteringPointSummary}
 */
// @ts-ignore
export function createMeteringPointSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMeteringPointSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MoveChargePointCommand}
 */
// @ts-ignore
export function createMoveChargePointCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMoveChargePointCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {OAuthConnectionCharger}
 */
// @ts-ignore
export function createOAuthConnectionChargerFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoOAuthConnectionCharger;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfAccountEntrySummary}
 */
// @ts-ignore
export function createPaginatedListOfAccountEntrySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfAccountEntrySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfAccountSummary}
 */
// @ts-ignore
export function createPaginatedListOfAccountSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfAccountSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfAffiliateSummary}
 */
// @ts-ignore
export function createPaginatedListOfAffiliateSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfAffiliateSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfAuditEntrySummary}
 */
// @ts-ignore
export function createPaginatedListOfAuditEntrySummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfAuditEntrySummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfCallSummary}
 */
// @ts-ignore
export function createPaginatedListOfCallSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfCallSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfChargePointSummary}
 */
// @ts-ignore
export function createPaginatedListOfChargePointSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfChargePointSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfChargerDefinitionSummary}
 */
// @ts-ignore
export function createPaginatedListOfChargerDefinitionSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfChargerDefinitionSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfContractListItem}
 */
// @ts-ignore
export function createPaginatedListOfContractListItemFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfContractListItem;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfContractSummary}
 */
// @ts-ignore
export function createPaginatedListOfContractSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfContractSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfConversionFactorSummary}
 */
// @ts-ignore
export function createPaginatedListOfConversionFactorSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfConversionFactorSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfCustomerSummary}
 */
// @ts-ignore
export function createPaginatedListOfCustomerSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfCustomerSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfDocumentSummary}
 */
// @ts-ignore
export function createPaginatedListOfDocumentSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfDocumentSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfLedgerSummary}
 */
// @ts-ignore
export function createPaginatedListOfLedgerSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfLedgerSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfLocationSummary}
 */
// @ts-ignore
export function createPaginatedListOfLocationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfLocationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfMessageSummary}
 */
// @ts-ignore
export function createPaginatedListOfMessageSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfMessageSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfPayoutSummary}
 */
// @ts-ignore
export function createPaginatedListOfPayoutSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfPayoutSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfRegistrationSummary}
 */
// @ts-ignore
export function createPaginatedListOfRegistrationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfRegistrationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedListOfTransactionSummary}
 */
// @ts-ignore
export function createPaginatedListOfTransactionSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedListOfTransactionSummary;
}
export interface CreatePayoutCommand extends AdditionalDataHolder, Parsable {
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The payoutDate property
     */
    payoutDate?: DateOnly | null;
    /**
     * The payoutPercentage property
     */
    payoutPercentage?: number | null;
    /**
     * The transactionId property
     */
    transactionId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Payout}
 */
// @ts-ignore
export function createPayoutFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPayout;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PayoutLine}
 */
// @ts-ignore
export function createPayoutLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPayoutLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PayoutSummary}
 */
// @ts-ignore
export function createPayoutSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPayoutSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProblemDetails_errors}
 */
// @ts-ignore
export function createProblemDetails_errorsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProblemDetails_errors;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProblemDetails}
 */
// @ts-ignore
export function createProblemDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProblemDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ProlongContractCommand}
 */
// @ts-ignore
export function createProlongContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoProlongContractCommand;
}
export interface CreateRegistrationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The registrationDate property
     */
    registrationDate?: DateOnly | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Registration}
 */
// @ts-ignore
export function createRegistrationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegistration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RegistrationLine}
 */
// @ts-ignore
export function createRegistrationLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegistrationLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RegistrationSummary}
 */
// @ts-ignore
export function createRegistrationSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRegistrationSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevokeContractSigningCommand}
 */
// @ts-ignore
export function createRevokeContractSigningCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevokeContractSigningCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevokeMandateSigningCommand}
 */
// @ts-ignore
export function createRevokeMandateSigningCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevokeMandateSigningCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ServiceProviderSettings}
 */
// @ts-ignore
export function createServiceProviderSettingsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoServiceProviderSettings;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SessionConsumptionEntry}
 */
// @ts-ignore
export function createSessionConsumptionEntryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSessionConsumptionEntry;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignContractCommand}
 */
// @ts-ignore
export function createSignContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignContractCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignMandateCommand}
 */
// @ts-ignore
export function createSignMandateCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignMandateCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignupAddress}
 */
// @ts-ignore
export function createSignupAddressFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignupAddress;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignupBankAccount}
 */
// @ts-ignore
export function createSignupBankAccountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignupBankAccount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignupChargePoint}
 */
// @ts-ignore
export function createSignupChargePointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignupChargePoint;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignupCompanyRegistration}
 */
// @ts-ignore
export function createSignupCompanyRegistrationFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignupCompanyRegistration;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SignupContact}
 */
// @ts-ignore
export function createSignupContactFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSignupContact;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagCustomerCount}
 */
// @ts-ignore
export function createTagCustomerCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagCustomerCount;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagNamespaceCount}
 */
// @ts-ignore
export function createTagNamespaceCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagNamespaceCount;
}
export interface CreateTransactionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The costPercentage property
     */
    costPercentage?: number | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The pricePerUnit property
     */
    pricePerUnit?: number | null;
    /**
     * The registrationId property
     */
    registrationId?: Guid | null;
    /**
     * The transactionDate property
     */
    transactionDate?: DateOnly | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {Transaction}
 */
// @ts-ignore
export function createTransactionFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTransaction;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TransactionLine}
 */
// @ts-ignore
export function createTransactionLineFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTransactionLine;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TransactionSummary}
 */
// @ts-ignore
export function createTransactionSummaryFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTransactionSummary;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateAccountCommand}
 */
// @ts-ignore
export function createUpdateAccountCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateAccountCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateAffiliateCommand}
 */
// @ts-ignore
export function createUpdateAffiliateCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateAffiliateCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateChargePointCommand}
 */
// @ts-ignore
export function createUpdateChargePointCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateChargePointCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateChargerDefinitionCommand}
 */
// @ts-ignore
export function createUpdateChargerDefinitionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateChargerDefinitionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateContractAffiliateConditionCommand}
 */
// @ts-ignore
export function createUpdateContractAffiliateConditionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateContractAffiliateConditionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateContractCommand}
 */
// @ts-ignore
export function createUpdateContractCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateContractCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateContractCommissionPercentageCommand}
 */
// @ts-ignore
export function createUpdateContractCommissionPercentageCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateContractCommissionPercentageCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateConversionFactorCommand}
 */
// @ts-ignore
export function createUpdateConversionFactorCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateConversionFactorCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerAddressCommand}
 */
// @ts-ignore
export function createUpdateCustomerAddressCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerAddressCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerAffiliateCommand}
 */
// @ts-ignore
export function createUpdateCustomerAffiliateCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerAffiliateCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerBankAccountCommand}
 */
// @ts-ignore
export function createUpdateCustomerBankAccountCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerBankAccountCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerCompanyRegistrationCommand}
 */
// @ts-ignore
export function createUpdateCustomerCompanyRegistrationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerCompanyRegistrationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerContactCommand}
 */
// @ts-ignore
export function createUpdateCustomerContactCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerContactCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerNotesCommand}
 */
// @ts-ignore
export function createUpdateCustomerNotesCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerNotesCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateCustomerTagsCommand}
 */
// @ts-ignore
export function createUpdateCustomerTagsCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateCustomerTagsCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateDocumentApprovalCommand}
 */
// @ts-ignore
export function createUpdateDocumentApprovalCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateDocumentApprovalCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateLedgerCommand}
 */
// @ts-ignore
export function createUpdateLedgerCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateLedgerCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateLocationCommand}
 */
// @ts-ignore
export function createUpdateLocationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateLocationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateLocationEssInstallationCommand}
 */
// @ts-ignore
export function createUpdateLocationEssInstallationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateLocationEssInstallationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateLocationPvInstallationCommand}
 */
// @ts-ignore
export function createUpdateLocationPvInstallationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateLocationPvInstallationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdatePayoutCommand}
 */
// @ts-ignore
export function createUpdatePayoutCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdatePayoutCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateRegistrationCommand}
 */
// @ts-ignore
export function createUpdateRegistrationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateRegistrationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsAddressCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsAddressCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsAddressCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsBankAccountCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsBankAccountCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsBankAccountCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsCompanyRegistrationCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsCompanyRegistrationCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsCompanyRegistrationCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsContactCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsContactCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsContactCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsPayoutDetailsCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsPayoutDetailsCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsPayoutDetailsCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateServiceProviderSettingsSupportEmailCommand}
 */
// @ts-ignore
export function createUpdateServiceProviderSettingsSupportEmailCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateServiceProviderSettingsSupportEmailCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateTransactionCommand}
 */
// @ts-ignore
export function createUpdateTransactionCommandFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateTransactionCommand;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {YearMandateSigningCount}
 */
// @ts-ignore
export function createYearMandateSigningCountFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoYearMandateSigningCount;
}
export type CurrencyType = (typeof CurrencyTypeObject)[keyof typeof CurrencyTypeObject];
export interface CurrentUser extends AdditionalDataHolder, Parsable {
    /**
     * The apiBuildNumber property
     */
    apiBuildNumber?: string | null;
    /**
     * The connectAppUrl property
     */
    connectAppUrl?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The environment property
     */
    environment?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The initials property
     */
    initials?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The permissions property
     */
    permissions?: string[] | null;
    /**
     * The roles property
     */
    roles?: string[] | null;
    /**
     * The scopes property
     */
    scopes?: string[] | null;
}
export interface Customer extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: CustomerAddress | null;
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The bankAccount property
     */
    bankAccount?: CustomerBankAccount | null;
    /**
     * The companyRegistration property
     */
    companyRegistration?: CustomerCompanyRegistration | null;
    /**
     * The contact property
     */
    contact?: CustomerContact | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The customerType property
     */
    customerType?: CustomerType | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The lastSeenAt property
     */
    lastSeenAt?: Date | null;
    /**
     * The legacyCompliancyStatus property
     */
    legacyCompliancyStatus?: LegacyCompliancyStatus | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
export interface CustomerActivity extends AdditionalDataHolder, Parsable {
    /**
     * The last30Days property
     */
    last30Days?: number | null;
    /**
     * The last7Days property
     */
    last7Days?: number | null;
    /**
     * The never property
     */
    never?: number | null;
    /**
     * The onlineNow property
     */
    onlineNow?: number | null;
    /**
     * The today property
     */
    today?: number | null;
}
export interface CustomerActivityHistory extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The granularity property
     */
    granularity?: ActivityGranularity | null;
    /**
     * The points property
     */
    points?: ActiveCustomersInPeriod[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
}
export interface CustomerAddress extends AdditionalDataHolder, Parsable {
    /**
     * The addressType property
     */
    addressType?: AddressType | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface CustomerBankAccount extends AdditionalDataHolder, Parsable {
    /**
     * The accountHolder property
     */
    accountHolder?: string | null;
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The bankName property
     */
    bankName?: string | null;
    /**
     * The bic property
     */
    bic?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface CustomerCompanyRegistration extends AdditionalDataHolder, Parsable {
    /**
     * The officeNumber property
     */
    officeNumber?: string | null;
    /**
     * The officeType property
     */
    officeType?: OfficeType | null;
    /**
     * The registrationName property
     */
    registrationName?: string | null;
    /**
     * The registrationNumber property
     */
    registrationNumber?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface CustomerConsumptionWithProjection extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The expectedConsumption property
     */
    expectedConsumption?: number | null;
    /**
     * The expectedPayoutAmount property
     */
    expectedPayoutAmount?: number | null;
    /**
     * The expectedUnits property
     */
    expectedUnits?: number | null;
    /**
     * The expectedYield property
     */
    expectedYield?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The payoutAmount property
     */
    payoutAmount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The projectionDate property
     */
    projectionDate?: DateOnly | null;
    /**
     * The registeredConsumption property
     */
    registeredConsumption?: number | null;
    /**
     * The registeredPayoutAmount property
     */
    registeredPayoutAmount?: number | null;
    /**
     * The registeredTo property
     */
    registeredTo?: DateOnly | null;
    /**
     * The registeredUnits property
     */
    registeredUnits?: number | null;
    /**
     * The registeredYield property
     */
    registeredYield?: number | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export interface CustomerContact extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
}
export interface CustomerOAuthConnection extends AdditionalDataHolder, Parsable {
    /**
     * The chargers property
     */
    chargers?: OAuthConnectionCharger[] | null;
    /**
     * The connectedDate property
     */
    connectedDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isAuthorizationExpired property
     */
    isAuthorizationExpired?: boolean | null;
    /**
     * The isRemovable property
     */
    isRemovable?: boolean | null;
    /**
     * The provider property
     */
    provider?: OAuthProviderType | null;
}
export interface CustomersCreatedInPeriod extends AdditionalDataHolder, Parsable {
    /**
     * The customersCreated property
     */
    customersCreated?: number | null;
    /**
     * The periodStart property
     */
    periodStart?: DateOnly | null;
    /**
     * The toDate property
     */
    toDate?: number | null;
}
export interface CustomersToDate extends AdditionalDataHolder, Parsable {
    /**
     * The last30Days property
     */
    last30Days?: number | null;
    /**
     * The last7Days property
     */
    last7Days?: number | null;
    /**
     * The today property
     */
    today?: number | null;
    /**
     * The total property
     */
    total?: number | null;
}
export interface CustomersToDateHistory extends AdditionalDataHolder, Parsable {
    /**
     * The from property
     */
    from?: DateOnly | null;
    /**
     * The granularity property
     */
    granularity?: ActivityGranularity | null;
    /**
     * The points property
     */
    points?: CustomersCreatedInPeriod[] | null;
    /**
     * The to property
     */
    to?: DateOnly | null;
}
export interface CustomerSummary extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: CustomerSummaryAddress | null;
    /**
     * The affiliateCodes property
     */
    affiliateCodes?: string[] | null;
    /**
     * The chargers property
     */
    chargers?: CustomerSummaryCharger[] | null;
    /**
     * The companyRegistration property
     */
    companyRegistration?: CustomerSummaryCompanyRegistration | null;
    /**
     * The contact property
     */
    contact?: CustomerSummaryContact | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The currentContract property
     */
    currentContract?: CustomerSummaryCurrentContract | null;
    /**
     * The currentContractCount property
     */
    currentContractCount?: number | null;
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The customerType property
     */
    customerType?: CustomerType | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The lastSeenAt property
     */
    lastSeenAt?: Date | null;
    /**
     * The locationCount property
     */
    locationCount?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
export interface CustomerSummaryAddress extends AdditionalDataHolder, Parsable {
    /**
     * The addressType property
     */
    addressType?: AddressType | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface CustomerSummaryCharger extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
}
export interface CustomerSummaryCompanyRegistration extends AdditionalDataHolder, Parsable {
    /**
     * The officeNumber property
     */
    officeNumber?: string | null;
    /**
     * The officeType property
     */
    officeType?: OfficeType | null;
    /**
     * The registrationName property
     */
    registrationName?: string | null;
    /**
     * The registrationNumber property
     */
    registrationNumber?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface CustomerSummaryContact extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The phoneNumber property
     */
    phoneNumber?: string | null;
}
export interface CustomerSummaryCurrentContract extends AdditionalDataHolder, Parsable {
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isEligibleForPayout property
     */
    isEligibleForPayout?: boolean | null;
    /**
     * The isEligibleForRegistration property
     */
    isEligibleForRegistration?: boolean | null;
    /**
     * The isEligibleForTransaction property
     */
    isEligibleForTransaction?: boolean | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface CustomerTagCount extends AdditionalDataHolder, Parsable {
    /**
     * The customers property
     */
    customers?: number | null;
    /**
     * The groups property
     */
    groups?: TagNamespaceCount[] | null;
}
export type CustomerType = (typeof CustomerTypeObject)[keyof typeof CustomerTypeObject];
export interface DataSharingGrantSummary extends AdditionalDataHolder, Parsable {
    /**
     * The applicationName property
     */
    applicationName?: string | null;
    /**
     * The clientId property
     */
    clientId?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The grantedAt property
     */
    grantedAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The revokedAt property
     */
    revokedAt?: Date | null;
}
/**
 * The deserialization information for the current model
 * @param Account The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccount(account: Partial<Account> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountNumber": n => { account.accountNumber = n.getStringValue(); },
        "balance": n => { account.balance = n.getObjectValue<AccountBalance>(createAccountBalanceFromDiscriminatorValue); },
        "createdBy": n => { account.createdBy = n.getStringValue(); },
        "createdDate": n => { account.createdDate = n.getDateValue(); },
        "id": n => { account.id = n.getGuidValue(); },
        "lastModifiedBy": n => { account.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { account.lastModifiedDate = n.getDateValue(); },
        "ledgerId": n => { account.ledgerId = n.getGuidValue(); },
        "ledgerName": n => { account.ledgerName = n.getStringValue(); },
        "name": n => { account.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountBalance The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountBalance(accountBalance: Partial<AccountBalance> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "balance": n => { accountBalance.balance = n.getNumberValue(); },
        "creditsCount": n => { accountBalance.creditsCount = n.getNumberValue(); },
        "date": n => { accountBalance.date = n.getDateValue(); },
        "debitsCount": n => { accountBalance.debitsCount = n.getNumberValue(); },
        "pendingBalance": n => { accountBalance.pendingBalance = n.getNumberValue(); },
        "pendingCreditsCount": n => { accountBalance.pendingCreditsCount = n.getNumberValue(); },
        "pendingDebitsCount": n => { accountBalance.pendingDebitsCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountEntrySummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountEntrySummary(accountEntrySummary: Partial<AccountEntrySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { accountEntrySummary.amount = n.getNumberValue(); },
        "committedDate": n => { accountEntrySummary.committedDate = n.getDateValue(); },
        "createdBy": n => { accountEntrySummary.createdBy = n.getStringValue(); },
        "createdDate": n => { accountEntrySummary.createdDate = n.getDateValue(); },
        "description": n => { accountEntrySummary.description = n.getStringValue(); },
        "id": n => { accountEntrySummary.id = n.getGuidValue(); },
        "isCommitted": n => { accountEntrySummary.isCommitted = n.getBooleanValue(); },
        "lastModifiedBy": n => { accountEntrySummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { accountEntrySummary.lastModifiedDate = n.getDateValue(); },
        "precededBy": n => { accountEntrySummary.precededBy = n.getGuidValue(); },
        "type": n => { accountEntrySummary.type = n.getEnumValue<AccountEntryType>(AccountEntryTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param AccountSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAccountSummary(accountSummary: Partial<AccountSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountNumber": n => { accountSummary.accountNumber = n.getStringValue(); },
        "balance": n => { accountSummary.balance = n.getNumberValue(); },
        "createdBy": n => { accountSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { accountSummary.createdDate = n.getDateValue(); },
        "id": n => { accountSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { accountSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { accountSummary.lastModifiedDate = n.getDateValue(); },
        "name": n => { accountSummary.name = n.getStringValue(); },
        "pendingBalance": n => { accountSummary.pendingBalance = n.getNumberValue(); },
        "pendingCreditsCount": n => { accountSummary.pendingCreditsCount = n.getNumberValue(); },
        "pendingDebitsCount": n => { accountSummary.pendingDebitsCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ActiveCustomersInPeriod The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoActiveCustomersInPeriod(activeCustomersInPeriod: Partial<ActiveCustomersInPeriod> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "activeCustomers": n => { activeCustomersInPeriod.activeCustomers = n.getNumberValue(); },
        "periodStart": n => { activeCustomersInPeriod.periodStart = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AddBackDatedChargePointConsumptionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddBackDatedChargePointConsumptionCommand(addBackDatedChargePointConsumptionCommand: Partial<AddBackDatedChargePointConsumptionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { addBackDatedChargePointConsumptionCommand.consumption = n.getNumberValue(); },
        "consumptionDate": n => { addBackDatedChargePointConsumptionCommand.consumptionDate = n.getDateOnlyValue(); },
        "id": n => { addBackDatedChargePointConsumptionCommand.id = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AddCreditCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddCreditCommand(addCreditCommand: Partial<AddCreditCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { addCreditCommand.amount = n.getNumberValue(); },
        "description": n => { addCreditCommand.description = n.getStringValue(); },
        "id": n => { addCreditCommand.id = n.getGuidValue(); },
        "isCommitted": n => { addCreditCommand.isCommitted = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AddDebitCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddDebitCommand(addDebitCommand: Partial<AddDebitCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { addDebitCommand.amount = n.getNumberValue(); },
        "description": n => { addDebitCommand.description = n.getStringValue(); },
        "id": n => { addDebitCommand.id = n.getGuidValue(); },
        "isCommitted": n => { addDebitCommand.isCommitted = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AddressSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddressSummary(addressSummary: Partial<AddressSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { addressSummary.city = n.getStringValue(); },
        "houseNumber": n => { addressSummary.houseNumber = n.getStringValue(); },
        "postcode": n => { addressSummary.postcode = n.getStringValue(); },
        "province": n => { addressSummary.province = n.getStringValue(); },
        "street": n => { addressSummary.street = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Affiliate The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAffiliate(affiliate: Partial<Affiliate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { affiliate.affiliateCode = n.getStringValue(); },
        "businessCondition": n => { affiliate.businessCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "consumerCondition": n => { affiliate.consumerCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "createdBy": n => { affiliate.createdBy = n.getStringValue(); },
        "createdDate": n => { affiliate.createdDate = n.getDateValue(); },
        "id": n => { affiliate.id = n.getGuidValue(); },
        "lastModifiedBy": n => { affiliate.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { affiliate.lastModifiedDate = n.getDateValue(); },
        "name": n => { affiliate.name = n.getStringValue(); },
        "notes": n => { affiliate.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AffiliateContractCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAffiliateContractCount(affiliateContractCount: Partial<AffiliateContractCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { affiliateContractCount.affiliateCode = n.getStringValue(); },
        "contracts": n => { affiliateContractCount.contracts = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AffiliateSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAffiliateSummary(affiliateSummary: Partial<AffiliateSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { affiliateSummary.affiliateCode = n.getStringValue(); },
        "businessCondition": n => { affiliateSummary.businessCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "consumerCondition": n => { affiliateSummary.consumerCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "contractCount": n => { affiliateSummary.contractCount = n.getNumberValue(); },
        "createdBy": n => { affiliateSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { affiliateSummary.createdDate = n.getDateValue(); },
        "id": n => { affiliateSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { affiliateSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { affiliateSummary.lastModifiedDate = n.getDateValue(); },
        "name": n => { affiliateSummary.name = n.getStringValue(); },
        "notes": n => { affiliateSummary.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AffiliateTermsDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAffiliateTermsDto(affiliateTermsDto: Partial<AffiliateTermsDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "discountPercentage": n => { affiliateTermsDto.discountPercentage = n.getNumberValue(); },
        "kickbackPercentage": n => { affiliateTermsDto.kickbackPercentage = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AssociateDocumentCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAssociateDocumentCommand(associateDocumentCommand: Partial<AssociateDocumentCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointId": n => { associateDocumentCommand.chargePointId = n.getGuidValue(); },
        "contractId": n => { associateDocumentCommand.contractId = n.getGuidValue(); },
        "id": n => { associateDocumentCommand.id = n.getGuidValue(); },
        "locationId": n => { associateDocumentCommand.locationId = n.getGuidValue(); },
        "type": n => { associateDocumentCommand.type = n.getEnumValue<ContractDocumentType>(ContractDocumentTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param AuditEntrySummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuditEntrySummary(auditEntrySummary: Partial<AuditEntrySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "action": n => { auditEntrySummary.action = n.getStringValue(); },
        "auditEntryType": n => { auditEntrySummary.auditEntryType = n.getEnumValue<AuditEntryType>(AuditEntryTypeObject); },
        "changedColumns": n => { auditEntrySummary.changedColumns = n.getCollectionOfPrimitiveValues<string>("string"); },
        "correlationId": n => { auditEntrySummary.correlationId = n.getGuidValue(); },
        "id": n => { auditEntrySummary.id = n.getGuidValue(); },
        "newValues": n => { auditEntrySummary.newValues = n.getObjectValue<AuditEntrySummary_newValues>(createAuditEntrySummary_newValuesFromDiscriminatorValue); },
        "oldValues": n => { auditEntrySummary.oldValues = n.getObjectValue<AuditEntrySummary_oldValues>(createAuditEntrySummary_oldValuesFromDiscriminatorValue); },
        "timestamp": n => { auditEntrySummary.timestamp = n.getDateValue(); },
        "userName": n => { auditEntrySummary.userName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AuditEntrySummary_newValues The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuditEntrySummary_newValues(auditEntrySummary_newValues: Partial<AuditEntrySummary_newValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param AuditEntrySummary_oldValues The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAuditEntrySummary_oldValues(auditEntrySummary_oldValues: Partial<AuditEntrySummary_oldValues> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillCallCustomersResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillCallCustomersResult(backfillCallCustomersResult: Partial<BackfillCallCustomersResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ambiguous": n => { backfillCallCustomersResult.ambiguous = n.getNumberValue(); },
        "answered": n => { backfillCallCustomersResult.answered = n.getNumberValue(); },
        "linked": n => { backfillCallCustomersResult.linked = n.getNumberValue(); },
        "unmatched": n => { backfillCallCustomersResult.unmatched = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillChargePointDeviceIdLine The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillChargePointDeviceIdLine(backfillChargePointDeviceIdLine: Partial<BackfillChargePointDeviceIdLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointId": n => { backfillChargePointDeviceIdLine.chargePointId = n.getGuidValue(); },
        "chargerName": n => { backfillChargePointDeviceIdLine.chargerName = n.getStringValue(); },
        "deviceId": n => { backfillChargePointDeviceIdLine.deviceId = n.getStringValue(); },
        "externalCustomerId": n => { backfillChargePointDeviceIdLine.externalCustomerId = n.getStringValue(); },
        "make": n => { backfillChargePointDeviceIdLine.make = n.getStringValue(); },
        "model": n => { backfillChargePointDeviceIdLine.model = n.getStringValue(); },
        "outcome": n => { backfillChargePointDeviceIdLine.outcome = n.getEnumValue<BackfillChargePointDeviceIdOutcome>(BackfillChargePointDeviceIdOutcomeObject); },
        "previousDeviceId": n => { backfillChargePointDeviceIdLine.previousDeviceId = n.getStringValue(); },
        "reason": n => { backfillChargePointDeviceIdLine.reason = n.getEnumValue<DeviceIdMatchReason>(DeviceIdMatchReasonObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillChargePointDeviceIdsCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillChargePointDeviceIdsCommand(backfillChargePointDeviceIdsCommand: Partial<BackfillChargePointDeviceIdsCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { backfillChargePointDeviceIdsCommand.dryRun = n.getBooleanValue(); },
        "provider": n => { backfillChargePointDeviceIdsCommand.provider = n.getEnumValue<OAuthProviderType>(OAuthProviderTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillChargePointDeviceIdsResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillChargePointDeviceIdsResult(backfillChargePointDeviceIdsResult: Partial<BackfillChargePointDeviceIdsResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "alreadyCorrect": n => { backfillChargePointDeviceIdsResult.alreadyCorrect = n.getNumberValue(); },
        "conflict": n => { backfillChargePointDeviceIdsResult.conflict = n.getNumberValue(); },
        "fixed": n => { backfillChargePointDeviceIdsResult.fixed = n.getNumberValue(); },
        "lines": n => { backfillChargePointDeviceIdsResult.lines = n.getCollectionOfObjectValues<BackfillChargePointDeviceIdLine>(createBackfillChargePointDeviceIdLineFromDiscriminatorValue); },
        "undecided": n => { backfillChargePointDeviceIdsResult.undecided = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillChargerDefinitionLinksCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillChargerDefinitionLinksCommand(backfillChargerDefinitionLinksCommand: Partial<BackfillChargerDefinitionLinksCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "dryRun": n => { backfillChargerDefinitionLinksCommand.dryRun = n.getBooleanValue() ?? true; },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillChargerDefinitionLinksResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillChargerDefinitionLinksResult(backfillChargerDefinitionLinksResult: Partial<BackfillChargerDefinitionLinksResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "linked": n => { backfillChargerDefinitionLinksResult.linked = n.getNumberValue(); },
        "midMeterChanged": n => { backfillChargerDefinitionLinksResult.midMeterChanged = n.getNumberValue(); },
        "withoutDefinition": n => { backfillChargerDefinitionLinksResult.withoutDefinition = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BackfillSessionDatesResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBackfillSessionDatesResult(backfillSessionDatesResult: Partial<BackfillSessionDatesResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ambiguous": n => { backfillSessionDatesResult.ambiguous = n.getNumberValue(); },
        "filled": n => { backfillSessionDatesResult.filled = n.getNumberValue(); },
        "skipped": n => { backfillSessionDatesResult.skipped = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CallAnswerer The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCallAnswerer(callAnswerer: Partial<CallAnswerer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { callAnswerer.email = n.getStringValue(); },
        "name": n => { callAnswerer.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CallLineSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCallLineSummary(callLineSummary: Partial<CallLineSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { callLineSummary.name = n.getStringValue(); },
        "number": n => { callLineSummary.number = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CallSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCallSummary(callSummary: Partial<CallSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "answeredBy": n => { callSummary.answeredBy = n.getStringValue(); },
        "calledBy": n => { callSummary.calledBy = n.getStringValue(); },
        "calledNumber": n => { callSummary.calledNumber = n.getStringValue(); },
        "customerId": n => { callSummary.customerId = n.getGuidValue(); },
        "customerName": n => { callSummary.customerName = n.getStringValue(); },
        "direction": n => { callSummary.direction = n.getEnumValue<CallDirection>(CallDirectionObject); },
        "duration": n => { callSummary.duration = n.getStringValue(); },
        "endedDate": n => { callSummary.endedDate = n.getDateValue(); },
        "id": n => { callSummary.id = n.getGuidValue(); },
        "isActive": n => { callSummary.isActive = n.getBooleanValue(); },
        "lineName": n => { callSummary.lineName = n.getStringValue(); },
        "phoneNumber": n => { callSummary.phoneNumber = n.getStringValue(); },
        "receivedDate": n => { callSummary.receivedDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CancelPendingEntriesCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCancelPendingEntriesCommand(cancelPendingEntriesCommand: Partial<CancelPendingEntriesCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entries": n => { cancelPendingEntriesCommand.entries = n.getCollectionOfPrimitiveValues<Guid>("string"); },
        "id": n => { cancelPendingEntriesCommand.id = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePoint(chargePoint: Partial<ChargePoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "charger": n => { chargePoint.charger = n.getObjectValue<Charger>(createChargerFromDiscriminatorValue); },
        "createdBy": n => { chargePoint.createdBy = n.getStringValue(); },
        "createdDate": n => { chargePoint.createdDate = n.getDateValue(); },
        "id": n => { chargePoint.id = n.getGuidValue(); },
        "lastModifiedBy": n => { chargePoint.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { chargePoint.lastModifiedDate = n.getDateValue(); },
        "locationId": n => { chargePoint.locationId = n.getGuidValue(); },
        "name": n => { chargePoint.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointConnection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointConnection(chargePointConnection: Partial<ChargePointConnection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "actionRequired": n => { chargePointConnection.actionRequired = n.getBooleanValue(); },
        "chargerId": n => { chargePointConnection.chargerId = n.getStringValue(); },
        "connectedAt": n => { chargePointConnection.connectedAt = n.getDateValue(); },
        "connectedDate": n => { chargePointConnection.connectedDate = n.getDateOnlyValue(); },
        "deviceIdLocked": n => { chargePointConnection.deviceIdLocked = n.getBooleanValue(); },
        "firstSessionDate": n => { chargePointConnection.firstSessionDate = n.getDateValue(); },
        "lastFetchedDate": n => { chargePointConnection.lastFetchedDate = n.getDateValue(); },
        "lastSessionDate": n => { chargePointConnection.lastSessionDate = n.getDateValue(); },
        "provider": n => { chargePointConnection.provider = n.getEnumValue<ConsumptionProvider>(ConsumptionProviderObject); },
        "reason": n => { chargePointConnection.reason = n.getStringValue(); },
        "source": n => { chargePointConnection.source = n.getEnumValue<ConsumptionSource>(ConsumptionSourceObject); },
        "status": n => { chargePointConnection.status = n.getEnumValue<ChargerConnectionStatus>(ChargerConnectionStatusObject); },
        "statusDate": n => { chargePointConnection.statusDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointConsumption The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointConsumption(chargePointConsumption: Partial<ChargePointConsumption> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { chargePointConsumption.consumption = n.getNumberValue(); },
        "deviceId": n => { chargePointConsumption.deviceId = n.getStringValue(); },
        "lastConsumptionDate": n => { chargePointConsumption.lastConsumptionDate = n.getDateValue(); },
        "units": n => { chargePointConsumption.units = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointConsumptionSources The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointConsumptionSources(chargePointConsumptionSources: Partial<ChargePointConsumptionSources> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { chargePointConsumptionSources.from = n.getDateOnlyValue(); },
        "sources": n => { chargePointConsumptionSources.sources = n.getCollectionOfObjectValues<ConsumptionSourceTotals>(createConsumptionSourceTotalsFromDiscriminatorValue); },
        "to": n => { chargePointConsumptionSources.to = n.getDateOnlyValue(); },
        "year": n => { chargePointConsumptionSources.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointConsumptionWithProjection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointConsumptionWithProjection(chargePointConsumptionWithProjection: Partial<ChargePointConsumptionWithProjection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointId": n => { chargePointConsumptionWithProjection.chargePointId = n.getGuidValue(); },
        "consumption": n => { chargePointConsumptionWithProjection.consumption = n.getNumberValue(); },
        "contractId": n => { chargePointConsumptionWithProjection.contractId = n.getGuidValue(); },
        "expectedConsumption": n => { chargePointConsumptionWithProjection.expectedConsumption = n.getNumberValue(); },
        "expectedPayoutAmount": n => { chargePointConsumptionWithProjection.expectedPayoutAmount = n.getNumberValue(); },
        "expectedUnits": n => { chargePointConsumptionWithProjection.expectedUnits = n.getNumberValue(); },
        "expectedYield": n => { chargePointConsumptionWithProjection.expectedYield = n.getNumberValue(); },
        "id": n => { chargePointConsumptionWithProjection.id = n.getGuidValue(); },
        "payoutAmount": n => { chargePointConsumptionWithProjection.payoutAmount = n.getNumberValue(); },
        "periodFrom": n => { chargePointConsumptionWithProjection.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { chargePointConsumptionWithProjection.periodTo = n.getDateOnlyValue(); },
        "projectionDate": n => { chargePointConsumptionWithProjection.projectionDate = n.getDateOnlyValue(); },
        "registeredConsumption": n => { chargePointConsumptionWithProjection.registeredConsumption = n.getNumberValue(); },
        "registeredPayoutAmount": n => { chargePointConsumptionWithProjection.registeredPayoutAmount = n.getNumberValue(); },
        "registeredTo": n => { chargePointConsumptionWithProjection.registeredTo = n.getDateOnlyValue(); },
        "registeredUnits": n => { chargePointConsumptionWithProjection.registeredUnits = n.getNumberValue(); },
        "registeredYield": n => { chargePointConsumptionWithProjection.registeredYield = n.getNumberValue(); },
        "units": n => { chargePointConsumptionWithProjection.units = n.getNumberValue(); },
        "yield": n => { chargePointConsumptionWithProjection.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointSummary(chargePointSummary: Partial<ChargePointSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "charger": n => { chargePointSummary.charger = n.getObjectValue<ChargePointSummaryCharger>(createChargePointSummaryChargerFromDiscriminatorValue); },
        "createdBy": n => { chargePointSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { chargePointSummary.createdDate = n.getDateValue(); },
        "id": n => { chargePointSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { chargePointSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { chargePointSummary.lastModifiedDate = n.getDateValue(); },
        "locationId": n => { chargePointSummary.locationId = n.getGuidValue(); },
        "name": n => { chargePointSummary.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointSummaryCharger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointSummaryCharger(chargePointSummaryCharger: Partial<ChargePointSummaryCharger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { chargePointSummaryCharger.deviceId = n.getStringValue(); },
        "make": n => { chargePointSummaryCharger.make = n.getStringValue(); },
        "midMeter": n => { chargePointSummaryCharger.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { chargePointSummaryCharger.model = n.getStringValue(); },
        "verificationStatus": n => { chargePointSummaryCharger.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargePointVolume The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargePointVolume(chargePointVolume: Partial<ChargePointVolume> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { chargePointVolume.amount = n.getNumberValue(); },
        "chargePoints": n => { chargePointVolume.chargePoints = n.getNumberValue(); },
        "consumption": n => { chargePointVolume.consumption = n.getNumberValue(); },
        "erePrice": n => { chargePointVolume.erePrice = n.getNumberValue(); },
        "expectedAmount": n => { chargePointVolume.expectedAmount = n.getNumberValue(); },
        "expectedConsumption": n => { chargePointVolume.expectedConsumption = n.getNumberValue(); },
        "expectedUnits": n => { chargePointVolume.expectedUnits = n.getNumberValue(); },
        "from": n => { chargePointVolume.from = n.getDateOnlyValue(); },
        "projectionDate": n => { chargePointVolume.projectionDate = n.getDateOnlyValue(); },
        "to": n => { chargePointVolume.to = n.getDateOnlyValue(); },
        "units": n => { chargePointVolume.units = n.getNumberValue(); },
        "year": n => { chargePointVolume.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Charger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCharger(charger: Partial<Charger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { charger.deviceId = n.getStringValue(); },
        "make": n => { charger.make = n.getStringValue(); },
        "midMeter": n => { charger.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { charger.model = n.getStringValue(); },
        "verificationStatus": n => { charger.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerCount(chargerCount: Partial<ChargerCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "date": n => { chargerCount.date = n.getDateOnlyValue(); },
        "makes": n => { chargerCount.makes = n.getCollectionOfObjectValues<ChargerMakeCount>(createChargerMakeCountFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerDefinition The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerDefinition(chargerDefinition: Partial<ChargerDefinition> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargeType": n => { chargerDefinition.chargeType = n.getEnumValue<ChargeType>(ChargeTypeObject); },
        "conformityStatement": n => { chargerDefinition.conformityStatement = n.getObjectValue<ConformityStatementDto>(createConformityStatementDtoFromDiscriminatorValue); },
        "createdBy": n => { chargerDefinition.createdBy = n.getStringValue(); },
        "createdDate": n => { chargerDefinition.createdDate = n.getDateValue(); },
        "datasheetUrl": n => { chargerDefinition.datasheetUrl = n.getStringValue(); },
        "id": n => { chargerDefinition.id = n.getGuidValue(); },
        "lastModifiedBy": n => { chargerDefinition.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { chargerDefinition.lastModifiedDate = n.getDateValue(); },
        "make": n => { chargerDefinition.make = n.getStringValue(); },
        "meterMake": n => { chargerDefinition.meterMake = n.getStringValue(); },
        "meterModel": n => { chargerDefinition.meterModel = n.getStringValue(); },
        "midMeter": n => { chargerDefinition.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { chargerDefinition.model = n.getStringValue(); },
        "notes": n => { chargerDefinition.notes = n.getStringValue(); },
        "source": n => { chargerDefinition.source = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerDefinitionSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerDefinitionSummary(chargerDefinitionSummary: Partial<ChargerDefinitionSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargeType": n => { chargerDefinitionSummary.chargeType = n.getEnumValue<ChargeType>(ChargeTypeObject); },
        "conformityStatement": n => { chargerDefinitionSummary.conformityStatement = n.getObjectValue<ConformityStatementDto>(createConformityStatementDtoFromDiscriminatorValue); },
        "createdBy": n => { chargerDefinitionSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { chargerDefinitionSummary.createdDate = n.getDateValue(); },
        "datasheetUrl": n => { chargerDefinitionSummary.datasheetUrl = n.getStringValue(); },
        "id": n => { chargerDefinitionSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { chargerDefinitionSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { chargerDefinitionSummary.lastModifiedDate = n.getDateValue(); },
        "make": n => { chargerDefinitionSummary.make = n.getStringValue(); },
        "meterMake": n => { chargerDefinitionSummary.meterMake = n.getStringValue(); },
        "meterModel": n => { chargerDefinitionSummary.meterModel = n.getStringValue(); },
        "midMeter": n => { chargerDefinitionSummary.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { chargerDefinitionSummary.model = n.getStringValue(); },
        "notes": n => { chargerDefinitionSummary.notes = n.getStringValue(); },
        "source": n => { chargerDefinitionSummary.source = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerMakeCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerMakeCount(chargerMakeCount: Partial<ChargerMakeCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePoints": n => { chargerMakeCount.chargePoints = n.getNumberValue(); },
        "make": n => { chargerMakeCount.make = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerMakeVolume The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerMakeVolume(chargerMakeVolume: Partial<ChargerMakeVolume> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { chargerMakeVolume.consumption = n.getNumberValue(); },
        "make": n => { chargerMakeVolume.make = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ChargerVolume The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChargerVolume(chargerVolume: Partial<ChargerVolume> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { chargerVolume.from = n.getDateOnlyValue(); },
        "makes": n => { chargerVolume.makes = n.getCollectionOfObjectValues<ChargerMakeVolume>(createChargerMakeVolumeFromDiscriminatorValue); },
        "to": n => { chargerVolume.to = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CommitPendingEntriesCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCommitPendingEntriesCommand(commitPendingEntriesCommand: Partial<CommitPendingEntriesCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "entries": n => { commitPendingEntriesCommand.entries = n.getCollectionOfPrimitiveValues<Guid>("string"); },
        "id": n => { commitPendingEntriesCommand.id = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CompanyRegistrationSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompanyRegistrationSummary(companyRegistrationSummary: Partial<CompanyRegistrationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addressType": n => { companyRegistrationSummary.addressType = n.getStringValue(); },
        "city": n => { companyRegistrationSummary.city = n.getStringValue(); },
        "houseNumber": n => { companyRegistrationSummary.houseNumber = n.getStringValue(); },
        "name": n => { companyRegistrationSummary.name = n.getStringValue(); },
        "officeNumber": n => { companyRegistrationSummary.officeNumber = n.getStringValue(); },
        "officeType": n => { companyRegistrationSummary.officeType = n.getStringValue(); },
        "postcode": n => { companyRegistrationSummary.postcode = n.getStringValue(); },
        "registrationNumber": n => { companyRegistrationSummary.registrationNumber = n.getStringValue(); },
        "street": n => { companyRegistrationSummary.street = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConformityStatementDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConformityStatementDto(conformityStatementDto: Partial<ConformityStatementDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { conformityStatementDto.contentType = n.getStringValue(); },
        "fileName": n => { conformityStatementDto.fileName = n.getStringValue(); },
        "fileSize": n => { conformityStatementDto.fileSize = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConsumptionHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConsumptionHistory(consumptionHistory: Partial<ConsumptionHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { consumptionHistory.from = n.getDateOnlyValue(); },
        "granularity": n => { consumptionHistory.granularity = n.getEnumValue<ConsumptionGranularity>(ConsumptionGranularityObject); },
        "points": n => { consumptionHistory.points = n.getCollectionOfObjectValues<ConsumptionHistoryPoint>(createConsumptionHistoryPointFromDiscriminatorValue); },
        "to": n => { consumptionHistory.to = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConsumptionHistoryPoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConsumptionHistoryPoint(consumptionHistoryPoint: Partial<ConsumptionHistoryPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { consumptionHistoryPoint.consumption = n.getNumberValue(); },
        "periodStart": n => { consumptionHistoryPoint.periodStart = n.getDateOnlyValue(); },
        "units": n => { consumptionHistoryPoint.units = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConsumptionSourceTotals The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConsumptionSourceTotals(consumptionSourceTotals: Partial<ConsumptionSourceTotals> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargerCount": n => { consumptionSourceTotals.chargerCount = n.getNumberValue(); },
        "consumption": n => { consumptionSourceTotals.consumption = n.getNumberValue(); },
        "provider": n => { consumptionSourceTotals.provider = n.getEnumValue<ConsumptionProvider>(ConsumptionProviderObject); },
        "source": n => { consumptionSourceTotals.source = n.getEnumValue<ConsumptionSource>(ConsumptionSourceObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param Contract The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContract(contract: Partial<Contract> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCondition": n => { contract.affiliateCondition = n.getObjectValue<ContractAffiliateCondition>(createContractAffiliateConditionFromDiscriminatorValue); },
        "commissionPercentage": n => { contract.commissionPercentage = n.getNumberValue(); },
        "complianceStatus": n => { contract.complianceStatus = n.getEnumValue<ComplianceStatus>(ComplianceStatusObject); },
        "contractReference": n => { contract.contractReference = n.getStringValue(); },
        "contractRevokedDate": n => { contract.contractRevokedDate = n.getDateOnlyValue(); },
        "contractSignedBy": n => { contract.contractSignedBy = n.getStringValue(); },
        "contractSignedDate": n => { contract.contractSignedDate = n.getDateOnlyValue(); },
        "createdBy": n => { contract.createdBy = n.getStringValue(); },
        "createdDate": n => { contract.createdDate = n.getDateValue(); },
        "customerId": n => { contract.customerId = n.getGuidValue(); },
        "id": n => { contract.id = n.getGuidValue(); },
        "isEligibleForPayout": n => { contract.isEligibleForPayout = n.getBooleanValue(); },
        "isEligibleForRegistration": n => { contract.isEligibleForRegistration = n.getBooleanValue(); },
        "isEligibleForTransaction": n => { contract.isEligibleForTransaction = n.getBooleanValue(); },
        "lastModifiedBy": n => { contract.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { contract.lastModifiedDate = n.getDateValue(); },
        "locationId": n => { contract.locationId = n.getGuidValue(); },
        "mandateRevokedDate": n => { contract.mandateRevokedDate = n.getDateOnlyValue(); },
        "mandateSignedBy": n => { contract.mandateSignedBy = n.getStringValue(); },
        "mandateSignedDate": n => { contract.mandateSignedDate = n.getDateOnlyValue(); },
        "nextContractId": n => { contract.nextContractId = n.getGuidValue(); },
        "openItems": n => { contract.openItems = n.getCollectionOfObjectValues<ContractComplianceItem>(createContractComplianceItemFromDiscriminatorValue); },
        "previousContractId": n => { contract.previousContractId = n.getGuidValue(); },
        "validFrom": n => { contract.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { contract.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractAffiliateCondition The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractAffiliateCondition(contractAffiliateCondition: Partial<ContractAffiliateCondition> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { contractAffiliateCondition.affiliateCode = n.getStringValue(); },
        "discountPercentage": n => { contractAffiliateCondition.discountPercentage = n.getNumberValue(); },
        "kickbackPercentage": n => { contractAffiliateCondition.kickbackPercentage = n.getNumberValue(); },
        "name": n => { contractAffiliateCondition.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractAffiliateCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractAffiliateCount(contractAffiliateCount: Partial<ContractAffiliateCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliates": n => { contractAffiliateCount.affiliates = n.getCollectionOfObjectValues<AffiliateContractCount>(createAffiliateContractCountFromDiscriminatorValue); },
        "contracts": n => { contractAffiliateCount.contracts = n.getNumberValue(); },
        "date": n => { contractAffiliateCount.date = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractComplianceItem The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractComplianceItem(contractComplianceItem: Partial<ContractComplianceItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "actor": n => { contractComplianceItem.actor = n.getEnumValue<ComplianceActor>(ComplianceActorObject); },
        "item": n => { contractComplianceItem.item = n.getEnumValue<ComplianceItem>(ComplianceItemObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractConsumptionWithProjection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractConsumptionWithProjection(contractConsumptionWithProjection: Partial<ContractConsumptionWithProjection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { contractConsumptionWithProjection.consumption = n.getNumberValue(); },
        "expectedConsumption": n => { contractConsumptionWithProjection.expectedConsumption = n.getNumberValue(); },
        "expectedPayoutAmount": n => { contractConsumptionWithProjection.expectedPayoutAmount = n.getNumberValue(); },
        "expectedUnits": n => { contractConsumptionWithProjection.expectedUnits = n.getNumberValue(); },
        "expectedYield": n => { contractConsumptionWithProjection.expectedYield = n.getNumberValue(); },
        "id": n => { contractConsumptionWithProjection.id = n.getGuidValue(); },
        "payoutAmount": n => { contractConsumptionWithProjection.payoutAmount = n.getNumberValue(); },
        "periodFrom": n => { contractConsumptionWithProjection.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { contractConsumptionWithProjection.periodTo = n.getDateOnlyValue(); },
        "projectionDate": n => { contractConsumptionWithProjection.projectionDate = n.getDateOnlyValue(); },
        "registeredConsumption": n => { contractConsumptionWithProjection.registeredConsumption = n.getNumberValue(); },
        "registeredPayoutAmount": n => { contractConsumptionWithProjection.registeredPayoutAmount = n.getNumberValue(); },
        "registeredTo": n => { contractConsumptionWithProjection.registeredTo = n.getDateOnlyValue(); },
        "registeredUnits": n => { contractConsumptionWithProjection.registeredUnits = n.getNumberValue(); },
        "registeredYield": n => { contractConsumptionWithProjection.registeredYield = n.getNumberValue(); },
        "units": n => { contractConsumptionWithProjection.units = n.getNumberValue(); },
        "yield": n => { contractConsumptionWithProjection.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractEligibility The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractEligibility(contractEligibility: Partial<ContractEligibility> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "eligibleForPayout": n => { contractEligibility.eligibleForPayout = n.getNumberValue(); },
        "eligibleForRegistration": n => { contractEligibility.eligibleForRegistration = n.getNumberValue(); },
        "eligibleForTransaction": n => { contractEligibility.eligibleForTransaction = n.getNumberValue(); },
        "notEligible": n => { contractEligibility.notEligible = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractListItem The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractListItem(contractListItem: Partial<ContractListItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { contractListItem.address = n.getStringValue(); },
        "chargePointCount": n => { contractListItem.chargePointCount = n.getNumberValue(); },
        "complianceStatus": n => { contractListItem.complianceStatus = n.getEnumValue<ComplianceStatus>(ComplianceStatusObject); },
        "contractReference": n => { contractListItem.contractReference = n.getStringValue(); },
        "customer": n => { contractListItem.customer = n.getObjectValue<ContractListItemCustomer>(createContractListItemCustomerFromDiscriminatorValue); },
        "eanCode": n => { contractListItem.eanCode = n.getStringValue(); },
        "id": n => { contractListItem.id = n.getGuidValue(); },
        "locationId": n => { contractListItem.locationId = n.getGuidValue(); },
        "openItems": n => { contractListItem.openItems = n.getCollectionOfObjectValues<ContractComplianceItem>(createContractComplianceItemFromDiscriminatorValue); },
        "validFrom": n => { contractListItem.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { contractListItem.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractListItemCustomer The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractListItemCustomer(contractListItemCustomer: Partial<ContractListItemCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerReference": n => { contractListItemCustomer.customerReference = n.getStringValue(); },
        "customerType": n => { contractListItemCustomer.customerType = n.getEnumValue<CustomerType>(CustomerTypeObject); },
        "id": n => { contractListItemCustomer.id = n.getGuidValue(); },
        "name": n => { contractListItemCustomer.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractOverview The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractOverview(contractOverview: Partial<ContractOverview> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "commission": n => { contractOverview.commission = n.getNumberValue(); },
        "consumption": n => { contractOverview.consumption = n.getNumberValue(); },
        "costs": n => { contractOverview.costs = n.getNumberValue(); },
        "payoutAmount": n => { contractOverview.payoutAmount = n.getNumberValue(); },
        "periodFrom": n => { contractOverview.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { contractOverview.periodTo = n.getDateOnlyValue(); },
        "registrationId": n => { contractOverview.registrationId = n.getGuidValue(); },
        "registrationReference": n => { contractOverview.registrationReference = n.getStringValue(); },
        "status": n => { contractOverview.status = n.getEnumValue<ContractOverviewStatus>(ContractOverviewStatusObject); },
        "units": n => { contractOverview.units = n.getNumberValue(); },
        "yield": n => { contractOverview.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractsCreatedInPeriod The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractsCreatedInPeriod(contractsCreatedInPeriod: Partial<ContractsCreatedInPeriod> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractsCreated": n => { contractsCreatedInPeriod.contractsCreated = n.getNumberValue(); },
        "periodStart": n => { contractsCreatedInPeriod.periodStart = n.getDateOnlyValue(); },
        "toDate": n => { contractsCreatedInPeriod.toDate = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractsToDate The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractsToDate(contractsToDate: Partial<ContractsToDate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "current": n => { contractsToDate.current = n.getNumberValue(); },
        "last30Days": n => { contractsToDate.last30Days = n.getNumberValue(); },
        "last7Days": n => { contractsToDate.last7Days = n.getNumberValue(); },
        "today": n => { contractsToDate.today = n.getNumberValue(); },
        "total": n => { contractsToDate.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractsToDateHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractsToDateHistory(contractsToDateHistory: Partial<ContractsToDateHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { contractsToDateHistory.from = n.getDateOnlyValue(); },
        "granularity": n => { contractsToDateHistory.granularity = n.getEnumValue<ActivityGranularity>(ActivityGranularityObject); },
        "points": n => { contractsToDateHistory.points = n.getCollectionOfObjectValues<ContractsCreatedInPeriod>(createContractsCreatedInPeriodFromDiscriminatorValue); },
        "to": n => { contractsToDateHistory.to = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractSummary(contractSummary: Partial<ContractSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCondition": n => { contractSummary.affiliateCondition = n.getObjectValue<ContractSummaryAffiliateCondition>(createContractSummaryAffiliateConditionFromDiscriminatorValue); },
        "chargePointCount": n => { contractSummary.chargePointCount = n.getNumberValue(); },
        "complianceStatus": n => { contractSummary.complianceStatus = n.getEnumValue<ComplianceStatus>(ComplianceStatusObject); },
        "contractReference": n => { contractSummary.contractReference = n.getStringValue(); },
        "createdBy": n => { contractSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { contractSummary.createdDate = n.getDateValue(); },
        "customer": n => { contractSummary.customer = n.getObjectValue<ContractSummaryCustomer>(createContractSummaryCustomerFromDiscriminatorValue); },
        "id": n => { contractSummary.id = n.getGuidValue(); },
        "isEligibleForPayout": n => { contractSummary.isEligibleForPayout = n.getBooleanValue(); },
        "isEligibleForRegistration": n => { contractSummary.isEligibleForRegistration = n.getBooleanValue(); },
        "isEligibleForTransaction": n => { contractSummary.isEligibleForTransaction = n.getBooleanValue(); },
        "lastModifiedBy": n => { contractSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { contractSummary.lastModifiedDate = n.getDateValue(); },
        "locationId": n => { contractSummary.locationId = n.getGuidValue(); },
        "openItems": n => { contractSummary.openItems = n.getCollectionOfObjectValues<ContractComplianceItem>(createContractComplianceItemFromDiscriminatorValue); },
        "validFrom": n => { contractSummary.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { contractSummary.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractSummaryAffiliateCondition The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractSummaryAffiliateCondition(contractSummaryAffiliateCondition: Partial<ContractSummaryAffiliateCondition> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { contractSummaryAffiliateCondition.affiliateCode = n.getStringValue(); },
        "discountPercentage": n => { contractSummaryAffiliateCondition.discountPercentage = n.getNumberValue(); },
        "kickbackPercentage": n => { contractSummaryAffiliateCondition.kickbackPercentage = n.getNumberValue(); },
        "name": n => { contractSummaryAffiliateCondition.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ContractSummaryCustomer The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoContractSummaryCustomer(contractSummaryCustomer: Partial<ContractSummaryCustomer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerReference": n => { contractSummaryCustomer.customerReference = n.getStringValue(); },
        "externalCustomerId": n => { contractSummaryCustomer.externalCustomerId = n.getStringValue(); },
        "id": n => { contractSummaryCustomer.id = n.getGuidValue(); },
        "name": n => { contractSummaryCustomer.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConversionFactor The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConversionFactor(conversionFactor: Partial<ConversionFactor> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdBy": n => { conversionFactor.createdBy = n.getStringValue(); },
        "createdDate": n => { conversionFactor.createdDate = n.getDateValue(); },
        "expectedErePrice": n => { conversionFactor.expectedErePrice = n.getNumberValue(); },
        "id": n => { conversionFactor.id = n.getGuidValue(); },
        "lastModifiedBy": n => { conversionFactor.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { conversionFactor.lastModifiedDate = n.getDateValue(); },
        "netConsumptionFactor": n => { conversionFactor.netConsumptionFactor = n.getNumberValue(); },
        "renewableConsumptionFactor": n => { conversionFactor.renewableConsumptionFactor = n.getNumberValue(); },
        "year": n => { conversionFactor.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConversionFactorSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConversionFactorSummary(conversionFactorSummary: Partial<ConversionFactorSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdBy": n => { conversionFactorSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { conversionFactorSummary.createdDate = n.getDateValue(); },
        "expectedErePrice": n => { conversionFactorSummary.expectedErePrice = n.getNumberValue(); },
        "id": n => { conversionFactorSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { conversionFactorSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { conversionFactorSummary.lastModifiedDate = n.getDateValue(); },
        "netConsumptionFactor": n => { conversionFactorSummary.netConsumptionFactor = n.getNumberValue(); },
        "renewableConsumptionFactor": n => { conversionFactorSummary.renewableConsumptionFactor = n.getNumberValue(); },
        "year": n => { conversionFactorSummary.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConvertCustomerToBusinessCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConvertCustomerToBusinessCommand(convertCustomerToBusinessCommand: Partial<ConvertCustomerToBusinessCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { convertCustomerToBusinessCommand.affiliateId = n.getGuidValue(); },
        "companyName": n => { convertCustomerToBusinessCommand.companyName = n.getStringValue(); },
        "companyRegistrationNumber": n => { convertCustomerToBusinessCommand.companyRegistrationNumber = n.getStringValue(); },
        "customerId": n => { convertCustomerToBusinessCommand.customerId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ConvertCustomerToConsumerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoConvertCustomerToConsumerCommand(convertCustomerToConsumerCommand: Partial<ConvertCustomerToConsumerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { convertCustomerToConsumerCommand.affiliateId = n.getGuidValue(); },
        "customerId": n => { convertCustomerToConsumerCommand.customerId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateAccountCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateAccountCommand(createAccountCommand: Partial<CreateAccountCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountNumber": n => { createAccountCommand.accountNumber = n.getStringValue(); },
        "initialBalance": n => { createAccountCommand.initialBalance = n.getNumberValue(); },
        "ledgerId": n => { createAccountCommand.ledgerId = n.getGuidValue(); },
        "name": n => { createAccountCommand.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateAffiliateCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateAffiliateCommand(createAffiliateCommand: Partial<CreateAffiliateCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { createAffiliateCommand.affiliateCode = n.getStringValue(); },
        "businessCondition": n => { createAffiliateCommand.businessCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "consumerCondition": n => { createAffiliateCommand.consumerCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "name": n => { createAffiliateCommand.name = n.getStringValue(); },
        "notes": n => { createAffiliateCommand.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateBusinessCustomerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateBusinessCustomerCommand(createBusinessCustomerCommand: Partial<CreateBusinessCustomerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { createBusinessCustomerCommand.affiliateId = n.getGuidValue(); },
        "companyRegistration": n => { createBusinessCustomerCommand.companyRegistration = n.getObjectValue<SignupCompanyRegistration>(createSignupCompanyRegistrationFromDiscriminatorValue); },
        "contact": n => { createBusinessCustomerCommand.contact = n.getObjectValue<SignupContact>(createSignupContactFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateBusinessCustomerResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateBusinessCustomerResult(createBusinessCustomerResult: Partial<CreateBusinessCustomerResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { createBusinessCustomerResult.customerId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateBusinessCustomerWithContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateBusinessCustomerWithContractCommand(createBusinessCustomerWithContractCommand: Partial<CreateBusinessCustomerWithContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { createBusinessCustomerWithContractCommand.address = n.getObjectValue<SignupAddress>(createSignupAddressFromDiscriminatorValue); },
        "affiliateId": n => { createBusinessCustomerWithContractCommand.affiliateId = n.getGuidValue(); },
        "bankAccount": n => { createBusinessCustomerWithContractCommand.bankAccount = n.getObjectValue<SignupBankAccount>(createSignupBankAccountFromDiscriminatorValue); },
        "chargePoints": n => { createBusinessCustomerWithContractCommand.chargePoints = n.getCollectionOfObjectValues<SignupChargePoint>(createSignupChargePointFromDiscriminatorValue); },
        "companyRegistration": n => { createBusinessCustomerWithContractCommand.companyRegistration = n.getObjectValue<SignupCompanyRegistration>(createSignupCompanyRegistrationFromDiscriminatorValue); },
        "contact": n => { createBusinessCustomerWithContractCommand.contact = n.getObjectValue<SignupContact>(createSignupContactFromDiscriminatorValue); },
        "validFrom": n => { createBusinessCustomerWithContractCommand.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { createBusinessCustomerWithContractCommand.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateBusinessCustomerWithContractResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateBusinessCustomerWithContractResult(createBusinessCustomerWithContractResult: Partial<CreateBusinessCustomerWithContractResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointIds": n => { createBusinessCustomerWithContractResult.chargePointIds = n.getCollectionOfPrimitiveValues<Guid>("string"); },
        "contractId": n => { createBusinessCustomerWithContractResult.contractId = n.getGuidValue(); },
        "customerId": n => { createBusinessCustomerWithContractResult.customerId = n.getGuidValue(); },
        "locationId": n => { createBusinessCustomerWithContractResult.locationId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateChargePointCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateChargePointCommand(createChargePointCommand: Partial<CreateChargePointCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { createChargePointCommand.deviceId = n.getStringValue(); },
        "locationId": n => { createChargePointCommand.locationId = n.getGuidValue(); },
        "make": n => { createChargePointCommand.make = n.getStringValue(); },
        "midMeter": n => { createChargePointCommand.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { createChargePointCommand.model = n.getStringValue(); },
        "name": n => { createChargePointCommand.name = n.getStringValue(); },
        "skipVerification": n => { createChargePointCommand.skipVerification = n.getBooleanValue(); },
        "verified": n => { createChargePointCommand.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateChargerDefinitionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateChargerDefinitionCommand(createChargerDefinitionCommand: Partial<CreateChargerDefinitionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargeType": n => { createChargerDefinitionCommand.chargeType = n.getEnumValue<ChargeType>(ChargeTypeObject); },
        "datasheetUrl": n => { createChargerDefinitionCommand.datasheetUrl = n.getStringValue(); },
        "make": n => { createChargerDefinitionCommand.make = n.getStringValue(); },
        "meterMake": n => { createChargerDefinitionCommand.meterMake = n.getStringValue(); },
        "meterModel": n => { createChargerDefinitionCommand.meterModel = n.getStringValue(); },
        "midMeter": n => { createChargerDefinitionCommand.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { createChargerDefinitionCommand.model = n.getStringValue(); },
        "notes": n => { createChargerDefinitionCommand.notes = n.getStringValue(); },
        "source": n => { createChargerDefinitionCommand.source = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateConsumerCustomerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateConsumerCustomerCommand(createConsumerCustomerCommand: Partial<CreateConsumerCustomerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { createConsumerCustomerCommand.affiliateId = n.getGuidValue(); },
        "contact": n => { createConsumerCustomerCommand.contact = n.getObjectValue<SignupContact>(createSignupContactFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateConsumerCustomerResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateConsumerCustomerResult(createConsumerCustomerResult: Partial<CreateConsumerCustomerResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { createConsumerCustomerResult.customerId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateConsumerCustomerWithContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateConsumerCustomerWithContractCommand(createConsumerCustomerWithContractCommand: Partial<CreateConsumerCustomerWithContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { createConsumerCustomerWithContractCommand.address = n.getObjectValue<SignupAddress>(createSignupAddressFromDiscriminatorValue); },
        "affiliateId": n => { createConsumerCustomerWithContractCommand.affiliateId = n.getGuidValue(); },
        "bankAccount": n => { createConsumerCustomerWithContractCommand.bankAccount = n.getObjectValue<SignupBankAccount>(createSignupBankAccountFromDiscriminatorValue); },
        "chargePoints": n => { createConsumerCustomerWithContractCommand.chargePoints = n.getCollectionOfObjectValues<SignupChargePoint>(createSignupChargePointFromDiscriminatorValue); },
        "contact": n => { createConsumerCustomerWithContractCommand.contact = n.getObjectValue<SignupContact>(createSignupContactFromDiscriminatorValue); },
        "validFrom": n => { createConsumerCustomerWithContractCommand.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { createConsumerCustomerWithContractCommand.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateConsumerCustomerWithContractResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateConsumerCustomerWithContractResult(createConsumerCustomerWithContractResult: Partial<CreateConsumerCustomerWithContractResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointIds": n => { createConsumerCustomerWithContractResult.chargePointIds = n.getCollectionOfPrimitiveValues<Guid>("string"); },
        "contractId": n => { createConsumerCustomerWithContractResult.contractId = n.getGuidValue(); },
        "customerId": n => { createConsumerCustomerWithContractResult.customerId = n.getGuidValue(); },
        "locationId": n => { createConsumerCustomerWithContractResult.locationId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateContractCommand(createContractCommand: Partial<CreateContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "locationId": n => { createContractCommand.locationId = n.getGuidValue(); },
        "validFrom": n => { createContractCommand.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { createContractCommand.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateConversionFactorCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateConversionFactorCommand(createConversionFactorCommand: Partial<CreateConversionFactorCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expectedErePrice": n => { createConversionFactorCommand.expectedErePrice = n.getNumberValue(); },
        "netConsumptionFactor": n => { createConversionFactorCommand.netConsumptionFactor = n.getNumberValue(); },
        "renewableConsumptionFactor": n => { createConversionFactorCommand.renewableConsumptionFactor = n.getNumberValue(); },
        "year": n => { createConversionFactorCommand.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateLedgerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateLedgerCommand(createLedgerCommand: Partial<CreateLedgerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "currency": n => { createLedgerCommand.currency = n.getEnumValue<CurrencyType>(CurrencyTypeObject); },
        "name": n => { createLedgerCommand.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateLocationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateLocationCommand(createLocationCommand: Partial<CreateLocationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectionType": n => { createLocationCommand.connectionType = n.getEnumValue<ConnectionType>(ConnectionTypeObject); },
        "customerId": n => { createLocationCommand.customerId = n.getGuidValue(); },
        "meteringPointCity": n => { createLocationCommand.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { createLocationCommand.meteringPointEanCode = n.getStringValue(); },
        "meteringPointGridOperator": n => { createLocationCommand.meteringPointGridOperator = n.getStringValue(); },
        "meteringPointGridOperatorEanCode": n => { createLocationCommand.meteringPointGridOperatorEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { createLocationCommand.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { createLocationCommand.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { createLocationCommand.meteringPointStreet = n.getStringValue(); },
        "meteringPointVerified": n => { createLocationCommand.meteringPointVerified = n.getBooleanValue(); },
        "name": n => { createLocationCommand.name = n.getStringValue(); },
        "skipMeteringPointVerification": n => { createLocationCommand.skipMeteringPointVerification = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateLocationResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateLocationResult(createLocationResult: Partial<CreateLocationResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractId": n => { createLocationResult.contractId = n.getGuidValue(); },
        "locationId": n => { createLocationResult.locationId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreatePayoutCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreatePayoutCommand(createPayoutCommand: Partial<CreatePayoutCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "notes": n => { createPayoutCommand.notes = n.getStringValue(); },
        "payoutDate": n => { createPayoutCommand.payoutDate = n.getDateOnlyValue(); },
        "payoutPercentage": n => { createPayoutCommand.payoutPercentage = n.getNumberValue(); },
        "transactionId": n => { createPayoutCommand.transactionId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateRegistrationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateRegistrationCommand(createRegistrationCommand: Partial<CreateRegistrationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "notes": n => { createRegistrationCommand.notes = n.getStringValue(); },
        "periodFrom": n => { createRegistrationCommand.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { createRegistrationCommand.periodTo = n.getDateOnlyValue(); },
        "registrationDate": n => { createRegistrationCommand.registrationDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateTransactionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateTransactionCommand(createTransactionCommand: Partial<CreateTransactionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "costPercentage": n => { createTransactionCommand.costPercentage = n.getNumberValue(); },
        "notes": n => { createTransactionCommand.notes = n.getStringValue(); },
        "pricePerUnit": n => { createTransactionCommand.pricePerUnit = n.getNumberValue(); },
        "registrationId": n => { createTransactionCommand.registrationId = n.getGuidValue(); },
        "transactionDate": n => { createTransactionCommand.transactionDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CurrentUser The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCurrentUser(currentUser: Partial<CurrentUser> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "apiBuildNumber": n => { currentUser.apiBuildNumber = n.getStringValue(); },
        "connectAppUrl": n => { currentUser.connectAppUrl = n.getStringValue(); },
        "email": n => { currentUser.email = n.getStringValue(); },
        "environment": n => { currentUser.environment = n.getStringValue(); },
        "id": n => { currentUser.id = n.getStringValue(); },
        "initials": n => { currentUser.initials = n.getStringValue(); },
        "name": n => { currentUser.name = n.getStringValue(); },
        "permissions": n => { currentUser.permissions = n.getCollectionOfPrimitiveValues<string>("string"); },
        "roles": n => { currentUser.roles = n.getCollectionOfPrimitiveValues<string>("string"); },
        "scopes": n => { currentUser.scopes = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param Customer The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomer(customer: Partial<Customer> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { customer.address = n.getObjectValue<CustomerAddress>(createCustomerAddressFromDiscriminatorValue); },
        "affiliateCode": n => { customer.affiliateCode = n.getStringValue(); },
        "affiliateId": n => { customer.affiliateId = n.getGuidValue(); },
        "bankAccount": n => { customer.bankAccount = n.getObjectValue<CustomerBankAccount>(createCustomerBankAccountFromDiscriminatorValue); },
        "companyRegistration": n => { customer.companyRegistration = n.getObjectValue<CustomerCompanyRegistration>(createCustomerCompanyRegistrationFromDiscriminatorValue); },
        "contact": n => { customer.contact = n.getObjectValue<CustomerContact>(createCustomerContactFromDiscriminatorValue); },
        "createdBy": n => { customer.createdBy = n.getStringValue(); },
        "createdDate": n => { customer.createdDate = n.getDateValue(); },
        "customerReference": n => { customer.customerReference = n.getStringValue(); },
        "customerType": n => { customer.customerType = n.getEnumValue<CustomerType>(CustomerTypeObject); },
        "externalCustomerId": n => { customer.externalCustomerId = n.getStringValue(); },
        "id": n => { customer.id = n.getGuidValue(); },
        "lastModifiedBy": n => { customer.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { customer.lastModifiedDate = n.getDateValue(); },
        "lastSeenAt": n => { customer.lastSeenAt = n.getDateValue(); },
        "legacyCompliancyStatus": n => { customer.legacyCompliancyStatus = n.getEnumValue<LegacyCompliancyStatus>(LegacyCompliancyStatusObject); },
        "name": n => { customer.name = n.getStringValue(); },
        "notes": n => { customer.notes = n.getStringValue(); },
        "tags": n => { customer.tags = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerActivity The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerActivity(customerActivity: Partial<CustomerActivity> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "last30Days": n => { customerActivity.last30Days = n.getNumberValue(); },
        "last7Days": n => { customerActivity.last7Days = n.getNumberValue(); },
        "never": n => { customerActivity.never = n.getNumberValue(); },
        "onlineNow": n => { customerActivity.onlineNow = n.getNumberValue(); },
        "today": n => { customerActivity.today = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerActivityHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerActivityHistory(customerActivityHistory: Partial<CustomerActivityHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { customerActivityHistory.from = n.getDateOnlyValue(); },
        "granularity": n => { customerActivityHistory.granularity = n.getEnumValue<ActivityGranularity>(ActivityGranularityObject); },
        "points": n => { customerActivityHistory.points = n.getCollectionOfObjectValues<ActiveCustomersInPeriod>(createActiveCustomersInPeriodFromDiscriminatorValue); },
        "to": n => { customerActivityHistory.to = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerAddress The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerAddress(customerAddress: Partial<CustomerAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addressType": n => { customerAddress.addressType = n.getEnumValue<AddressType>(AddressTypeObject); },
        "city": n => { customerAddress.city = n.getStringValue(); },
        "houseNumber": n => { customerAddress.houseNumber = n.getStringValue(); },
        "postcode": n => { customerAddress.postcode = n.getStringValue(); },
        "street": n => { customerAddress.street = n.getStringValue(); },
        "verificationStatus": n => { customerAddress.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerBankAccount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerBankAccount(customerBankAccount: Partial<CustomerBankAccount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountHolder": n => { customerBankAccount.accountHolder = n.getStringValue(); },
        "accountNumber": n => { customerBankAccount.accountNumber = n.getStringValue(); },
        "bankName": n => { customerBankAccount.bankName = n.getStringValue(); },
        "bic": n => { customerBankAccount.bic = n.getStringValue(); },
        "verificationStatus": n => { customerBankAccount.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerCompanyRegistration The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerCompanyRegistration(customerCompanyRegistration: Partial<CustomerCompanyRegistration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "officeNumber": n => { customerCompanyRegistration.officeNumber = n.getStringValue(); },
        "officeType": n => { customerCompanyRegistration.officeType = n.getEnumValue<OfficeType>(OfficeTypeObject); },
        "registrationName": n => { customerCompanyRegistration.registrationName = n.getStringValue(); },
        "registrationNumber": n => { customerCompanyRegistration.registrationNumber = n.getStringValue(); },
        "verificationStatus": n => { customerCompanyRegistration.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerConsumptionWithProjection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerConsumptionWithProjection(customerConsumptionWithProjection: Partial<CustomerConsumptionWithProjection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { customerConsumptionWithProjection.consumption = n.getNumberValue(); },
        "contractCount": n => { customerConsumptionWithProjection.contractCount = n.getNumberValue(); },
        "customerId": n => { customerConsumptionWithProjection.customerId = n.getGuidValue(); },
        "expectedConsumption": n => { customerConsumptionWithProjection.expectedConsumption = n.getNumberValue(); },
        "expectedPayoutAmount": n => { customerConsumptionWithProjection.expectedPayoutAmount = n.getNumberValue(); },
        "expectedUnits": n => { customerConsumptionWithProjection.expectedUnits = n.getNumberValue(); },
        "expectedYield": n => { customerConsumptionWithProjection.expectedYield = n.getNumberValue(); },
        "id": n => { customerConsumptionWithProjection.id = n.getGuidValue(); },
        "payoutAmount": n => { customerConsumptionWithProjection.payoutAmount = n.getNumberValue(); },
        "periodFrom": n => { customerConsumptionWithProjection.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { customerConsumptionWithProjection.periodTo = n.getDateOnlyValue(); },
        "projectionDate": n => { customerConsumptionWithProjection.projectionDate = n.getDateOnlyValue(); },
        "registeredConsumption": n => { customerConsumptionWithProjection.registeredConsumption = n.getNumberValue(); },
        "registeredPayoutAmount": n => { customerConsumptionWithProjection.registeredPayoutAmount = n.getNumberValue(); },
        "registeredTo": n => { customerConsumptionWithProjection.registeredTo = n.getDateOnlyValue(); },
        "registeredUnits": n => { customerConsumptionWithProjection.registeredUnits = n.getNumberValue(); },
        "registeredYield": n => { customerConsumptionWithProjection.registeredYield = n.getNumberValue(); },
        "units": n => { customerConsumptionWithProjection.units = n.getNumberValue(); },
        "yield": n => { customerConsumptionWithProjection.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerContact The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerContact(customerContact: Partial<CustomerContact> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { customerContact.email = n.getStringValue(); },
        "firstName": n => { customerContact.firstName = n.getStringValue(); },
        "lastName": n => { customerContact.lastName = n.getStringValue(); },
        "name": n => { customerContact.name = n.getStringValue(); },
        "phone": n => { customerContact.phone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerOAuthConnection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerOAuthConnection(customerOAuthConnection: Partial<CustomerOAuthConnection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargers": n => { customerOAuthConnection.chargers = n.getCollectionOfObjectValues<OAuthConnectionCharger>(createOAuthConnectionChargerFromDiscriminatorValue); },
        "connectedDate": n => { customerOAuthConnection.connectedDate = n.getDateValue(); },
        "id": n => { customerOAuthConnection.id = n.getGuidValue(); },
        "isAuthorizationExpired": n => { customerOAuthConnection.isAuthorizationExpired = n.getBooleanValue(); },
        "isRemovable": n => { customerOAuthConnection.isRemovable = n.getBooleanValue(); },
        "provider": n => { customerOAuthConnection.provider = n.getEnumValue<OAuthProviderType>(OAuthProviderTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomersCreatedInPeriod The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomersCreatedInPeriod(customersCreatedInPeriod: Partial<CustomersCreatedInPeriod> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customersCreated": n => { customersCreatedInPeriod.customersCreated = n.getNumberValue(); },
        "periodStart": n => { customersCreatedInPeriod.periodStart = n.getDateOnlyValue(); },
        "toDate": n => { customersCreatedInPeriod.toDate = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomersToDate The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomersToDate(customersToDate: Partial<CustomersToDate> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "last30Days": n => { customersToDate.last30Days = n.getNumberValue(); },
        "last7Days": n => { customersToDate.last7Days = n.getNumberValue(); },
        "today": n => { customersToDate.today = n.getNumberValue(); },
        "total": n => { customersToDate.total = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomersToDateHistory The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomersToDateHistory(customersToDateHistory: Partial<CustomersToDateHistory> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "from": n => { customersToDateHistory.from = n.getDateOnlyValue(); },
        "granularity": n => { customersToDateHistory.granularity = n.getEnumValue<ActivityGranularity>(ActivityGranularityObject); },
        "points": n => { customersToDateHistory.points = n.getCollectionOfObjectValues<CustomersCreatedInPeriod>(createCustomersCreatedInPeriodFromDiscriminatorValue); },
        "to": n => { customersToDateHistory.to = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummary(customerSummary: Partial<CustomerSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { customerSummary.address = n.getObjectValue<CustomerSummaryAddress>(createCustomerSummaryAddressFromDiscriminatorValue); },
        "affiliateCodes": n => { customerSummary.affiliateCodes = n.getCollectionOfPrimitiveValues<string>("string"); },
        "chargers": n => { customerSummary.chargers = n.getCollectionOfObjectValues<CustomerSummaryCharger>(createCustomerSummaryChargerFromDiscriminatorValue); },
        "companyRegistration": n => { customerSummary.companyRegistration = n.getObjectValue<CustomerSummaryCompanyRegistration>(createCustomerSummaryCompanyRegistrationFromDiscriminatorValue); },
        "contact": n => { customerSummary.contact = n.getObjectValue<CustomerSummaryContact>(createCustomerSummaryContactFromDiscriminatorValue); },
        "contractCount": n => { customerSummary.contractCount = n.getNumberValue(); },
        "createdBy": n => { customerSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { customerSummary.createdDate = n.getDateValue(); },
        "currentContract": n => { customerSummary.currentContract = n.getObjectValue<CustomerSummaryCurrentContract>(createCustomerSummaryCurrentContractFromDiscriminatorValue); },
        "currentContractCount": n => { customerSummary.currentContractCount = n.getNumberValue(); },
        "customerReference": n => { customerSummary.customerReference = n.getStringValue(); },
        "customerType": n => { customerSummary.customerType = n.getEnumValue<CustomerType>(CustomerTypeObject); },
        "externalCustomerId": n => { customerSummary.externalCustomerId = n.getStringValue(); },
        "id": n => { customerSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { customerSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { customerSummary.lastModifiedDate = n.getDateValue(); },
        "lastSeenAt": n => { customerSummary.lastSeenAt = n.getDateValue(); },
        "locationCount": n => { customerSummary.locationCount = n.getNumberValue(); },
        "name": n => { customerSummary.name = n.getStringValue(); },
        "tags": n => { customerSummary.tags = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummaryAddress The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummaryAddress(customerSummaryAddress: Partial<CustomerSummaryAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addressType": n => { customerSummaryAddress.addressType = n.getEnumValue<AddressType>(AddressTypeObject); },
        "city": n => { customerSummaryAddress.city = n.getStringValue(); },
        "houseNumber": n => { customerSummaryAddress.houseNumber = n.getStringValue(); },
        "postcode": n => { customerSummaryAddress.postcode = n.getStringValue(); },
        "street": n => { customerSummaryAddress.street = n.getStringValue(); },
        "verificationStatus": n => { customerSummaryAddress.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummaryCharger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummaryCharger(customerSummaryCharger: Partial<CustomerSummaryCharger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { customerSummaryCharger.deviceId = n.getStringValue(); },
        "make": n => { customerSummaryCharger.make = n.getStringValue(); },
        "midMeter": n => { customerSummaryCharger.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { customerSummaryCharger.model = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummaryCompanyRegistration The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummaryCompanyRegistration(customerSummaryCompanyRegistration: Partial<CustomerSummaryCompanyRegistration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "officeNumber": n => { customerSummaryCompanyRegistration.officeNumber = n.getStringValue(); },
        "officeType": n => { customerSummaryCompanyRegistration.officeType = n.getEnumValue<OfficeType>(OfficeTypeObject); },
        "registrationName": n => { customerSummaryCompanyRegistration.registrationName = n.getStringValue(); },
        "registrationNumber": n => { customerSummaryCompanyRegistration.registrationNumber = n.getStringValue(); },
        "verificationStatus": n => { customerSummaryCompanyRegistration.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummaryContact The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummaryContact(customerSummaryContact: Partial<CustomerSummaryContact> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { customerSummaryContact.email = n.getStringValue(); },
        "name": n => { customerSummaryContact.name = n.getStringValue(); },
        "phoneNumber": n => { customerSummaryContact.phoneNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerSummaryCurrentContract The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerSummaryCurrentContract(customerSummaryCurrentContract: Partial<CustomerSummaryCurrentContract> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractReference": n => { customerSummaryCurrentContract.contractReference = n.getStringValue(); },
        "id": n => { customerSummaryCurrentContract.id = n.getGuidValue(); },
        "isEligibleForPayout": n => { customerSummaryCurrentContract.isEligibleForPayout = n.getBooleanValue(); },
        "isEligibleForRegistration": n => { customerSummaryCurrentContract.isEligibleForRegistration = n.getBooleanValue(); },
        "isEligibleForTransaction": n => { customerSummaryCurrentContract.isEligibleForTransaction = n.getBooleanValue(); },
        "validFrom": n => { customerSummaryCurrentContract.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { customerSummaryCurrentContract.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CustomerTagCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCustomerTagCount(customerTagCount: Partial<CustomerTagCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { customerTagCount.customers = n.getNumberValue(); },
        "groups": n => { customerTagCount.groups = n.getCollectionOfObjectValues<TagNamespaceCount>(createTagNamespaceCountFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param DataSharingGrantSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDataSharingGrantSummary(dataSharingGrantSummary: Partial<DataSharingGrantSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "applicationName": n => { dataSharingGrantSummary.applicationName = n.getStringValue(); },
        "clientId": n => { dataSharingGrantSummary.clientId = n.getStringValue(); },
        "customerId": n => { dataSharingGrantSummary.customerId = n.getGuidValue(); },
        "grantedAt": n => { dataSharingGrantSummary.grantedAt = n.getDateValue(); },
        "id": n => { dataSharingGrantSummary.id = n.getGuidValue(); },
        "isActive": n => { dataSharingGrantSummary.isActive = n.getBooleanValue(); },
        "lastModifiedBy": n => { dataSharingGrantSummary.lastModifiedBy = n.getStringValue(); },
        "revokedAt": n => { dataSharingGrantSummary.revokedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DocumentChargePoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentChargePoint(documentChargePoint: Partial<DocumentChargePoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { documentChargePoint.id = n.getGuidValue(); },
        "name": n => { documentChargePoint.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DocumentRejectionReasons The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentRejectionReasons(documentRejectionReasons: Partial<DocumentRejectionReasons> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "reasons": n => { documentRejectionReasons.reasons = n.getCollectionOfEnumValues<RejectionReason>(RejectionReasonObject); },
        "type": n => { documentRejectionReasons.type = n.getEnumValue<ContractDocumentType>(ContractDocumentTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param DocumentReview The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentReview(documentReview: Partial<DocumentReview> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalStatus": n => { documentReview.approvalStatus = n.getEnumValue<ApprovalStatus>(ApprovalStatusObject); },
        "reviewedBy": n => { documentReview.reviewedBy = n.getStringValue(); },
        "reviewedDate": n => { documentReview.reviewedDate = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DocumentSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDocumentSummary(documentSummary: Partial<DocumentSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "approvalStatus": n => { documentSummary.approvalStatus = n.getEnumValue<ApprovalStatus>(ApprovalStatusObject); },
        "chargePointId": n => { documentSummary.chargePointId = n.getGuidValue(); },
        "chargePoints": n => { documentSummary.chargePoints = n.getCollectionOfObjectValues<DocumentChargePoint>(createDocumentChargePointFromDiscriminatorValue); },
        "contentType": n => { documentSummary.contentType = n.getStringValue(); },
        "contractId": n => { documentSummary.contractId = n.getGuidValue(); },
        "contractReference": n => { documentSummary.contractReference = n.getStringValue(); },
        "createdBy": n => { documentSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { documentSummary.createdDate = n.getDateValue(); },
        "customerId": n => { documentSummary.customerId = n.getGuidValue(); },
        "fileName": n => { documentSummary.fileName = n.getStringValue(); },
        "fileSize": n => { documentSummary.fileSize = n.getNumberValue(); },
        "id": n => { documentSummary.id = n.getGuidValue(); },
        "locationId": n => { documentSummary.locationId = n.getGuidValue(); },
        "locationName": n => { documentSummary.locationName = n.getStringValue(); },
        "rejectionNote": n => { documentSummary.rejectionNote = n.getStringValue(); },
        "rejectionReason": n => { documentSummary.rejectionReason = n.getEnumValue<RejectionReason>(RejectionReasonObject); },
        "type": n => { documentSummary.type = n.getEnumValue<ContractDocumentType>(ContractDocumentTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param EnqueueBackfillChargerMakesAndModelsResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnqueueBackfillChargerMakesAndModelsResult(enqueueBackfillChargerMakesAndModelsResult: Partial<EnqueueBackfillChargerMakesAndModelsResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connections": n => { enqueueBackfillChargerMakesAndModelsResult.connections = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EnqueueFetchChargePointConsumptionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnqueueFetchChargePointConsumptionCommand(enqueueFetchChargePointConsumptionCommand: Partial<EnqueueFetchChargePointConsumptionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "provider": n => { enqueueFetchChargePointConsumptionCommand.provider = n.getEnumValue<OAuthProviderType>(OAuthProviderTypeObject); },
        "refetch": n => { enqueueFetchChargePointConsumptionCommand.refetch = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EnqueueFetchChargePointConsumptionResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEnqueueFetchChargePointConsumptionResult(enqueueFetchChargePointConsumptionResult: Partial<EnqueueFetchChargePointConsumptionResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fetchedCount": n => { enqueueFetchChargePointConsumptionResult.fetchedCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FetchChargePointConsumptionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFetchChargePointConsumptionCommand(fetchChargePointConsumptionCommand: Partial<FetchChargePointConsumptionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargerId": n => { fetchChargePointConsumptionCommand.chargerId = n.getStringValue(); },
        "externalCustomerId": n => { fetchChargePointConsumptionCommand.externalCustomerId = n.getStringValue(); },
        "provider": n => { fetchChargePointConsumptionCommand.provider = n.getEnumValue<OAuthProviderType>(OAuthProviderTypeObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param FetchChargePointConsumptionResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFetchChargePointConsumptionResult(fetchChargePointConsumptionResult: Partial<FetchChargePointConsumptionResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accessDenied": n => { fetchChargePointConsumptionResult.accessDenied = n.getBooleanValue(); },
        "consumptionTotal": n => { fetchChargePointConsumptionResult.consumptionTotal = n.getNumberValue(); },
        "lastIngestedAt": n => { fetchChargePointConsumptionResult.lastIngestedAt = n.getDateValue(); },
        "notConnected": n => { fetchChargePointConsumptionResult.notConnected = n.getBooleanValue(); },
        "rateLimited": n => { fetchChargePointConsumptionResult.rateLimited = n.getBooleanValue(); },
        "sessionCount": n => { fetchChargePointConsumptionResult.sessionCount = n.getNumberValue(); },
        "skippedDuplicateCount": n => { fetchChargePointConsumptionResult.skippedDuplicateCount = n.getNumberValue(); },
        "skippedInvalidCount": n => { fetchChargePointConsumptionResult.skippedInvalidCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestAffiliateCustomerOrchestrationResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestAffiliateCustomerOrchestrationResult(ingestAffiliateCustomerOrchestrationResult: Partial<IngestAffiliateCustomerOrchestrationResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "acceptedCount": n => { ingestAffiliateCustomerOrchestrationResult.acceptedCount = n.getNumberValue(); },
        "customerCount": n => { ingestAffiliateCustomerOrchestrationResult.customerCount = n.getNumberValue(); },
        "customers": n => { ingestAffiliateCustomerOrchestrationResult.customers = n.getCollectionOfObjectValues<IngestAffiliateCustomerReport>(createIngestAffiliateCustomerReportFromDiscriminatorValue); },
        "rowCount": n => { ingestAffiliateCustomerOrchestrationResult.rowCount = n.getNumberValue(); },
        "scheduledCount": n => { ingestAffiliateCustomerOrchestrationResult.scheduledCount = n.getNumberValue(); },
        "tag": n => { ingestAffiliateCustomerOrchestrationResult.tag = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestAffiliateCustomerReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestAffiliateCustomerReport(ingestAffiliateCustomerReport: Partial<IngestAffiliateCustomerReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { ingestAffiliateCustomerReport.email = n.getStringValue(); },
        "name": n => { ingestAffiliateCustomerReport.name = n.getStringValue(); },
        "outcome": n => { ingestAffiliateCustomerReport.outcome = n.getEnumValue<IngestAffiliateCustomerOutcome>(IngestAffiliateCustomerOutcomeObject); },
        "reasons": n => { ingestAffiliateCustomerReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "rows": n => { ingestAffiliateCustomerReport.rows = n.getCollectionOfPrimitiveValues<number>("number"); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestBusinessCustomerReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestBusinessCustomerReport(ingestBusinessCustomerReport: Partial<IngestBusinessCustomerReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { ingestBusinessCustomerReport.companyName = n.getStringValue(); },
        "customer": n => { ingestBusinessCustomerReport.customer = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "email": n => { ingestBusinessCustomerReport.email = n.getStringValue(); },
        "externalCustomerId": n => { ingestBusinessCustomerReport.externalCustomerId = n.getStringValue(); },
        "locations": n => { ingestBusinessCustomerReport.locations = n.getCollectionOfObjectValues<IngestBusinessLocationReport>(createIngestBusinessLocationReportFromDiscriminatorValue); },
        "reasons": n => { ingestBusinessCustomerReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "registrationNumber": n => { ingestBusinessCustomerReport.registrationNumber = n.getStringValue(); },
        "rowNumbers": n => { ingestBusinessCustomerReport.rowNumbers = n.getCollectionOfPrimitiveValues<string>("string"); },
        "rows": n => { ingestBusinessCustomerReport.rows = n.getCollectionOfPrimitiveValues<number>("number"); },
        "tags": n => { ingestBusinessCustomerReport.tags = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestBusinessCustomerWithContractOrchestrationResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestBusinessCustomerWithContractOrchestrationResult(ingestBusinessCustomerWithContractOrchestrationResult: Partial<IngestBusinessCustomerWithContractOrchestrationResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerCount": n => { ingestBusinessCustomerWithContractOrchestrationResult.customerCount = n.getNumberValue(); },
        "customers": n => { ingestBusinessCustomerWithContractOrchestrationResult.customers = n.getCollectionOfObjectValues<IngestBusinessCustomerReport>(createIngestBusinessCustomerReportFromDiscriminatorValue); },
        "rowCount": n => { ingestBusinessCustomerWithContractOrchestrationResult.rowCount = n.getNumberValue(); },
        "scheduledCount": n => { ingestBusinessCustomerWithContractOrchestrationResult.scheduledCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestBusinessLocationReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestBusinessLocationReport(ingestBusinessLocationReport: Partial<IngestBusinessLocationReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePoints": n => { ingestBusinessLocationReport.chargePoints = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "contract": n => { ingestBusinessLocationReport.contract = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "deviceIds": n => { ingestBusinessLocationReport.deviceIds = n.getCollectionOfPrimitiveValues<string>("string"); },
        "location": n => { ingestBusinessLocationReport.location = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "name": n => { ingestBusinessLocationReport.name = n.getStringValue(); },
        "reasons": n => { ingestBusinessLocationReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "row": n => { ingestBusinessLocationReport.row = n.getNumberValue(); },
        "rowNumber": n => { ingestBusinessLocationReport.rowNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestChargePointReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestChargePointReport(ingestChargePointReport: Partial<IngestChargePointReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { ingestChargePointReport.deviceId = n.getStringValue(); },
        "outcome": n => { ingestChargePointReport.outcome = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "reasons": n => { ingestChargePointReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "row": n => { ingestChargePointReport.row = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestConsumerCustomerReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestConsumerCustomerReport(ingestConsumerCustomerReport: Partial<IngestConsumerCustomerReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePoints": n => { ingestConsumerCustomerReport.chargePoints = n.getCollectionOfObjectValues<IngestChargePointReport>(createIngestChargePointReportFromDiscriminatorValue); },
        "contract": n => { ingestConsumerCustomerReport.contract = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "customer": n => { ingestConsumerCustomerReport.customer = n.getEnumValue<IngestOutcome>(IngestOutcomeObject); },
        "email": n => { ingestConsumerCustomerReport.email = n.getStringValue(); },
        "externalCustomerId": n => { ingestConsumerCustomerReport.externalCustomerId = n.getStringValue(); },
        "legacyCompliancyStatus": n => { ingestConsumerCustomerReport.legacyCompliancyStatus = n.getEnumValue<LegacyCompliancyStatus>(LegacyCompliancyStatusObject); },
        "legacyCustomerId": n => { ingestConsumerCustomerReport.legacyCustomerId = n.getStringValue(); },
        "name": n => { ingestConsumerCustomerReport.name = n.getStringValue(); },
        "reasons": n => { ingestConsumerCustomerReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "rows": n => { ingestConsumerCustomerReport.rows = n.getCollectionOfPrimitiveValues<number>("number"); },
        "tags": n => { ingestConsumerCustomerReport.tags = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestConsumerCustomerWithContractOrchestrationResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestConsumerCustomerWithContractOrchestrationResult(ingestConsumerCustomerWithContractOrchestrationResult: Partial<IngestConsumerCustomerWithContractOrchestrationResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerCount": n => { ingestConsumerCustomerWithContractOrchestrationResult.customerCount = n.getNumberValue(); },
        "customers": n => { ingestConsumerCustomerWithContractOrchestrationResult.customers = n.getCollectionOfObjectValues<IngestConsumerCustomerReport>(createIngestConsumerCustomerReportFromDiscriminatorValue); },
        "rowCount": n => { ingestConsumerCustomerWithContractOrchestrationResult.rowCount = n.getNumberValue(); },
        "scheduledCount": n => { ingestConsumerCustomerWithContractOrchestrationResult.scheduledCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestManualChargePointConsumptionResult The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestManualChargePointConsumptionResult(ingestManualChargePointConsumptionResult: Partial<IngestManualChargePointConsumptionResult> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumptionTotal": n => { ingestManualChargePointConsumptionResult.consumptionTotal = n.getNumberValue(); },
        "customers": n => { ingestManualChargePointConsumptionResult.customers = n.getCollectionOfObjectValues<IngestManualConsumptionCustomerReport>(createIngestManualConsumptionCustomerReportFromDiscriminatorValue); },
        "ingestedCount": n => { ingestManualChargePointConsumptionResult.ingestedCount = n.getNumberValue(); },
        "rowCount": n => { ingestManualChargePointConsumptionResult.rowCount = n.getNumberValue(); },
        "skippedDuplicateCount": n => { ingestManualChargePointConsumptionResult.skippedDuplicateCount = n.getNumberValue(); },
        "skippedInvalidCount": n => { ingestManualChargePointConsumptionResult.skippedInvalidCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestManualConsumptionCustomerReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestManualConsumptionCustomerReport(ingestManualConsumptionCustomerReport: Partial<IngestManualConsumptionCustomerReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { ingestManualConsumptionCustomerReport.email = n.getStringValue(); },
        "externalCustomerId": n => { ingestManualConsumptionCustomerReport.externalCustomerId = n.getStringValue(); },
        "legacyCustomerId": n => { ingestManualConsumptionCustomerReport.legacyCustomerId = n.getStringValue(); },
        "name": n => { ingestManualConsumptionCustomerReport.name = n.getStringValue(); },
        "readings": n => { ingestManualConsumptionCustomerReport.readings = n.getCollectionOfObjectValues<IngestManualConsumptionReadingReport>(createIngestManualConsumptionReadingReportFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param IngestManualConsumptionReadingReport The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIngestManualConsumptionReadingReport(ingestManualConsumptionReadingReport: Partial<IngestManualConsumptionReadingReport> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { ingestManualConsumptionReadingReport.consumption = n.getNumberValue(); },
        "consumptionId": n => { ingestManualConsumptionReadingReport.consumptionId = n.getStringValue(); },
        "deviceId": n => { ingestManualConsumptionReadingReport.deviceId = n.getStringValue(); },
        "notes": n => { ingestManualConsumptionReadingReport.notes = n.getCollectionOfPrimitiveValues<string>("string"); },
        "outcome": n => { ingestManualConsumptionReadingReport.outcome = n.getEnumValue<ManualReadingOutcome>(ManualReadingOutcomeObject); },
        "reasons": n => { ingestManualConsumptionReadingReport.reasons = n.getCollectionOfPrimitiveValues<string>("string"); },
        "receivedAt": n => { ingestManualConsumptionReadingReport.receivedAt = n.getDateValue(); },
        "row": n => { ingestManualConsumptionReadingReport.row = n.getNumberValue(); },
        "timestamp": n => { ingestManualConsumptionReadingReport.timestamp = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Ledger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLedger(ledger: Partial<Ledger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accounts": n => { ledger.accounts = n.getCollectionOfObjectValues<LedgerAccount>(createLedgerAccountFromDiscriminatorValue); },
        "accountsCount": n => { ledger.accountsCount = n.getNumberValue(); },
        "createdBy": n => { ledger.createdBy = n.getStringValue(); },
        "createdDate": n => { ledger.createdDate = n.getDateValue(); },
        "currency": n => { ledger.currency = n.getEnumValue<CurrencyType>(CurrencyTypeObject); },
        "id": n => { ledger.id = n.getGuidValue(); },
        "lastModifiedBy": n => { ledger.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { ledger.lastModifiedDate = n.getDateValue(); },
        "name": n => { ledger.name = n.getStringValue(); },
        "totalBalance": n => { ledger.totalBalance = n.getNumberValue(); },
        "totalPendingBalance": n => { ledger.totalPendingBalance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LedgerAccount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLedgerAccount(ledgerAccount: Partial<LedgerAccount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountNumber": n => { ledgerAccount.accountNumber = n.getStringValue(); },
        "balance": n => { ledgerAccount.balance = n.getNumberValue(); },
        "contractId": n => { ledgerAccount.contractId = n.getGuidValue(); },
        "contractReference": n => { ledgerAccount.contractReference = n.getStringValue(); },
        "customerEmail": n => { ledgerAccount.customerEmail = n.getStringValue(); },
        "customerId": n => { ledgerAccount.customerId = n.getGuidValue(); },
        "customerName": n => { ledgerAccount.customerName = n.getStringValue(); },
        "id": n => { ledgerAccount.id = n.getGuidValue(); },
        "locationId": n => { ledgerAccount.locationId = n.getGuidValue(); },
        "meteringPointCity": n => { ledgerAccount.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { ledgerAccount.meteringPointEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { ledgerAccount.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { ledgerAccount.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { ledgerAccount.meteringPointStreet = n.getStringValue(); },
        "name": n => { ledgerAccount.name = n.getStringValue(); },
        "pendingBalance": n => { ledgerAccount.pendingBalance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LedgerSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLedgerSummary(ledgerSummary: Partial<LedgerSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountsCount": n => { ledgerSummary.accountsCount = n.getNumberValue(); },
        "createdBy": n => { ledgerSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { ledgerSummary.createdDate = n.getDateValue(); },
        "currency": n => { ledgerSummary.currency = n.getEnumValue<CurrencyType>(CurrencyTypeObject); },
        "id": n => { ledgerSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { ledgerSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { ledgerSummary.lastModifiedDate = n.getDateValue(); },
        "name": n => { ledgerSummary.name = n.getStringValue(); },
        "totalBalance": n => { ledgerSummary.totalBalance = n.getNumberValue(); },
        "totalPendingBalance": n => { ledgerSummary.totalPendingBalance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LinkCallToCustomerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLinkCallToCustomerCommand(linkCallToCustomerCommand: Partial<LinkCallToCustomerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callId": n => { linkCallToCustomerCommand.callId = n.getGuidValue(); },
        "customerId": n => { linkCallToCustomerCommand.customerId = n.getGuidValue(); },
        "replacePhoneNumber": n => { linkCallToCustomerCommand.replacePhoneNumber = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Location The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocation(location: Partial<Location> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePoints": n => { location.chargePoints = n.getCollectionOfObjectValues<LocationChargePoint>(createLocationChargePointFromDiscriminatorValue); },
        "connectionType": n => { location.connectionType = n.getEnumValue<ConnectionType>(ConnectionTypeObject); },
        "contracts": n => { location.contracts = n.getCollectionOfObjectValues<LocationContract>(createLocationContractFromDiscriminatorValue); },
        "createdBy": n => { location.createdBy = n.getStringValue(); },
        "createdDate": n => { location.createdDate = n.getDateValue(); },
        "customerId": n => { location.customerId = n.getGuidValue(); },
        "essInstallation": n => { location.essInstallation = n.getObjectValue<LocationInstallation>(createLocationInstallationFromDiscriminatorValue); },
        "hasEssInstallation": n => { location.hasEssInstallation = n.getBooleanValue(); },
        "hasPvInstallation": n => { location.hasPvInstallation = n.getBooleanValue(); },
        "id": n => { location.id = n.getGuidValue(); },
        "lastModifiedBy": n => { location.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { location.lastModifiedDate = n.getDateValue(); },
        "meteringPoint": n => { location.meteringPoint = n.getObjectValue<LocationMeteringPoint>(createLocationMeteringPointFromDiscriminatorValue); },
        "name": n => { location.name = n.getStringValue(); },
        "pvInstallation": n => { location.pvInstallation = n.getObjectValue<LocationInstallation>(createLocationInstallationFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationAddress The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationAddress(locationAddress: Partial<LocationAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { locationAddress.city = n.getStringValue(); },
        "houseNumber": n => { locationAddress.houseNumber = n.getStringValue(); },
        "postcode": n => { locationAddress.postcode = n.getStringValue(); },
        "street": n => { locationAddress.street = n.getStringValue(); },
        "verificationStatus": n => { locationAddress.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationChargePoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationChargePoint(locationChargePoint: Partial<LocationChargePoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "charger": n => { locationChargePoint.charger = n.getObjectValue<LocationCharger>(createLocationChargerFromDiscriminatorValue); },
        "id": n => { locationChargePoint.id = n.getGuidValue(); },
        "name": n => { locationChargePoint.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationCharger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationCharger(locationCharger: Partial<LocationCharger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { locationCharger.deviceId = n.getStringValue(); },
        "make": n => { locationCharger.make = n.getStringValue(); },
        "midMeter": n => { locationCharger.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { locationCharger.model = n.getStringValue(); },
        "verificationStatus": n => { locationCharger.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationConsumptionWithProjection The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationConsumptionWithProjection(locationConsumptionWithProjection: Partial<LocationConsumptionWithProjection> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { locationConsumptionWithProjection.consumption = n.getNumberValue(); },
        "contractId": n => { locationConsumptionWithProjection.contractId = n.getGuidValue(); },
        "expectedConsumption": n => { locationConsumptionWithProjection.expectedConsumption = n.getNumberValue(); },
        "expectedPayoutAmount": n => { locationConsumptionWithProjection.expectedPayoutAmount = n.getNumberValue(); },
        "expectedUnits": n => { locationConsumptionWithProjection.expectedUnits = n.getNumberValue(); },
        "expectedYield": n => { locationConsumptionWithProjection.expectedYield = n.getNumberValue(); },
        "id": n => { locationConsumptionWithProjection.id = n.getGuidValue(); },
        "locationId": n => { locationConsumptionWithProjection.locationId = n.getGuidValue(); },
        "payoutAmount": n => { locationConsumptionWithProjection.payoutAmount = n.getNumberValue(); },
        "periodFrom": n => { locationConsumptionWithProjection.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { locationConsumptionWithProjection.periodTo = n.getDateOnlyValue(); },
        "projectionDate": n => { locationConsumptionWithProjection.projectionDate = n.getDateOnlyValue(); },
        "registeredConsumption": n => { locationConsumptionWithProjection.registeredConsumption = n.getNumberValue(); },
        "registeredPayoutAmount": n => { locationConsumptionWithProjection.registeredPayoutAmount = n.getNumberValue(); },
        "registeredTo": n => { locationConsumptionWithProjection.registeredTo = n.getDateOnlyValue(); },
        "registeredUnits": n => { locationConsumptionWithProjection.registeredUnits = n.getNumberValue(); },
        "registeredYield": n => { locationConsumptionWithProjection.registeredYield = n.getNumberValue(); },
        "units": n => { locationConsumptionWithProjection.units = n.getNumberValue(); },
        "yield": n => { locationConsumptionWithProjection.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationContract The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationContract(locationContract: Partial<LocationContract> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCondition": n => { locationContract.affiliateCondition = n.getObjectValue<LocationContractAffiliateCondition>(createLocationContractAffiliateConditionFromDiscriminatorValue); },
        "complianceStatus": n => { locationContract.complianceStatus = n.getEnumValue<ComplianceStatus>(ComplianceStatusObject); },
        "contractReference": n => { locationContract.contractReference = n.getStringValue(); },
        "contractRevokedDate": n => { locationContract.contractRevokedDate = n.getDateOnlyValue(); },
        "contractSignedDate": n => { locationContract.contractSignedDate = n.getDateOnlyValue(); },
        "id": n => { locationContract.id = n.getGuidValue(); },
        "isEligibleForPayout": n => { locationContract.isEligibleForPayout = n.getBooleanValue(); },
        "isEligibleForRegistration": n => { locationContract.isEligibleForRegistration = n.getBooleanValue(); },
        "isEligibleForTransaction": n => { locationContract.isEligibleForTransaction = n.getBooleanValue(); },
        "mandateRevokedDate": n => { locationContract.mandateRevokedDate = n.getDateOnlyValue(); },
        "mandateSignedDate": n => { locationContract.mandateSignedDate = n.getDateOnlyValue(); },
        "openItems": n => { locationContract.openItems = n.getCollectionOfObjectValues<ContractComplianceItem>(createContractComplianceItemFromDiscriminatorValue); },
        "validFrom": n => { locationContract.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { locationContract.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationContractAffiliateCondition The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationContractAffiliateCondition(locationContractAffiliateCondition: Partial<LocationContractAffiliateCondition> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { locationContractAffiliateCondition.affiliateCode = n.getStringValue(); },
        "discountPercentage": n => { locationContractAffiliateCondition.discountPercentage = n.getNumberValue(); },
        "name": n => { locationContractAffiliateCondition.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationInstallation The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationInstallation(locationInstallation: Partial<LocationInstallation> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "capacity": n => { locationInstallation.capacity = n.getNumberValue(); },
        "make": n => { locationInstallation.make = n.getStringValue(); },
        "model": n => { locationInstallation.model = n.getStringValue(); },
        "notes": n => { locationInstallation.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationMeteringPoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationMeteringPoint(locationMeteringPoint: Partial<LocationMeteringPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { locationMeteringPoint.address = n.getObjectValue<LocationAddress>(createLocationAddressFromDiscriminatorValue); },
        "eanCode": n => { locationMeteringPoint.eanCode = n.getStringValue(); },
        "gridOperator": n => { locationMeteringPoint.gridOperator = n.getStringValue(); },
        "gridOperatorEanCode": n => { locationMeteringPoint.gridOperatorEanCode = n.getStringValue(); },
        "verificationStatus": n => { locationMeteringPoint.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationSummary(locationSummary: Partial<LocationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargePointCount": n => { locationSummary.chargePointCount = n.getNumberValue(); },
        "contractCount": n => { locationSummary.contractCount = n.getNumberValue(); },
        "currentContractId": n => { locationSummary.currentContractId = n.getGuidValue(); },
        "customerId": n => { locationSummary.customerId = n.getGuidValue(); },
        "hasEssInstallation": n => { locationSummary.hasEssInstallation = n.getBooleanValue(); },
        "hasPvInstallation": n => { locationSummary.hasPvInstallation = n.getBooleanValue(); },
        "id": n => { locationSummary.id = n.getGuidValue(); },
        "meteringPoint": n => { locationSummary.meteringPoint = n.getObjectValue<LocationSummaryMeteringPoint>(createLocationSummaryMeteringPointFromDiscriminatorValue); },
        "name": n => { locationSummary.name = n.getStringValue(); },
        "pendingChargePointCount": n => { locationSummary.pendingChargePointCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationSummaryAddress The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationSummaryAddress(locationSummaryAddress: Partial<LocationSummaryAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { locationSummaryAddress.city = n.getStringValue(); },
        "houseNumber": n => { locationSummaryAddress.houseNumber = n.getStringValue(); },
        "postcode": n => { locationSummaryAddress.postcode = n.getStringValue(); },
        "street": n => { locationSummaryAddress.street = n.getStringValue(); },
        "verificationStatus": n => { locationSummaryAddress.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param LocationSummaryMeteringPoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoLocationSummaryMeteringPoint(locationSummaryMeteringPoint: Partial<LocationSummaryMeteringPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "address": n => { locationSummaryMeteringPoint.address = n.getObjectValue<LocationSummaryAddress>(createLocationSummaryAddressFromDiscriminatorValue); },
        "eanCode": n => { locationSummaryMeteringPoint.eanCode = n.getStringValue(); },
        "gridOperator": n => { locationSummaryMeteringPoint.gridOperator = n.getStringValue(); },
        "gridOperatorEanCode": n => { locationSummaryMeteringPoint.gridOperatorEanCode = n.getStringValue(); },
        "verificationStatus": n => { locationSummaryMeteringPoint.verificationStatus = n.getEnumValue<VerificationStatus>(VerificationStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param MandateSigningCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMandateSigningCount(mandateSigningCount: Partial<MandateSigningCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "years": n => { mandateSigningCount.years = n.getCollectionOfObjectValues<YearMandateSigningCount>(createYearMandateSigningCountFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param ManualConsumptionEntry The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoManualConsumptionEntry(manualConsumptionEntry: Partial<ManualConsumptionEntry> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { manualConsumptionEntry.consumption = n.getNumberValue(); },
        "id": n => { manualConsumptionEntry.id = n.getStringValue(); },
        "provider": n => { manualConsumptionEntry.provider = n.getEnumValue<ConsumptionProvider>(ConsumptionProviderObject); },
        "receivedAt": n => { manualConsumptionEntry.receivedAt = n.getDateValue(); },
        "source": n => { manualConsumptionEntry.source = n.getEnumValue<ConsumptionSource>(ConsumptionSourceObject); },
        "superseded": n => { manualConsumptionEntry.superseded = n.getBooleanValue(); },
        "timestamp": n => { manualConsumptionEntry.timestamp = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MessageDetail The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMessageDetail(messageDetail: Partial<MessageDetail> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bodyAvailable": n => { messageDetail.bodyAvailable = n.getBooleanValue(); },
        "customerId": n => { messageDetail.customerId = n.getGuidValue(); },
        "htmlBody": n => { messageDetail.htmlBody = n.getStringValue(); },
        "id": n => { messageDetail.id = n.getGuidValue(); },
        "recipient": n => { messageDetail.recipient = n.getStringValue(); },
        "sentDate": n => { messageDetail.sentDate = n.getDateValue(); },
        "subject": n => { messageDetail.subject = n.getStringValue(); },
        "textBody": n => { messageDetail.textBody = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MessageSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMessageSummary(messageSummary: Partial<MessageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { messageSummary.customerId = n.getGuidValue(); },
        "id": n => { messageSummary.id = n.getGuidValue(); },
        "recipient": n => { messageSummary.recipient = n.getStringValue(); },
        "sentDate": n => { messageSummary.sentDate = n.getDateValue(); },
        "subject": n => { messageSummary.subject = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MeteringPointSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMeteringPointSummary(meteringPointSummary: Partial<MeteringPointSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { meteringPointSummary.city = n.getStringValue(); },
        "eanCode": n => { meteringPointSummary.eanCode = n.getStringValue(); },
        "gridOperator": n => { meteringPointSummary.gridOperator = n.getStringValue(); },
        "gridOperatorEanCode": n => { meteringPointSummary.gridOperatorEanCode = n.getStringValue(); },
        "houseNumber": n => { meteringPointSummary.houseNumber = n.getStringValue(); },
        "postcode": n => { meteringPointSummary.postcode = n.getStringValue(); },
        "specialMeteringPoint": n => { meteringPointSummary.specialMeteringPoint = n.getBooleanValue(); },
        "street": n => { meteringPointSummary.street = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MoveChargePointCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMoveChargePointCommand(moveChargePointCommand: Partial<MoveChargePointCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { moveChargePointCommand.id = n.getGuidValue(); },
        "locationId": n => { moveChargePointCommand.locationId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param OAuthConnectionCharger The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoOAuthConnectionCharger(oAuthConnectionCharger: Partial<OAuthConnectionCharger> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { oAuthConnectionCharger.deviceId = n.getStringValue(); },
        "isActive": n => { oAuthConnectionCharger.isActive = n.getBooleanValue(); },
        "make": n => { oAuthConnectionCharger.make = n.getStringValue(); },
        "model": n => { oAuthConnectionCharger.model = n.getStringValue(); },
        "name": n => { oAuthConnectionCharger.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfAccountEntrySummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfAccountEntrySummary(paginatedListOfAccountEntrySummary: Partial<PaginatedListOfAccountEntrySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfAccountEntrySummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfAccountEntrySummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfAccountEntrySummary.items = n.getCollectionOfObjectValues<AccountEntrySummary>(createAccountEntrySummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfAccountEntrySummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfAccountEntrySummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfAccountEntrySummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfAccountSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfAccountSummary(paginatedListOfAccountSummary: Partial<PaginatedListOfAccountSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfAccountSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfAccountSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfAccountSummary.items = n.getCollectionOfObjectValues<AccountSummary>(createAccountSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfAccountSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfAccountSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfAccountSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfAffiliateSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfAffiliateSummary(paginatedListOfAffiliateSummary: Partial<PaginatedListOfAffiliateSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfAffiliateSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfAffiliateSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfAffiliateSummary.items = n.getCollectionOfObjectValues<AffiliateSummary>(createAffiliateSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfAffiliateSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfAffiliateSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfAffiliateSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfAuditEntrySummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfAuditEntrySummary(paginatedListOfAuditEntrySummary: Partial<PaginatedListOfAuditEntrySummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfAuditEntrySummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfAuditEntrySummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfAuditEntrySummary.items = n.getCollectionOfObjectValues<AuditEntrySummary>(createAuditEntrySummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfAuditEntrySummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfAuditEntrySummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfAuditEntrySummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfCallSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfCallSummary(paginatedListOfCallSummary: Partial<PaginatedListOfCallSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfCallSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfCallSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfCallSummary.items = n.getCollectionOfObjectValues<CallSummary>(createCallSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfCallSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfCallSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfCallSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfChargePointSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfChargePointSummary(paginatedListOfChargePointSummary: Partial<PaginatedListOfChargePointSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfChargePointSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfChargePointSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfChargePointSummary.items = n.getCollectionOfObjectValues<ChargePointSummary>(createChargePointSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfChargePointSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfChargePointSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfChargePointSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfChargerDefinitionSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfChargerDefinitionSummary(paginatedListOfChargerDefinitionSummary: Partial<PaginatedListOfChargerDefinitionSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfChargerDefinitionSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfChargerDefinitionSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfChargerDefinitionSummary.items = n.getCollectionOfObjectValues<ChargerDefinitionSummary>(createChargerDefinitionSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfChargerDefinitionSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfChargerDefinitionSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfChargerDefinitionSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfContractListItem The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfContractListItem(paginatedListOfContractListItem: Partial<PaginatedListOfContractListItem> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfContractListItem.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfContractListItem.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfContractListItem.items = n.getCollectionOfObjectValues<ContractListItem>(createContractListItemFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfContractListItem.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfContractListItem.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfContractListItem.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfContractSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfContractSummary(paginatedListOfContractSummary: Partial<PaginatedListOfContractSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfContractSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfContractSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfContractSummary.items = n.getCollectionOfObjectValues<ContractSummary>(createContractSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfContractSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfContractSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfContractSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfConversionFactorSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfConversionFactorSummary(paginatedListOfConversionFactorSummary: Partial<PaginatedListOfConversionFactorSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfConversionFactorSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfConversionFactorSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfConversionFactorSummary.items = n.getCollectionOfObjectValues<ConversionFactorSummary>(createConversionFactorSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfConversionFactorSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfConversionFactorSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfConversionFactorSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfCustomerSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfCustomerSummary(paginatedListOfCustomerSummary: Partial<PaginatedListOfCustomerSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfCustomerSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfCustomerSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfCustomerSummary.items = n.getCollectionOfObjectValues<CustomerSummary>(createCustomerSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfCustomerSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfCustomerSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfCustomerSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfDocumentSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfDocumentSummary(paginatedListOfDocumentSummary: Partial<PaginatedListOfDocumentSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfDocumentSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfDocumentSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfDocumentSummary.items = n.getCollectionOfObjectValues<DocumentSummary>(createDocumentSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfDocumentSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfDocumentSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfDocumentSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfLedgerSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfLedgerSummary(paginatedListOfLedgerSummary: Partial<PaginatedListOfLedgerSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfLedgerSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfLedgerSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfLedgerSummary.items = n.getCollectionOfObjectValues<LedgerSummary>(createLedgerSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfLedgerSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfLedgerSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfLedgerSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfLocationSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfLocationSummary(paginatedListOfLocationSummary: Partial<PaginatedListOfLocationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfLocationSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfLocationSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfLocationSummary.items = n.getCollectionOfObjectValues<LocationSummary>(createLocationSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfLocationSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfLocationSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfLocationSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfMessageSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfMessageSummary(paginatedListOfMessageSummary: Partial<PaginatedListOfMessageSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfMessageSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfMessageSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfMessageSummary.items = n.getCollectionOfObjectValues<MessageSummary>(createMessageSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfMessageSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfMessageSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfMessageSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfPayoutSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfPayoutSummary(paginatedListOfPayoutSummary: Partial<PaginatedListOfPayoutSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfPayoutSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfPayoutSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfPayoutSummary.items = n.getCollectionOfObjectValues<PayoutSummary>(createPayoutSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfPayoutSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfPayoutSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfPayoutSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfRegistrationSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfRegistrationSummary(paginatedListOfRegistrationSummary: Partial<PaginatedListOfRegistrationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfRegistrationSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfRegistrationSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfRegistrationSummary.items = n.getCollectionOfObjectValues<RegistrationSummary>(createRegistrationSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfRegistrationSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfRegistrationSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfRegistrationSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedListOfTransactionSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedListOfTransactionSummary(paginatedListOfTransactionSummary: Partial<PaginatedListOfTransactionSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedListOfTransactionSummary.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedListOfTransactionSummary.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedListOfTransactionSummary.items = n.getCollectionOfObjectValues<TransactionSummary>(createTransactionSummaryFromDiscriminatorValue); },
        "pageNumber": n => { paginatedListOfTransactionSummary.pageNumber = n.getNumberValue(); },
        "totalCount": n => { paginatedListOfTransactionSummary.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedListOfTransactionSummary.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Payout The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPayout(payout: Partial<Payout> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdBy": n => { payout.createdBy = n.getStringValue(); },
        "createdDate": n => { payout.createdDate = n.getDateValue(); },
        "id": n => { payout.id = n.getGuidValue(); },
        "lastModifiedBy": n => { payout.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { payout.lastModifiedDate = n.getDateValue(); },
        "lines": n => { payout.lines = n.getCollectionOfObjectValues<PayoutLine>(createPayoutLineFromDiscriminatorValue); },
        "notes": n => { payout.notes = n.getStringValue(); },
        "payoutDate": n => { payout.payoutDate = n.getDateOnlyValue(); },
        "payoutReference": n => { payout.payoutReference = n.getStringValue(); },
        "totalAmount": n => { payout.totalAmount = n.getNumberValue(); },
        "totalCommission": n => { payout.totalCommission = n.getNumberValue(); },
        "totalDiscount": n => { payout.totalDiscount = n.getNumberValue(); },
        "totalNetYield": n => { payout.totalNetYield = n.getNumberValue(); },
        "transactionId": n => { payout.transactionId = n.getGuidValue(); },
        "transactionReference": n => { payout.transactionReference = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PayoutLine The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPayoutLine(payoutLine: Partial<PayoutLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { payoutLine.amount = n.getNumberValue(); },
        "commission": n => { payoutLine.commission = n.getNumberValue(); },
        "contractId": n => { payoutLine.contractId = n.getGuidValue(); },
        "contractReference": n => { payoutLine.contractReference = n.getStringValue(); },
        "customerEmail": n => { payoutLine.customerEmail = n.getStringValue(); },
        "customerId": n => { payoutLine.customerId = n.getGuidValue(); },
        "customerName": n => { payoutLine.customerName = n.getStringValue(); },
        "customerReference": n => { payoutLine.customerReference = n.getStringValue(); },
        "discount": n => { payoutLine.discount = n.getNumberValue(); },
        "id": n => { payoutLine.id = n.getGuidValue(); },
        "locationId": n => { payoutLine.locationId = n.getGuidValue(); },
        "meteringPointCity": n => { payoutLine.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { payoutLine.meteringPointEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { payoutLine.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { payoutLine.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { payoutLine.meteringPointStreet = n.getStringValue(); },
        "netYield": n => { payoutLine.netYield = n.getNumberValue(); },
        "percentage": n => { payoutLine.percentage = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PayoutSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPayoutSummary(payoutSummary: Partial<PayoutSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractCount": n => { payoutSummary.contractCount = n.getNumberValue(); },
        "createdBy": n => { payoutSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { payoutSummary.createdDate = n.getDateValue(); },
        "id": n => { payoutSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { payoutSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { payoutSummary.lastModifiedDate = n.getDateValue(); },
        "payoutDate": n => { payoutSummary.payoutDate = n.getDateOnlyValue(); },
        "payoutReference": n => { payoutSummary.payoutReference = n.getStringValue(); },
        "totalAmount": n => { payoutSummary.totalAmount = n.getNumberValue(); },
        "totalCommission": n => { payoutSummary.totalCommission = n.getNumberValue(); },
        "totalDiscount": n => { payoutSummary.totalDiscount = n.getNumberValue(); },
        "totalNetYield": n => { payoutSummary.totalNetYield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProblemDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProblemDetails(problemDetails: Partial<ProblemDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detail": n => { problemDetails.detail = n.getStringValue(); },
        "errors": n => { problemDetails.errors = n.getObjectValue<ProblemDetails_errors>(createProblemDetails_errorsFromDiscriminatorValue); },
        "instance": n => { problemDetails.instance = n.getStringValue(); },
        "status": n => { problemDetails.status = n.getNumberValue(); },
        "title": n => { problemDetails.title = n.getStringValue(); },
        "traceId": n => { problemDetails.traceId = n.getStringValue(); },
        "type": n => { problemDetails.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ProblemDetails_errors The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProblemDetails_errors(problemDetails_errors: Partial<ProblemDetails_errors> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param ProlongContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoProlongContractCommand(prolongContractCommand: Partial<ProlongContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { prolongContractCommand.id = n.getGuidValue(); },
        "validFrom": n => { prolongContractCommand.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { prolongContractCommand.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param Registration The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegistration(registration: Partial<Registration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdBy": n => { registration.createdBy = n.getStringValue(); },
        "createdDate": n => { registration.createdDate = n.getDateValue(); },
        "id": n => { registration.id = n.getGuidValue(); },
        "lastModifiedBy": n => { registration.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { registration.lastModifiedDate = n.getDateValue(); },
        "lines": n => { registration.lines = n.getCollectionOfObjectValues<RegistrationLine>(createRegistrationLineFromDiscriminatorValue); },
        "notes": n => { registration.notes = n.getStringValue(); },
        "periodFrom": n => { registration.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { registration.periodTo = n.getDateOnlyValue(); },
        "registrationDate": n => { registration.registrationDate = n.getDateOnlyValue(); },
        "registrationReference": n => { registration.registrationReference = n.getStringValue(); },
        "totalConsumption": n => { registration.totalConsumption = n.getNumberValue(); },
        "totalUnits": n => { registration.totalUnits = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RegistrationLine The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegistrationLine(registrationLine: Partial<RegistrationLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "consumption": n => { registrationLine.consumption = n.getNumberValue(); },
        "consumptionType": n => { registrationLine.consumptionType = n.getEnumValue<ConsumptionType>(ConsumptionTypeObject); },
        "contractId": n => { registrationLine.contractId = n.getGuidValue(); },
        "contractReference": n => { registrationLine.contractReference = n.getStringValue(); },
        "customerEmail": n => { registrationLine.customerEmail = n.getStringValue(); },
        "customerId": n => { registrationLine.customerId = n.getGuidValue(); },
        "customerName": n => { registrationLine.customerName = n.getStringValue(); },
        "customerReference": n => { registrationLine.customerReference = n.getStringValue(); },
        "id": n => { registrationLine.id = n.getGuidValue(); },
        "locationId": n => { registrationLine.locationId = n.getGuidValue(); },
        "meteringPointCity": n => { registrationLine.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { registrationLine.meteringPointEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { registrationLine.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { registrationLine.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { registrationLine.meteringPointStreet = n.getStringValue(); },
        "units": n => { registrationLine.units = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RegistrationSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRegistrationSummary(registrationSummary: Partial<RegistrationSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "blockedContractCount": n => { registrationSummary.blockedContractCount = n.getNumberValue(); },
        "contractCount": n => { registrationSummary.contractCount = n.getNumberValue(); },
        "createdBy": n => { registrationSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { registrationSummary.createdDate = n.getDateValue(); },
        "id": n => { registrationSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { registrationSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { registrationSummary.lastModifiedDate = n.getDateValue(); },
        "pendingContractCount": n => { registrationSummary.pendingContractCount = n.getNumberValue(); },
        "periodFrom": n => { registrationSummary.periodFrom = n.getDateOnlyValue(); },
        "periodTo": n => { registrationSummary.periodTo = n.getDateOnlyValue(); },
        "registrationDate": n => { registrationSummary.registrationDate = n.getDateOnlyValue(); },
        "registrationReference": n => { registrationSummary.registrationReference = n.getStringValue(); },
        "totalConsumption": n => { registrationSummary.totalConsumption = n.getNumberValue(); },
        "totalUnits": n => { registrationSummary.totalUnits = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevokeContractSigningCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevokeContractSigningCommand(revokeContractSigningCommand: Partial<RevokeContractSigningCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractId": n => { revokeContractSigningCommand.contractId = n.getGuidValue(); },
        "revokedDate": n => { revokeContractSigningCommand.revokedDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevokeMandateSigningCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevokeMandateSigningCommand(revokeMandateSigningCommand: Partial<RevokeMandateSigningCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractId": n => { revokeMandateSigningCommand.contractId = n.getGuidValue(); },
        "revokedDate": n => { revokeMandateSigningCommand.revokedDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ServiceProviderSettings The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoServiceProviderSettings(serviceProviderSettings: Partial<ServiceProviderSettings> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addressCity": n => { serviceProviderSettings.addressCity = n.getStringValue(); },
        "addressHouseNumber": n => { serviceProviderSettings.addressHouseNumber = n.getStringValue(); },
        "addressPostcode": n => { serviceProviderSettings.addressPostcode = n.getStringValue(); },
        "addressStreet": n => { serviceProviderSettings.addressStreet = n.getStringValue(); },
        "bankAccountHolder": n => { serviceProviderSettings.bankAccountHolder = n.getStringValue(); },
        "bankAccountNumber": n => { serviceProviderSettings.bankAccountNumber = n.getStringValue(); },
        "commissionPercentage": n => { serviceProviderSettings.commissionPercentage = n.getNumberValue(); },
        "companyRegistrationName": n => { serviceProviderSettings.companyRegistrationName = n.getStringValue(); },
        "companyRegistrationNumber": n => { serviceProviderSettings.companyRegistrationNumber = n.getStringValue(); },
        "contactEmail": n => { serviceProviderSettings.contactEmail = n.getStringValue(); },
        "contactFirstName": n => { serviceProviderSettings.contactFirstName = n.getStringValue(); },
        "contactLastName": n => { serviceProviderSettings.contactLastName = n.getStringValue(); },
        "contactPhone": n => { serviceProviderSettings.contactPhone = n.getStringValue(); },
        "createdBy": n => { serviceProviderSettings.createdBy = n.getStringValue(); },
        "createdDate": n => { serviceProviderSettings.createdDate = n.getDateValue(); },
        "id": n => { serviceProviderSettings.id = n.getGuidValue(); },
        "lastModifiedBy": n => { serviceProviderSettings.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { serviceProviderSettings.lastModifiedDate = n.getDateValue(); },
        "name": n => { serviceProviderSettings.name = n.getStringValue(); },
        "supportEmail": n => { serviceProviderSettings.supportEmail = n.getStringValue(); },
        "vatPercentage": n => { serviceProviderSettings.vatPercentage = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SessionConsumptionEntry The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSessionConsumptionEntry(sessionConsumptionEntry: Partial<SessionConsumptionEntry> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargerId": n => { sessionConsumptionEntry.chargerId = n.getStringValue(); },
        "consumption": n => { sessionConsumptionEntry.consumption = n.getNumberValue(); },
        "duration": n => { sessionConsumptionEntry.duration = n.getStringValue(); },
        "id": n => { sessionConsumptionEntry.id = n.getStringValue(); },
        "provider": n => { sessionConsumptionEntry.provider = n.getEnumValue<ConsumptionProvider>(ConsumptionProviderObject); },
        "receivedAt": n => { sessionConsumptionEntry.receivedAt = n.getDateValue(); },
        "source": n => { sessionConsumptionEntry.source = n.getEnumValue<ConsumptionSource>(ConsumptionSourceObject); },
        "startedAt": n => { sessionConsumptionEntry.startedAt = n.getDateValue(); },
        "stoppedAt": n => { sessionConsumptionEntry.stoppedAt = n.getDateValue(); },
        "timestamp": n => { sessionConsumptionEntry.timestamp = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignContractCommand(signContractCommand: Partial<SignContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractId": n => { signContractCommand.contractId = n.getGuidValue(); },
        "signature": n => { signContractCommand.signature = n.getByteArrayValue(); },
        "signatureContentType": n => { signContractCommand.signatureContentType = n.getStringValue(); },
        "signatureFileSize": n => { signContractCommand.signatureFileSize = n.getNumberValue(); },
        "signedBy": n => { signContractCommand.signedBy = n.getStringValue(); },
        "signedDate": n => { signContractCommand.signedDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignMandateCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignMandateCommand(signMandateCommand: Partial<SignMandateCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contractId": n => { signMandateCommand.contractId = n.getGuidValue(); },
        "signature": n => { signMandateCommand.signature = n.getByteArrayValue(); },
        "signatureContentType": n => { signMandateCommand.signatureContentType = n.getStringValue(); },
        "signatureFileSize": n => { signMandateCommand.signatureFileSize = n.getNumberValue(); },
        "signedBy": n => { signMandateCommand.signedBy = n.getStringValue(); },
        "signedDate": n => { signMandateCommand.signedDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignupAddress The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignupAddress(signupAddress: Partial<SignupAddress> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { signupAddress.city = n.getStringValue(); },
        "eanCode": n => { signupAddress.eanCode = n.getStringValue(); },
        "gridOperator": n => { signupAddress.gridOperator = n.getStringValue(); },
        "gridOperatorEanCode": n => { signupAddress.gridOperatorEanCode = n.getStringValue(); },
        "houseNumber": n => { signupAddress.houseNumber = n.getStringValue(); },
        "postcode": n => { signupAddress.postcode = n.getStringValue(); },
        "street": n => { signupAddress.street = n.getStringValue(); },
        "verified": n => { signupAddress.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignupBankAccount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignupBankAccount(signupBankAccount: Partial<SignupBankAccount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountHolder": n => { signupBankAccount.accountHolder = n.getStringValue(); },
        "accountNumber": n => { signupBankAccount.accountNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignupChargePoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignupChargePoint(signupChargePoint: Partial<SignupChargePoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { signupChargePoint.deviceId = n.getStringValue(); },
        "make": n => { signupChargePoint.make = n.getStringValue(); },
        "model": n => { signupChargePoint.model = n.getStringValue(); },
        "name": n => { signupChargePoint.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignupCompanyRegistration The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignupCompanyRegistration(signupCompanyRegistration: Partial<SignupCompanyRegistration> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { signupCompanyRegistration.name = n.getStringValue(); },
        "number": n => { signupCompanyRegistration.number = n.getStringValue(); },
        "officeNumber": n => { signupCompanyRegistration.officeNumber = n.getStringValue(); },
        "officeType": n => { signupCompanyRegistration.officeType = n.getEnumValue<OfficeType>(OfficeTypeObject); },
        "verified": n => { signupCompanyRegistration.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SignupContact The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSignupContact(signupContact: Partial<SignupContact> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { signupContact.email = n.getStringValue(); },
        "firstName": n => { signupContact.firstName = n.getStringValue(); },
        "lastName": n => { signupContact.lastName = n.getStringValue(); },
        "phone": n => { signupContact.phone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TagCustomerCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagCustomerCount(tagCustomerCount: Partial<TagCustomerCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { tagCustomerCount.customers = n.getNumberValue(); },
        "tag": n => { tagCustomerCount.tag = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TagNamespaceCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagNamespaceCount(tagNamespaceCount: Partial<TagNamespaceCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customers": n => { tagNamespaceCount.customers = n.getNumberValue(); },
        "namespace": n => { tagNamespaceCount.namespace = n.getStringValue(); },
        "tags": n => { tagNamespaceCount.tags = n.getCollectionOfObjectValues<TagCustomerCount>(createTagCustomerCountFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param Transaction The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTransaction(transaction: Partial<Transaction> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "costPercentage": n => { transaction.costPercentage = n.getNumberValue(); },
        "createdBy": n => { transaction.createdBy = n.getStringValue(); },
        "createdDate": n => { transaction.createdDate = n.getDateValue(); },
        "id": n => { transaction.id = n.getGuidValue(); },
        "lastModifiedBy": n => { transaction.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { transaction.lastModifiedDate = n.getDateValue(); },
        "lines": n => { transaction.lines = n.getCollectionOfObjectValues<TransactionLine>(createTransactionLineFromDiscriminatorValue); },
        "notes": n => { transaction.notes = n.getStringValue(); },
        "pricePerUnit": n => { transaction.pricePerUnit = n.getNumberValue(); },
        "registrationId": n => { transaction.registrationId = n.getGuidValue(); },
        "registrationReference": n => { transaction.registrationReference = n.getStringValue(); },
        "totalAmount": n => { transaction.totalAmount = n.getNumberValue(); },
        "totalCosts": n => { transaction.totalCosts = n.getNumberValue(); },
        "totalUnits": n => { transaction.totalUnits = n.getNumberValue(); },
        "totalYield": n => { transaction.totalYield = n.getNumberValue(); },
        "transactionDate": n => { transaction.transactionDate = n.getDateOnlyValue(); },
        "transactionReference": n => { transaction.transactionReference = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TransactionLine The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTransactionLine(transactionLine: Partial<TransactionLine> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "amount": n => { transactionLine.amount = n.getNumberValue(); },
        "contractId": n => { transactionLine.contractId = n.getGuidValue(); },
        "contractReference": n => { transactionLine.contractReference = n.getStringValue(); },
        "costs": n => { transactionLine.costs = n.getNumberValue(); },
        "customerEmail": n => { transactionLine.customerEmail = n.getStringValue(); },
        "customerId": n => { transactionLine.customerId = n.getGuidValue(); },
        "customerName": n => { transactionLine.customerName = n.getStringValue(); },
        "customerReference": n => { transactionLine.customerReference = n.getStringValue(); },
        "id": n => { transactionLine.id = n.getGuidValue(); },
        "locationId": n => { transactionLine.locationId = n.getGuidValue(); },
        "meteringPointCity": n => { transactionLine.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { transactionLine.meteringPointEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { transactionLine.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { transactionLine.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { transactionLine.meteringPointStreet = n.getStringValue(); },
        "units": n => { transactionLine.units = n.getNumberValue(); },
        "yield": n => { transactionLine.yield = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TransactionSummary The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTransactionSummary(transactionSummary: Partial<TransactionSummary> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "blockedContractCount": n => { transactionSummary.blockedContractCount = n.getNumberValue(); },
        "contractCount": n => { transactionSummary.contractCount = n.getNumberValue(); },
        "createdBy": n => { transactionSummary.createdBy = n.getStringValue(); },
        "createdDate": n => { transactionSummary.createdDate = n.getDateValue(); },
        "id": n => { transactionSummary.id = n.getGuidValue(); },
        "lastModifiedBy": n => { transactionSummary.lastModifiedBy = n.getStringValue(); },
        "lastModifiedDate": n => { transactionSummary.lastModifiedDate = n.getDateValue(); },
        "pendingContractCount": n => { transactionSummary.pendingContractCount = n.getNumberValue(); },
        "totalAmount": n => { transactionSummary.totalAmount = n.getNumberValue(); },
        "totalCosts": n => { transactionSummary.totalCosts = n.getNumberValue(); },
        "totalUnits": n => { transactionSummary.totalUnits = n.getNumberValue(); },
        "totalYield": n => { transactionSummary.totalYield = n.getNumberValue(); },
        "transactionDate": n => { transactionSummary.transactionDate = n.getDateOnlyValue(); },
        "transactionReference": n => { transactionSummary.transactionReference = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateAccountCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateAccountCommand(updateAccountCommand: Partial<UpdateAccountCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateAccountCommand.id = n.getGuidValue(); },
        "name": n => { updateAccountCommand.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateAffiliateCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateAffiliateCommand(updateAffiliateCommand: Partial<UpdateAffiliateCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateCode": n => { updateAffiliateCommand.affiliateCode = n.getStringValue(); },
        "businessCondition": n => { updateAffiliateCommand.businessCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "consumerCondition": n => { updateAffiliateCommand.consumerCondition = n.getObjectValue<AffiliateTermsDto>(createAffiliateTermsDtoFromDiscriminatorValue); },
        "id": n => { updateAffiliateCommand.id = n.getGuidValue(); },
        "name": n => { updateAffiliateCommand.name = n.getStringValue(); },
        "notes": n => { updateAffiliateCommand.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateChargePointCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateChargePointCommand(updateChargePointCommand: Partial<UpdateChargePointCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "deviceId": n => { updateChargePointCommand.deviceId = n.getStringValue(); },
        "id": n => { updateChargePointCommand.id = n.getGuidValue(); },
        "make": n => { updateChargePointCommand.make = n.getStringValue(); },
        "midMeter": n => { updateChargePointCommand.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { updateChargePointCommand.model = n.getStringValue(); },
        "name": n => { updateChargePointCommand.name = n.getStringValue(); },
        "skipVerification": n => { updateChargePointCommand.skipVerification = n.getBooleanValue(); },
        "verified": n => { updateChargePointCommand.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateChargerDefinitionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateChargerDefinitionCommand(updateChargerDefinitionCommand: Partial<UpdateChargerDefinitionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "chargeType": n => { updateChargerDefinitionCommand.chargeType = n.getEnumValue<ChargeType>(ChargeTypeObject); },
        "datasheetUrl": n => { updateChargerDefinitionCommand.datasheetUrl = n.getStringValue(); },
        "id": n => { updateChargerDefinitionCommand.id = n.getGuidValue(); },
        "make": n => { updateChargerDefinitionCommand.make = n.getStringValue(); },
        "meterMake": n => { updateChargerDefinitionCommand.meterMake = n.getStringValue(); },
        "meterModel": n => { updateChargerDefinitionCommand.meterModel = n.getStringValue(); },
        "midMeter": n => { updateChargerDefinitionCommand.midMeter = n.getEnumValue<MidMeterType>(MidMeterTypeObject); },
        "model": n => { updateChargerDefinitionCommand.model = n.getStringValue(); },
        "notes": n => { updateChargerDefinitionCommand.notes = n.getStringValue(); },
        "source": n => { updateChargerDefinitionCommand.source = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateContractAffiliateConditionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateContractAffiliateConditionCommand(updateContractAffiliateConditionCommand: Partial<UpdateContractAffiliateConditionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { updateContractAffiliateConditionCommand.affiliateId = n.getGuidValue(); },
        "contractId": n => { updateContractAffiliateConditionCommand.contractId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateContractCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateContractCommand(updateContractCommand: Partial<UpdateContractCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateContractCommand.id = n.getGuidValue(); },
        "validFrom": n => { updateContractCommand.validFrom = n.getDateOnlyValue(); },
        "validTo": n => { updateContractCommand.validTo = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateContractCommissionPercentageCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateContractCommissionPercentageCommand(updateContractCommissionPercentageCommand: Partial<UpdateContractCommissionPercentageCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "commissionPercentage": n => { updateContractCommissionPercentageCommand.commissionPercentage = n.getNumberValue(); },
        "contractId": n => { updateContractCommissionPercentageCommand.contractId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateConversionFactorCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateConversionFactorCommand(updateConversionFactorCommand: Partial<UpdateConversionFactorCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expectedErePrice": n => { updateConversionFactorCommand.expectedErePrice = n.getNumberValue(); },
        "id": n => { updateConversionFactorCommand.id = n.getGuidValue(); },
        "netConsumptionFactor": n => { updateConversionFactorCommand.netConsumptionFactor = n.getNumberValue(); },
        "renewableConsumptionFactor": n => { updateConversionFactorCommand.renewableConsumptionFactor = n.getNumberValue(); },
        "year": n => { updateConversionFactorCommand.year = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerAddressCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerAddressCommand(updateCustomerAddressCommand: Partial<UpdateCustomerAddressCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addressType": n => { updateCustomerAddressCommand.addressType = n.getEnumValue<AddressType>(AddressTypeObject); },
        "city": n => { updateCustomerAddressCommand.city = n.getStringValue(); },
        "customerId": n => { updateCustomerAddressCommand.customerId = n.getGuidValue(); },
        "houseNumber": n => { updateCustomerAddressCommand.houseNumber = n.getStringValue(); },
        "postcode": n => { updateCustomerAddressCommand.postcode = n.getStringValue(); },
        "skipAddressVerification": n => { updateCustomerAddressCommand.skipAddressVerification = n.getBooleanValue(); },
        "street": n => { updateCustomerAddressCommand.street = n.getStringValue(); },
        "verified": n => { updateCustomerAddressCommand.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerAffiliateCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerAffiliateCommand(updateCustomerAffiliateCommand: Partial<UpdateCustomerAffiliateCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "affiliateId": n => { updateCustomerAffiliateCommand.affiliateId = n.getGuidValue(); },
        "customerId": n => { updateCustomerAffiliateCommand.customerId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerBankAccountCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerBankAccountCommand(updateCustomerBankAccountCommand: Partial<UpdateCustomerBankAccountCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountHolder": n => { updateCustomerBankAccountCommand.accountHolder = n.getStringValue(); },
        "accountNumber": n => { updateCustomerBankAccountCommand.accountNumber = n.getStringValue(); },
        "customerId": n => { updateCustomerBankAccountCommand.customerId = n.getGuidValue(); },
        "verified": n => { updateCustomerBankAccountCommand.verified = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerCompanyRegistrationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerCompanyRegistrationCommand(updateCustomerCompanyRegistrationCommand: Partial<UpdateCustomerCompanyRegistrationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { updateCustomerCompanyRegistrationCommand.companyName = n.getStringValue(); },
        "companyRegistrationNumber": n => { updateCustomerCompanyRegistrationCommand.companyRegistrationNumber = n.getStringValue(); },
        "customerId": n => { updateCustomerCompanyRegistrationCommand.customerId = n.getGuidValue(); },
        "skipCompanyRegistrationVerification": n => { updateCustomerCompanyRegistrationCommand.skipCompanyRegistrationVerification = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerContactCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerContactCommand(updateCustomerContactCommand: Partial<UpdateCustomerContactCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { updateCustomerContactCommand.customerId = n.getGuidValue(); },
        "email": n => { updateCustomerContactCommand.email = n.getStringValue(); },
        "firstName": n => { updateCustomerContactCommand.firstName = n.getStringValue(); },
        "lastName": n => { updateCustomerContactCommand.lastName = n.getStringValue(); },
        "phone": n => { updateCustomerContactCommand.phone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerNotesCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerNotesCommand(updateCustomerNotesCommand: Partial<UpdateCustomerNotesCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { updateCustomerNotesCommand.customerId = n.getGuidValue(); },
        "notes": n => { updateCustomerNotesCommand.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateCustomerTagsCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateCustomerTagsCommand(updateCustomerTagsCommand: Partial<UpdateCustomerTagsCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "customerId": n => { updateCustomerTagsCommand.customerId = n.getGuidValue(); },
        "tags": n => { updateCustomerTagsCommand.tags = n.getCollectionOfPrimitiveValues<string>("string"); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateDocumentApprovalCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateDocumentApprovalCommand(updateDocumentApprovalCommand: Partial<UpdateDocumentApprovalCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateDocumentApprovalCommand.id = n.getGuidValue(); },
        "rejectionNote": n => { updateDocumentApprovalCommand.rejectionNote = n.getStringValue(); },
        "rejectionReason": n => { updateDocumentApprovalCommand.rejectionReason = n.getEnumValue<RejectionReason>(RejectionReasonObject); },
        "status": n => { updateDocumentApprovalCommand.status = n.getEnumValue<ApprovalStatus>(ApprovalStatusObject); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateLedgerCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateLedgerCommand(updateLedgerCommand: Partial<UpdateLedgerCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateLedgerCommand.id = n.getGuidValue(); },
        "name": n => { updateLedgerCommand.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateLocationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateLocationCommand(updateLocationCommand: Partial<UpdateLocationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "connectionType": n => { updateLocationCommand.connectionType = n.getEnumValue<ConnectionType>(ConnectionTypeObject); },
        "id": n => { updateLocationCommand.id = n.getGuidValue(); },
        "meteringPointCity": n => { updateLocationCommand.meteringPointCity = n.getStringValue(); },
        "meteringPointEanCode": n => { updateLocationCommand.meteringPointEanCode = n.getStringValue(); },
        "meteringPointGridOperator": n => { updateLocationCommand.meteringPointGridOperator = n.getStringValue(); },
        "meteringPointGridOperatorEanCode": n => { updateLocationCommand.meteringPointGridOperatorEanCode = n.getStringValue(); },
        "meteringPointHouseNumber": n => { updateLocationCommand.meteringPointHouseNumber = n.getStringValue(); },
        "meteringPointPostcode": n => { updateLocationCommand.meteringPointPostcode = n.getStringValue(); },
        "meteringPointStreet": n => { updateLocationCommand.meteringPointStreet = n.getStringValue(); },
        "meteringPointVerified": n => { updateLocationCommand.meteringPointVerified = n.getBooleanValue(); },
        "name": n => { updateLocationCommand.name = n.getStringValue(); },
        "skipMeteringPointVerification": n => { updateLocationCommand.skipMeteringPointVerification = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateLocationEssInstallationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateLocationEssInstallationCommand(updateLocationEssInstallationCommand: Partial<UpdateLocationEssInstallationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "capacity": n => { updateLocationEssInstallationCommand.capacity = n.getNumberValue(); },
        "id": n => { updateLocationEssInstallationCommand.id = n.getGuidValue(); },
        "make": n => { updateLocationEssInstallationCommand.make = n.getStringValue(); },
        "model": n => { updateLocationEssInstallationCommand.model = n.getStringValue(); },
        "notes": n => { updateLocationEssInstallationCommand.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateLocationPvInstallationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateLocationPvInstallationCommand(updateLocationPvInstallationCommand: Partial<UpdateLocationPvInstallationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "capacity": n => { updateLocationPvInstallationCommand.capacity = n.getNumberValue(); },
        "id": n => { updateLocationPvInstallationCommand.id = n.getGuidValue(); },
        "make": n => { updateLocationPvInstallationCommand.make = n.getStringValue(); },
        "model": n => { updateLocationPvInstallationCommand.model = n.getStringValue(); },
        "notes": n => { updateLocationPvInstallationCommand.notes = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdatePayoutCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdatePayoutCommand(updatePayoutCommand: Partial<UpdatePayoutCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updatePayoutCommand.id = n.getGuidValue(); },
        "notes": n => { updatePayoutCommand.notes = n.getStringValue(); },
        "payoutDate": n => { updatePayoutCommand.payoutDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateRegistrationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateRegistrationCommand(updateRegistrationCommand: Partial<UpdateRegistrationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateRegistrationCommand.id = n.getGuidValue(); },
        "notes": n => { updateRegistrationCommand.notes = n.getStringValue(); },
        "registrationDate": n => { updateRegistrationCommand.registrationDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsAddressCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsAddressCommand(updateServiceProviderSettingsAddressCommand: Partial<UpdateServiceProviderSettingsAddressCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "city": n => { updateServiceProviderSettingsAddressCommand.city = n.getStringValue(); },
        "houseNumber": n => { updateServiceProviderSettingsAddressCommand.houseNumber = n.getStringValue(); },
        "postcode": n => { updateServiceProviderSettingsAddressCommand.postcode = n.getStringValue(); },
        "street": n => { updateServiceProviderSettingsAddressCommand.street = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsBankAccountCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsBankAccountCommand(updateServiceProviderSettingsBankAccountCommand: Partial<UpdateServiceProviderSettingsBankAccountCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "accountHolder": n => { updateServiceProviderSettingsBankAccountCommand.accountHolder = n.getStringValue(); },
        "accountNumber": n => { updateServiceProviderSettingsBankAccountCommand.accountNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsCompanyRegistrationCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsCompanyRegistrationCommand(updateServiceProviderSettingsCompanyRegistrationCommand: Partial<UpdateServiceProviderSettingsCompanyRegistrationCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "companyName": n => { updateServiceProviderSettingsCompanyRegistrationCommand.companyName = n.getStringValue(); },
        "companyRegistrationNumber": n => { updateServiceProviderSettingsCompanyRegistrationCommand.companyRegistrationNumber = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsContactCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsContactCommand(updateServiceProviderSettingsContactCommand: Partial<UpdateServiceProviderSettingsContactCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { updateServiceProviderSettingsContactCommand.email = n.getStringValue(); },
        "firstName": n => { updateServiceProviderSettingsContactCommand.firstName = n.getStringValue(); },
        "lastName": n => { updateServiceProviderSettingsContactCommand.lastName = n.getStringValue(); },
        "phone": n => { updateServiceProviderSettingsContactCommand.phone = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsPayoutDetailsCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsPayoutDetailsCommand(updateServiceProviderSettingsPayoutDetailsCommand: Partial<UpdateServiceProviderSettingsPayoutDetailsCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "commissionPercentage": n => { updateServiceProviderSettingsPayoutDetailsCommand.commissionPercentage = n.getNumberValue(); },
        "vatPercentage": n => { updateServiceProviderSettingsPayoutDetailsCommand.vatPercentage = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateServiceProviderSettingsSupportEmailCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateServiceProviderSettingsSupportEmailCommand(updateServiceProviderSettingsSupportEmailCommand: Partial<UpdateServiceProviderSettingsSupportEmailCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "supportEmail": n => { updateServiceProviderSettingsSupportEmailCommand.supportEmail = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateTransactionCommand The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateTransactionCommand(updateTransactionCommand: Partial<UpdateTransactionCommand> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { updateTransactionCommand.id = n.getGuidValue(); },
        "notes": n => { updateTransactionCommand.notes = n.getStringValue(); },
        "transactionDate": n => { updateTransactionCommand.transactionDate = n.getDateOnlyValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param YearMandateSigningCount The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoYearMandateSigningCount(yearMandateSigningCount: Partial<YearMandateSigningCount> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "signed": n => { yearMandateSigningCount.signed = n.getNumberValue(); },
        "unsigned": n => { yearMandateSigningCount.unsigned = n.getNumberValue(); },
        "year": n => { yearMandateSigningCount.year = n.getNumberValue(); },
    }
}
export type DeviceIdMatchReason = (typeof DeviceIdMatchReasonObject)[keyof typeof DeviceIdMatchReasonObject];
export interface DocumentChargePoint extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface DocumentRejectionReasons extends AdditionalDataHolder, Parsable {
    /**
     * The reasons property
     */
    reasons?: RejectionReason[] | null;
    /**
     * The type property
     */
    type?: ContractDocumentType | null;
}
export interface DocumentReview extends AdditionalDataHolder, Parsable {
    /**
     * The approvalStatus property
     */
    approvalStatus?: ApprovalStatus | null;
    /**
     * The reviewedBy property
     */
    reviewedBy?: string | null;
    /**
     * The reviewedDate property
     */
    reviewedDate?: Date | null;
}
export interface DocumentSummary extends AdditionalDataHolder, Parsable {
    /**
     * The approvalStatus property
     */
    approvalStatus?: ApprovalStatus | null;
    /**
     * The chargePointId property
     */
    chargePointId?: Guid | null;
    /**
     * The chargePoints property
     */
    chargePoints?: DocumentChargePoint[] | null;
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The fileSize property
     */
    fileSize?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The locationName property
     */
    locationName?: string | null;
    /**
     * The rejectionNote property
     */
    rejectionNote?: string | null;
    /**
     * The rejectionReason property
     */
    rejectionReason?: RejectionReason | null;
    /**
     * The type property
     */
    type?: ContractDocumentType | null;
}
export interface EnqueueBackfillChargerMakesAndModelsResult extends AdditionalDataHolder, Parsable {
    /**
     * The connections property
     */
    connections?: number | null;
}
export interface EnqueueFetchChargePointConsumptionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The provider property
     */
    provider?: OAuthProviderType | null;
    /**
     * The refetch property
     */
    refetch?: boolean | null;
}
export interface EnqueueFetchChargePointConsumptionResult extends AdditionalDataHolder, Parsable {
    /**
     * The fetchedCount property
     */
    fetchedCount?: number | null;
}
export interface FetchChargePointConsumptionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The chargerId property
     */
    chargerId?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The provider property
     */
    provider?: OAuthProviderType | null;
}
export interface FetchChargePointConsumptionResult extends AdditionalDataHolder, Parsable {
    /**
     * The accessDenied property
     */
    accessDenied?: boolean | null;
    /**
     * The consumptionTotal property
     */
    consumptionTotal?: number | null;
    /**
     * The lastIngestedAt property
     */
    lastIngestedAt?: Date | null;
    /**
     * The notConnected property
     */
    notConnected?: boolean | null;
    /**
     * The rateLimited property
     */
    rateLimited?: boolean | null;
    /**
     * The sessionCount property
     */
    sessionCount?: number | null;
    /**
     * The skippedDuplicateCount property
     */
    skippedDuplicateCount?: number | null;
    /**
     * The skippedInvalidCount property
     */
    skippedInvalidCount?: number | null;
}
export type FileType = (typeof FileTypeObject)[keyof typeof FileTypeObject];
export interface IngestAffiliateCustomerOrchestrationResult extends AdditionalDataHolder, Parsable {
    /**
     * The acceptedCount property
     */
    acceptedCount?: number | null;
    /**
     * The customerCount property
     */
    customerCount?: number | null;
    /**
     * The customers property
     */
    customers?: IngestAffiliateCustomerReport[] | null;
    /**
     * The rowCount property
     */
    rowCount?: number | null;
    /**
     * The scheduledCount property
     */
    scheduledCount?: number | null;
    /**
     * The tag property
     */
    tag?: string | null;
}
export type IngestAffiliateCustomerOutcome = (typeof IngestAffiliateCustomerOutcomeObject)[keyof typeof IngestAffiliateCustomerOutcomeObject];
export interface IngestAffiliateCustomerReport extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The outcome property
     */
    outcome?: IngestAffiliateCustomerOutcome | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The rows property
     */
    rows?: number[] | null;
}
export interface IngestBusinessCustomerReport extends AdditionalDataHolder, Parsable {
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The customer property
     */
    customer?: IngestOutcome | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The locations property
     */
    locations?: IngestBusinessLocationReport[] | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The registrationNumber property
     */
    registrationNumber?: string | null;
    /**
     * The rowNumbers property
     */
    rowNumbers?: string[] | null;
    /**
     * The rows property
     */
    rows?: number[] | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
export interface IngestBusinessCustomerWithContractOrchestrationResult extends AdditionalDataHolder, Parsable {
    /**
     * The customerCount property
     */
    customerCount?: number | null;
    /**
     * The customers property
     */
    customers?: IngestBusinessCustomerReport[] | null;
    /**
     * The rowCount property
     */
    rowCount?: number | null;
    /**
     * The scheduledCount property
     */
    scheduledCount?: number | null;
}
export interface IngestBusinessLocationReport extends AdditionalDataHolder, Parsable {
    /**
     * The chargePoints property
     */
    chargePoints?: IngestOutcome | null;
    /**
     * The contract property
     */
    contract?: IngestOutcome | null;
    /**
     * The deviceIds property
     */
    deviceIds?: string[] | null;
    /**
     * The location property
     */
    location?: IngestOutcome | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The row property
     */
    row?: number | null;
    /**
     * The rowNumber property
     */
    rowNumber?: string | null;
}
export interface IngestChargePointReport extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The outcome property
     */
    outcome?: IngestOutcome | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The row property
     */
    row?: number | null;
}
export interface IngestConsumerCustomerReport extends AdditionalDataHolder, Parsable {
    /**
     * The chargePoints property
     */
    chargePoints?: IngestChargePointReport[] | null;
    /**
     * The contract property
     */
    contract?: IngestOutcome | null;
    /**
     * The customer property
     */
    customer?: IngestOutcome | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The legacyCompliancyStatus property
     */
    legacyCompliancyStatus?: LegacyCompliancyStatus | null;
    /**
     * The legacyCustomerId property
     */
    legacyCustomerId?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The rows property
     */
    rows?: number[] | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
export interface IngestConsumerCustomerWithContractOrchestrationResult extends AdditionalDataHolder, Parsable {
    /**
     * The customerCount property
     */
    customerCount?: number | null;
    /**
     * The customers property
     */
    customers?: IngestConsumerCustomerReport[] | null;
    /**
     * The rowCount property
     */
    rowCount?: number | null;
    /**
     * The scheduledCount property
     */
    scheduledCount?: number | null;
}
export interface IngestManualChargePointConsumptionResult extends AdditionalDataHolder, Parsable {
    /**
     * The consumptionTotal property
     */
    consumptionTotal?: number | null;
    /**
     * The customers property
     */
    customers?: IngestManualConsumptionCustomerReport[] | null;
    /**
     * The ingestedCount property
     */
    ingestedCount?: number | null;
    /**
     * The rowCount property
     */
    rowCount?: number | null;
    /**
     * The skippedDuplicateCount property
     */
    skippedDuplicateCount?: number | null;
    /**
     * The skippedInvalidCount property
     */
    skippedInvalidCount?: number | null;
}
export interface IngestManualConsumptionCustomerReport extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The externalCustomerId property
     */
    externalCustomerId?: string | null;
    /**
     * The legacyCustomerId property
     */
    legacyCustomerId?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The readings property
     */
    readings?: IngestManualConsumptionReadingReport[] | null;
}
export interface IngestManualConsumptionReadingReport extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The consumptionId property
     */
    consumptionId?: string | null;
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The notes property
     */
    notes?: string[] | null;
    /**
     * The outcome property
     */
    outcome?: ManualReadingOutcome | null;
    /**
     * The reasons property
     */
    reasons?: string[] | null;
    /**
     * The receivedAt property
     */
    receivedAt?: Date | null;
    /**
     * The row property
     */
    row?: number | null;
    /**
     * The timestamp property
     */
    timestamp?: Date | null;
}
export type IngestOutcome = (typeof IngestOutcomeObject)[keyof typeof IngestOutcomeObject];
export interface Ledger extends AdditionalDataHolder, Parsable {
    /**
     * The accounts property
     */
    accounts?: LedgerAccount[] | null;
    /**
     * The accountsCount property
     */
    accountsCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The currency property
     */
    currency?: CurrencyType | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The totalBalance property
     */
    totalBalance?: number | null;
    /**
     * The totalPendingBalance property
     */
    totalPendingBalance?: number | null;
}
export interface LedgerAccount extends AdditionalDataHolder, Parsable {
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The balance property
     */
    balance?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The customerEmail property
     */
    customerEmail?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The pendingBalance property
     */
    pendingBalance?: number | null;
}
export interface LedgerSummary extends AdditionalDataHolder, Parsable {
    /**
     * The accountsCount property
     */
    accountsCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The currency property
     */
    currency?: CurrencyType | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The totalBalance property
     */
    totalBalance?: number | null;
    /**
     * The totalPendingBalance property
     */
    totalPendingBalance?: number | null;
}
export type LegacyCompliancyStatus = (typeof LegacyCompliancyStatusObject)[keyof typeof LegacyCompliancyStatusObject];
export interface LinkCallToCustomerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The callId property
     */
    callId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The replacePhoneNumber property
     */
    replacePhoneNumber?: boolean | null;
}
export interface Location extends AdditionalDataHolder, Parsable {
    /**
     * The chargePoints property
     */
    chargePoints?: LocationChargePoint[] | null;
    /**
     * The connectionType property
     */
    connectionType?: ConnectionType | null;
    /**
     * The contracts property
     */
    contracts?: LocationContract[] | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The essInstallation property
     */
    essInstallation?: LocationInstallation | null;
    /**
     * The hasEssInstallation property
     */
    hasEssInstallation?: boolean | null;
    /**
     * The hasPvInstallation property
     */
    hasPvInstallation?: boolean | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The meteringPoint property
     */
    meteringPoint?: LocationMeteringPoint | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The pvInstallation property
     */
    pvInstallation?: LocationInstallation | null;
}
export interface LocationAddress extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface LocationChargePoint extends AdditionalDataHolder, Parsable {
    /**
     * The charger property
     */
    charger?: LocationCharger | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface LocationCharger extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface LocationConsumptionWithProjection extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The expectedConsumption property
     */
    expectedConsumption?: number | null;
    /**
     * The expectedPayoutAmount property
     */
    expectedPayoutAmount?: number | null;
    /**
     * The expectedUnits property
     */
    expectedUnits?: number | null;
    /**
     * The expectedYield property
     */
    expectedYield?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The payoutAmount property
     */
    payoutAmount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The projectionDate property
     */
    projectionDate?: DateOnly | null;
    /**
     * The registeredConsumption property
     */
    registeredConsumption?: number | null;
    /**
     * The registeredPayoutAmount property
     */
    registeredPayoutAmount?: number | null;
    /**
     * The registeredTo property
     */
    registeredTo?: DateOnly | null;
    /**
     * The registeredUnits property
     */
    registeredUnits?: number | null;
    /**
     * The registeredYield property
     */
    registeredYield?: number | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export interface LocationContract extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCondition property
     */
    affiliateCondition?: LocationContractAffiliateCondition | null;
    /**
     * The complianceStatus property
     */
    complianceStatus?: ComplianceStatus | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The contractRevokedDate property
     */
    contractRevokedDate?: DateOnly | null;
    /**
     * The contractSignedDate property
     */
    contractSignedDate?: DateOnly | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isEligibleForPayout property
     */
    isEligibleForPayout?: boolean | null;
    /**
     * The isEligibleForRegistration property
     */
    isEligibleForRegistration?: boolean | null;
    /**
     * The isEligibleForTransaction property
     */
    isEligibleForTransaction?: boolean | null;
    /**
     * The mandateRevokedDate property
     */
    mandateRevokedDate?: DateOnly | null;
    /**
     * The mandateSignedDate property
     */
    mandateSignedDate?: DateOnly | null;
    /**
     * The openItems property
     */
    openItems?: ContractComplianceItem[] | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface LocationContractAffiliateCondition extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The discountPercentage property
     */
    discountPercentage?: number | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface LocationInstallation extends AdditionalDataHolder, Parsable {
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface LocationMeteringPoint extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: LocationAddress | null;
    /**
     * The eanCode property
     */
    eanCode?: string | null;
    /**
     * The gridOperator property
     */
    gridOperator?: string | null;
    /**
     * The gridOperatorEanCode property
     */
    gridOperatorEanCode?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface LocationSummary extends AdditionalDataHolder, Parsable {
    /**
     * The chargePointCount property
     */
    chargePointCount?: number | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The currentContractId property
     */
    currentContractId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The hasEssInstallation property
     */
    hasEssInstallation?: boolean | null;
    /**
     * The hasPvInstallation property
     */
    hasPvInstallation?: boolean | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The meteringPoint property
     */
    meteringPoint?: LocationSummaryMeteringPoint | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The pendingChargePointCount property
     */
    pendingChargePointCount?: number | null;
}
export interface LocationSummaryAddress extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface LocationSummaryMeteringPoint extends AdditionalDataHolder, Parsable {
    /**
     * The address property
     */
    address?: LocationSummaryAddress | null;
    /**
     * The eanCode property
     */
    eanCode?: string | null;
    /**
     * The gridOperator property
     */
    gridOperator?: string | null;
    /**
     * The gridOperatorEanCode property
     */
    gridOperatorEanCode?: string | null;
    /**
     * The verificationStatus property
     */
    verificationStatus?: VerificationStatus | null;
}
export interface MandateSigningCount extends AdditionalDataHolder, Parsable {
    /**
     * The years property
     */
    years?: YearMandateSigningCount[] | null;
}
export interface ManualConsumptionEntry extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The provider property
     */
    provider?: ConsumptionProvider | null;
    /**
     * The receivedAt property
     */
    receivedAt?: Date | null;
    /**
     * The source property
     */
    source?: ConsumptionSource | null;
    /**
     * The superseded property
     */
    superseded?: boolean | null;
    /**
     * The timestamp property
     */
    timestamp?: Date | null;
}
export type ManualReadingOutcome = (typeof ManualReadingOutcomeObject)[keyof typeof ManualReadingOutcomeObject];
export interface MessageDetail extends AdditionalDataHolder, Parsable {
    /**
     * The bodyAvailable property
     */
    bodyAvailable?: boolean | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The htmlBody property
     */
    htmlBody?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The recipient property
     */
    recipient?: string | null;
    /**
     * The sentDate property
     */
    sentDate?: Date | null;
    /**
     * The subject property
     */
    subject?: string | null;
    /**
     * The textBody property
     */
    textBody?: string | null;
}
export interface MessageSummary extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The recipient property
     */
    recipient?: string | null;
    /**
     * The sentDate property
     */
    sentDate?: Date | null;
    /**
     * The subject property
     */
    subject?: string | null;
}
export interface MeteringPointSummary extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The eanCode property
     */
    eanCode?: string | null;
    /**
     * The gridOperator property
     */
    gridOperator?: string | null;
    /**
     * The gridOperatorEanCode property
     */
    gridOperatorEanCode?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The specialMeteringPoint property
     */
    specialMeteringPoint?: boolean | null;
    /**
     * The street property
     */
    street?: string | null;
}
export type MidMeterType = (typeof MidMeterTypeObject)[keyof typeof MidMeterTypeObject];
export interface MoveChargePointCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
}
export interface OAuthConnectionCharger extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The isActive property
     */
    isActive?: boolean | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export type OAuthProviderType = (typeof OAuthProviderTypeObject)[keyof typeof OAuthProviderTypeObject];
export type OfficeType = (typeof OfficeTypeObject)[keyof typeof OfficeTypeObject];
export interface PaginatedListOfAccountEntrySummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: AccountEntrySummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfAccountSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: AccountSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfAffiliateSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: AffiliateSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfAuditEntrySummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: AuditEntrySummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfCallSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: CallSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfChargePointSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ChargePointSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfChargerDefinitionSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ChargerDefinitionSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfContractListItem extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ContractListItem[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfContractSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ContractSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfConversionFactorSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ConversionFactorSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfCustomerSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: CustomerSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfDocumentSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: DocumentSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfLedgerSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: LedgerSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfLocationSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: LocationSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfMessageSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: MessageSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfPayoutSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: PayoutSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfRegistrationSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: RegistrationSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedListOfTransactionSummary extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: TransactionSummary[] | null;
    /**
     * The pageNumber property
     */
    pageNumber?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface Payout extends AdditionalDataHolder, Parsable {
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The lines property
     */
    lines?: PayoutLine[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The payoutDate property
     */
    payoutDate?: DateOnly | null;
    /**
     * The payoutReference property
     */
    payoutReference?: string | null;
    /**
     * The totalAmount property
     */
    totalAmount?: number | null;
    /**
     * The totalCommission property
     */
    totalCommission?: number | null;
    /**
     * The totalDiscount property
     */
    totalDiscount?: number | null;
    /**
     * The totalNetYield property
     */
    totalNetYield?: number | null;
    /**
     * The transactionId property
     */
    transactionId?: Guid | null;
    /**
     * The transactionReference property
     */
    transactionReference?: string | null;
}
export interface PayoutLine extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The commission property
     */
    commission?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The customerEmail property
     */
    customerEmail?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The discount property
     */
    discount?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The netYield property
     */
    netYield?: number | null;
    /**
     * The percentage property
     */
    percentage?: number | null;
}
export interface PayoutSummary extends AdditionalDataHolder, Parsable {
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The payoutDate property
     */
    payoutDate?: DateOnly | null;
    /**
     * The payoutReference property
     */
    payoutReference?: string | null;
    /**
     * The totalAmount property
     */
    totalAmount?: number | null;
    /**
     * The totalCommission property
     */
    totalCommission?: number | null;
    /**
     * The totalDiscount property
     */
    totalDiscount?: number | null;
    /**
     * The totalNetYield property
     */
    totalNetYield?: number | null;
}
/**
 * RFC 9457 problem details.
 */
export interface ProblemDetails extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The detail property
     */
    detail?: string | null;
    /**
     * The validation failures, keyed by field. Only on urn:zeres:problem:validation.
     */
    errors?: ProblemDetails_errors | null;
    /**
     * The instance property
     */
    instance?: string | null;
    /**
     * The status property
     */
    status?: number | null;
    /**
     * The title property
     */
    title?: string | null;
    /**
     * The traceId property
     */
    traceId?: string | null;
    /**
     * The rule the request broke. Match on this value; it never changes once published.| type | status | title ||---|---|---|| `urn:zeres:problem:day-outside-contract-validity` | 400 | The day lies outside the contract's validity. || `urn:zeres:problem:import-file-unreadable` | 400 | The import file does not have the layout the import reads. || `urn:zeres:problem:invalid-phone-number` | 400 | The phone number is not valid. || `urn:zeres:problem:payout-percentage-exceeds-remainder` | 400 | The payout percentage exceeds what is left on the transaction. || `urn:zeres:problem:rejection-reason-not-fitting-type` | 400 | The rejection reason does not fit the document's type. || `urn:zeres:problem:revoked-date-out-of-range` | 400 | The revocation date lies outside the allowed range. || `urn:zeres:problem:validation` | 400 | One or more fields are invalid. || `urn:zeres:problem:unauthorized` | 401 | The request is not signed in. || `urn:zeres:problem:data-sharing-revoked` | 403 | The customer's data sharing grant for this application is revoked. || `urn:zeres:problem:forbidden` | 403 | The signed-in user may not perform this action. || `urn:zeres:problem:address-not-found` | 404 | No address exists for the postcode and house number. || `urn:zeres:problem:company-registration-not-found` | 404 | No company registration was found. || `urn:zeres:problem:conformity-statement-not-found` | 404 | The charger definition has no conformity statement. || `urn:zeres:problem:not-found` | 404 | The resource was not found. || `urn:zeres:problem:affiliate-condition-exceeds-commission` | 409 | The affiliate's discount and kickback together exceed the contract's commission. || `urn:zeres:problem:affiliate-has-customers` | 409 | The affiliate cannot be deleted while customers have it. || `urn:zeres:problem:affiliate-not-offered-for-customer-type` | 409 | The affiliate offers no condition for this customer type. || `urn:zeres:problem:affiliate-terms-in-use` | 409 | Customers still use the affiliate terms being withdrawn. || `urn:zeres:problem:cannot-remove-ocpp-connection` | 409 | The OCPP connection cannot be removed. || `urn:zeres:problem:charge-point-has-registered-consumption` | 409 | The charge point's consumption is registered on the location it moved from. || `urn:zeres:problem:charge-point-has-registrations` | 409 | The charge point cannot be deleted while its contract has registrations. || `urn:zeres:problem:charge-point-move-loses-registration` | 409 | The charge point's move would leave consumption unregistered. || `urn:zeres:problem:charger-not-fetchable` | 409 | The charger has no authorization that delivers its sessions. || `urn:zeres:problem:commission-has-payouts` | 409 | The contract's commission cannot be changed while payouts reference it. || `urn:zeres:problem:consumption-already-registered` | 409 | The consumption is already registered. || `urn:zeres:problem:consumption-period-overlap` | 409 | A consumption input already covers part of this period. || `urn:zeres:problem:contract-has-payouts` | 409 | The contract cannot be deleted while payouts reference it. || `urn:zeres:problem:contract-has-registrations` | 409 | The contract cannot be deleted while registrations reference it. || `urn:zeres:problem:contract-has-transactions` | 409 | The contract cannot be deleted while transactions reference it. || `urn:zeres:problem:contract-not-signable` | 409 | Only a business customer signs the contract. || `urn:zeres:problem:contract-not-signed` | 409 | The contract is not signed. || `urn:zeres:problem:contract-overlaps` | 409 | Another contract on the location covers part of this period. || `urn:zeres:problem:contract-signed` | 409 | A signed contract can no longer be changed. || `urn:zeres:problem:contract-signing-revoked` | 409 | The contract signing is already revoked. || `urn:zeres:problem:conversion-factor-exists` | 409 | There is already a conversion factor for this year. || `urn:zeres:problem:conversion-factor-has-registrations` | 409 | The conversion factor of a year with registrations cannot be deleted or moved. || `urn:zeres:problem:customer-already-business` | 409 | The customer is already a business customer. || `urn:zeres:problem:customer-already-consumer` | 409 | The customer is already a consumer customer. || `urn:zeres:problem:customer-company-registration-exists` | 409 | A business customer with this KvK number already exists. || `urn:zeres:problem:customer-email-exists` | 409 | A customer with this e-mail address already exists. || `urn:zeres:problem:customer-has-active-signing` | 409 | The customer cannot be converted while a contract has an active signing. || `urn:zeres:problem:customer-has-signed-mandate` | 409 | The customer cannot be converted while a contract has a signed mandate. || `urn:zeres:problem:data-sharing-grant-exists` | 409 | The customer already holds a data sharing grant for this application. || `urn:zeres:problem:device-id-has-authorization` | 409 | The charge point's device id cannot change while the customer authorized it. || `urn:zeres:problem:device-id-on-another-customer` | 409 | The device is registered on another customer's location. || `urn:zeres:problem:device-id-under-multiple-contracts` | 409 | The device is under more than one contract for the same period. || `urn:zeres:problem:document-approved` | 409 | An approved document cannot be deleted. || `urn:zeres:problem:document-exists` | 409 | The owner already holds a document of this type. || `urn:zeres:problem:document-signed-not-associable` | 409 | A contract or mandate keeps the association its signing gave it. || `urn:zeres:problem:duplicate-charge-point` | 409 | The location already has a charge point for this device. || `urn:zeres:problem:installation-on-consumer-location` | 409 | Installations can only be recorded on a business customer's location. || `urn:zeres:problem:last-contract-on-location` | 409 | The only contract on a location cannot be deleted. || `urn:zeres:problem:ledger-has-accounts` | 409 | The ledger cannot be deleted while accounts are booked on it. || `urn:zeres:problem:mandate-not-signed` | 409 | The mandate is not signed. || `urn:zeres:problem:mandate-signed` | 409 | A signed mandate can no longer be changed. || `urn:zeres:problem:mandate-signing-revoked` | 409 | The mandate signing is already revoked. || `urn:zeres:problem:manual-consumption-not-allowed` | 409 | The charge point reports its consumption automatically. || `urn:zeres:problem:metering-point-under-contract` | 409 | The metering point is already under another contract for this period. || `urn:zeres:problem:no-contracts-to-pay-out` | 409 | No contract on the transaction is left to pay out. || `urn:zeres:problem:no-contracts-to-sell` | 409 | No contract on the registration is left to sell. || `urn:zeres:problem:payout-has-later-payout` | 409 | A later payout settles the same transaction. || `urn:zeres:problem:reading-has-later-reading` | 409 | A later reading follows the one being removed. || `urn:zeres:problem:registration-has-transactions` | 409 | The registration cannot be deleted while a transaction sells its units. || `urn:zeres:problem:service-provider-settings-not-set-up` | 409 | The service provider settings are not set up. || `urn:zeres:problem:transaction-has-payouts` | 409 | The transaction cannot be deleted while a payout settles it. || `urn:zeres:problem:analytics-unavailable` | 502 | The analytics store is unavailable. || `urn:zeres:problem:email-archive-unavailable` | 502 | The mail archive is unavailable. || `urn:zeres:problem:email-not-retried` | 502 | The mail provider did not confirm the mail. || `urn:zeres:problem:telemetry-unavailable` | 502 | The telemetry store is unavailable. || `urn:zeres:problem:provider-rate-limited` | 503 | The vendor connection is busy. |A type outside this list, such as the framework's rfc9110 link on an unexpected 500, is an error without a specific rule.
     */
    type?: string | null;
}
/**
 * The validation failures, keyed by field. Only on urn:zeres:problem:validation.
 */
export interface ProblemDetails_errors extends AdditionalDataHolder, Parsable {
}
export interface ProlongContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface Registration extends AdditionalDataHolder, Parsable {
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The lines property
     */
    lines?: RegistrationLine[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The registrationDate property
     */
    registrationDate?: DateOnly | null;
    /**
     * The registrationReference property
     */
    registrationReference?: string | null;
    /**
     * The totalConsumption property
     */
    totalConsumption?: number | null;
    /**
     * The totalUnits property
     */
    totalUnits?: number | null;
}
export interface RegistrationLine extends AdditionalDataHolder, Parsable {
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The consumptionType property
     */
    consumptionType?: ConsumptionType | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The customerEmail property
     */
    customerEmail?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The units property
     */
    units?: number | null;
}
export interface RegistrationSummary extends AdditionalDataHolder, Parsable {
    /**
     * The blockedContractCount property
     */
    blockedContractCount?: number | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The pendingContractCount property
     */
    pendingContractCount?: number | null;
    /**
     * The periodFrom property
     */
    periodFrom?: DateOnly | null;
    /**
     * The periodTo property
     */
    periodTo?: DateOnly | null;
    /**
     * The registrationDate property
     */
    registrationDate?: DateOnly | null;
    /**
     * The registrationReference property
     */
    registrationReference?: string | null;
    /**
     * The totalConsumption property
     */
    totalConsumption?: number | null;
    /**
     * The totalUnits property
     */
    totalUnits?: number | null;
}
export type RejectionReason = (typeof RejectionReasonObject)[keyof typeof RejectionReasonObject];
export interface RevokeContractSigningCommand extends AdditionalDataHolder, Parsable {
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The revokedDate property
     */
    revokedDate?: DateOnly | null;
}
export interface RevokeMandateSigningCommand extends AdditionalDataHolder, Parsable {
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The revokedDate property
     */
    revokedDate?: DateOnly | null;
}
/**
 * Serializes information the current object
 * @param Account The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccount(writer: SerializationWriter, account: Partial<Account> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!account || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountNumber", account.accountNumber);
    writer.writeObjectValue<AccountBalance>("balance", account.balance, serializeAccountBalance);
    writer.writeStringValue("createdBy", account.createdBy);
    writer.writeDateValue("createdDate", account.createdDate);
    writer.writeGuidValue("id", account.id);
    writer.writeStringValue("lastModifiedBy", account.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", account.lastModifiedDate);
    writer.writeGuidValue("ledgerId", account.ledgerId);
    writer.writeStringValue("ledgerName", account.ledgerName);
    writer.writeStringValue("name", account.name);
    writer.writeAdditionalData(account.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountBalance The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountBalance(writer: SerializationWriter, accountBalance: Partial<AccountBalance> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountBalance || isSerializingDerivedType) { return; }
    writer.writeNumberValue("balance", accountBalance.balance);
    writer.writeNumberValue("creditsCount", accountBalance.creditsCount);
    writer.writeDateValue("date", accountBalance.date);
    writer.writeNumberValue("debitsCount", accountBalance.debitsCount);
    writer.writeNumberValue("pendingBalance", accountBalance.pendingBalance);
    writer.writeNumberValue("pendingCreditsCount", accountBalance.pendingCreditsCount);
    writer.writeNumberValue("pendingDebitsCount", accountBalance.pendingDebitsCount);
    writer.writeAdditionalData(accountBalance.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountEntrySummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountEntrySummary(writer: SerializationWriter, accountEntrySummary: Partial<AccountEntrySummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountEntrySummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", accountEntrySummary.amount);
    writer.writeDateValue("committedDate", accountEntrySummary.committedDate);
    writer.writeStringValue("createdBy", accountEntrySummary.createdBy);
    writer.writeDateValue("createdDate", accountEntrySummary.createdDate);
    writer.writeStringValue("description", accountEntrySummary.description);
    writer.writeGuidValue("id", accountEntrySummary.id);
    writer.writeBooleanValue("isCommitted", accountEntrySummary.isCommitted);
    writer.writeStringValue("lastModifiedBy", accountEntrySummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", accountEntrySummary.lastModifiedDate);
    writer.writeGuidValue("precededBy", accountEntrySummary.precededBy);
    writer.writeEnumValue<AccountEntryType>("type", accountEntrySummary.type);
    writer.writeAdditionalData(accountEntrySummary.additionalData);
}
/**
 * Serializes information the current object
 * @param AccountSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAccountSummary(writer: SerializationWriter, accountSummary: Partial<AccountSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!accountSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountNumber", accountSummary.accountNumber);
    writer.writeNumberValue("balance", accountSummary.balance);
    writer.writeStringValue("createdBy", accountSummary.createdBy);
    writer.writeDateValue("createdDate", accountSummary.createdDate);
    writer.writeGuidValue("id", accountSummary.id);
    writer.writeStringValue("lastModifiedBy", accountSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", accountSummary.lastModifiedDate);
    writer.writeStringValue("name", accountSummary.name);
    writer.writeNumberValue("pendingBalance", accountSummary.pendingBalance);
    writer.writeNumberValue("pendingCreditsCount", accountSummary.pendingCreditsCount);
    writer.writeNumberValue("pendingDebitsCount", accountSummary.pendingDebitsCount);
    writer.writeAdditionalData(accountSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ActiveCustomersInPeriod The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeActiveCustomersInPeriod(writer: SerializationWriter, activeCustomersInPeriod: Partial<ActiveCustomersInPeriod> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!activeCustomersInPeriod || isSerializingDerivedType) { return; }
    writer.writeNumberValue("activeCustomers", activeCustomersInPeriod.activeCustomers);
    writer.writeDateOnlyValue("periodStart", activeCustomersInPeriod.periodStart);
    writer.writeAdditionalData(activeCustomersInPeriod.additionalData);
}
/**
 * Serializes information the current object
 * @param AddBackDatedChargePointConsumptionCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddBackDatedChargePointConsumptionCommand(writer: SerializationWriter, addBackDatedChargePointConsumptionCommand: Partial<AddBackDatedChargePointConsumptionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!addBackDatedChargePointConsumptionCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", addBackDatedChargePointConsumptionCommand.consumption);
    writer.writeDateOnlyValue("consumptionDate", addBackDatedChargePointConsumptionCommand.consumptionDate);
    writer.writeGuidValue("id", addBackDatedChargePointConsumptionCommand.id);
    writer.writeAdditionalData(addBackDatedChargePointConsumptionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param AddCreditCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddCreditCommand(writer: SerializationWriter, addCreditCommand: Partial<AddCreditCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!addCreditCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", addCreditCommand.amount);
    writer.writeStringValue("description", addCreditCommand.description);
    writer.writeGuidValue("id", addCreditCommand.id);
    writer.writeBooleanValue("isCommitted", addCreditCommand.isCommitted);
    writer.writeAdditionalData(addCreditCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param AddDebitCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddDebitCommand(writer: SerializationWriter, addDebitCommand: Partial<AddDebitCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!addDebitCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", addDebitCommand.amount);
    writer.writeStringValue("description", addDebitCommand.description);
    writer.writeGuidValue("id", addDebitCommand.id);
    writer.writeBooleanValue("isCommitted", addDebitCommand.isCommitted);
    writer.writeAdditionalData(addDebitCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param AddressSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddressSummary(writer: SerializationWriter, addressSummary: Partial<AddressSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!addressSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", addressSummary.city);
    writer.writeStringValue("houseNumber", addressSummary.houseNumber);
    writer.writeStringValue("postcode", addressSummary.postcode);
    writer.writeStringValue("province", addressSummary.province);
    writer.writeStringValue("street", addressSummary.street);
    writer.writeAdditionalData(addressSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param Affiliate The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAffiliate(writer: SerializationWriter, affiliate: Partial<Affiliate> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!affiliate || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", affiliate.affiliateCode);
    writer.writeObjectValue<AffiliateTermsDto>("businessCondition", affiliate.businessCondition, serializeAffiliateTermsDto);
    writer.writeObjectValue<AffiliateTermsDto>("consumerCondition", affiliate.consumerCondition, serializeAffiliateTermsDto);
    writer.writeStringValue("createdBy", affiliate.createdBy);
    writer.writeDateValue("createdDate", affiliate.createdDate);
    writer.writeGuidValue("id", affiliate.id);
    writer.writeStringValue("lastModifiedBy", affiliate.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", affiliate.lastModifiedDate);
    writer.writeStringValue("name", affiliate.name);
    writer.writeStringValue("notes", affiliate.notes);
    writer.writeAdditionalData(affiliate.additionalData);
}
/**
 * Serializes information the current object
 * @param AffiliateContractCount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAffiliateContractCount(writer: SerializationWriter, affiliateContractCount: Partial<AffiliateContractCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!affiliateContractCount || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", affiliateContractCount.affiliateCode);
    writer.writeNumberValue("contracts", affiliateContractCount.contracts);
    writer.writeAdditionalData(affiliateContractCount.additionalData);
}
/**
 * Serializes information the current object
 * @param AffiliateSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAffiliateSummary(writer: SerializationWriter, affiliateSummary: Partial<AffiliateSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!affiliateSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", affiliateSummary.affiliateCode);
    writer.writeObjectValue<AffiliateTermsDto>("businessCondition", affiliateSummary.businessCondition, serializeAffiliateTermsDto);
    writer.writeObjectValue<AffiliateTermsDto>("consumerCondition", affiliateSummary.consumerCondition, serializeAffiliateTermsDto);
    writer.writeNumberValue("contractCount", affiliateSummary.contractCount);
    writer.writeStringValue("createdBy", affiliateSummary.createdBy);
    writer.writeDateValue("createdDate", affiliateSummary.createdDate);
    writer.writeGuidValue("id", affiliateSummary.id);
    writer.writeStringValue("lastModifiedBy", affiliateSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", affiliateSummary.lastModifiedDate);
    writer.writeStringValue("name", affiliateSummary.name);
    writer.writeStringValue("notes", affiliateSummary.notes);
    writer.writeAdditionalData(affiliateSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param AffiliateTermsDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAffiliateTermsDto(writer: SerializationWriter, affiliateTermsDto: Partial<AffiliateTermsDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!affiliateTermsDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("discountPercentage", affiliateTermsDto.discountPercentage);
    writer.writeNumberValue("kickbackPercentage", affiliateTermsDto.kickbackPercentage);
    writer.writeAdditionalData(affiliateTermsDto.additionalData);
}
/**
 * Serializes information the current object
 * @param AssociateDocumentCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAssociateDocumentCommand(writer: SerializationWriter, associateDocumentCommand: Partial<AssociateDocumentCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!associateDocumentCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("chargePointId", associateDocumentCommand.chargePointId);
    writer.writeGuidValue("contractId", associateDocumentCommand.contractId);
    writer.writeGuidValue("id", associateDocumentCommand.id);
    writer.writeGuidValue("locationId", associateDocumentCommand.locationId);
    writer.writeEnumValue<ContractDocumentType>("type", associateDocumentCommand.type);
    writer.writeAdditionalData(associateDocumentCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param AuditEntrySummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuditEntrySummary(writer: SerializationWriter, auditEntrySummary: Partial<AuditEntrySummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!auditEntrySummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("action", auditEntrySummary.action);
    writer.writeEnumValue<AuditEntryType>("auditEntryType", auditEntrySummary.auditEntryType);
    writer.writeCollectionOfPrimitiveValues<string>("changedColumns", auditEntrySummary.changedColumns);
    writer.writeGuidValue("correlationId", auditEntrySummary.correlationId);
    writer.writeGuidValue("id", auditEntrySummary.id);
    writer.writeObjectValue<AuditEntrySummary_newValues>("newValues", auditEntrySummary.newValues, serializeAuditEntrySummary_newValues);
    writer.writeObjectValue<AuditEntrySummary_oldValues>("oldValues", auditEntrySummary.oldValues, serializeAuditEntrySummary_oldValues);
    writer.writeDateValue("timestamp", auditEntrySummary.timestamp);
    writer.writeStringValue("userName", auditEntrySummary.userName);
    writer.writeAdditionalData(auditEntrySummary.additionalData);
}
/**
 * Serializes information the current object
 * @param AuditEntrySummary_newValues The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuditEntrySummary_newValues(writer: SerializationWriter, auditEntrySummary_newValues: Partial<AuditEntrySummary_newValues> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!auditEntrySummary_newValues || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(auditEntrySummary_newValues.additionalData);
}
/**
 * Serializes information the current object
 * @param AuditEntrySummary_oldValues The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAuditEntrySummary_oldValues(writer: SerializationWriter, auditEntrySummary_oldValues: Partial<AuditEntrySummary_oldValues> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!auditEntrySummary_oldValues || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(auditEntrySummary_oldValues.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillCallCustomersResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillCallCustomersResult(writer: SerializationWriter, backfillCallCustomersResult: Partial<BackfillCallCustomersResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillCallCustomersResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("ambiguous", backfillCallCustomersResult.ambiguous);
    writer.writeNumberValue("answered", backfillCallCustomersResult.answered);
    writer.writeNumberValue("linked", backfillCallCustomersResult.linked);
    writer.writeNumberValue("unmatched", backfillCallCustomersResult.unmatched);
    writer.writeAdditionalData(backfillCallCustomersResult.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillChargePointDeviceIdLine The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillChargePointDeviceIdLine(writer: SerializationWriter, backfillChargePointDeviceIdLine: Partial<BackfillChargePointDeviceIdLine> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillChargePointDeviceIdLine || isSerializingDerivedType) { return; }
    writer.writeGuidValue("chargePointId", backfillChargePointDeviceIdLine.chargePointId);
    writer.writeStringValue("chargerName", backfillChargePointDeviceIdLine.chargerName);
    writer.writeStringValue("deviceId", backfillChargePointDeviceIdLine.deviceId);
    writer.writeStringValue("externalCustomerId", backfillChargePointDeviceIdLine.externalCustomerId);
    writer.writeStringValue("make", backfillChargePointDeviceIdLine.make);
    writer.writeStringValue("model", backfillChargePointDeviceIdLine.model);
    writer.writeEnumValue<BackfillChargePointDeviceIdOutcome>("outcome", backfillChargePointDeviceIdLine.outcome);
    writer.writeStringValue("previousDeviceId", backfillChargePointDeviceIdLine.previousDeviceId);
    writer.writeEnumValue<DeviceIdMatchReason>("reason", backfillChargePointDeviceIdLine.reason);
    writer.writeAdditionalData(backfillChargePointDeviceIdLine.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillChargePointDeviceIdsCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillChargePointDeviceIdsCommand(writer: SerializationWriter, backfillChargePointDeviceIdsCommand: Partial<BackfillChargePointDeviceIdsCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillChargePointDeviceIdsCommand || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("dryRun", backfillChargePointDeviceIdsCommand.dryRun);
    writer.writeEnumValue<OAuthProviderType>("provider", backfillChargePointDeviceIdsCommand.provider);
    writer.writeAdditionalData(backfillChargePointDeviceIdsCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillChargePointDeviceIdsResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillChargePointDeviceIdsResult(writer: SerializationWriter, backfillChargePointDeviceIdsResult: Partial<BackfillChargePointDeviceIdsResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillChargePointDeviceIdsResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("alreadyCorrect", backfillChargePointDeviceIdsResult.alreadyCorrect);
    writer.writeNumberValue("conflict", backfillChargePointDeviceIdsResult.conflict);
    writer.writeNumberValue("fixed", backfillChargePointDeviceIdsResult.fixed);
    writer.writeCollectionOfObjectValues<BackfillChargePointDeviceIdLine>("lines", backfillChargePointDeviceIdsResult.lines, serializeBackfillChargePointDeviceIdLine);
    writer.writeNumberValue("undecided", backfillChargePointDeviceIdsResult.undecided);
    writer.writeAdditionalData(backfillChargePointDeviceIdsResult.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillChargerDefinitionLinksCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillChargerDefinitionLinksCommand(writer: SerializationWriter, backfillChargerDefinitionLinksCommand: Partial<BackfillChargerDefinitionLinksCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillChargerDefinitionLinksCommand || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("dryRun", backfillChargerDefinitionLinksCommand.dryRun ?? true);
    writer.writeAdditionalData(backfillChargerDefinitionLinksCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillChargerDefinitionLinksResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillChargerDefinitionLinksResult(writer: SerializationWriter, backfillChargerDefinitionLinksResult: Partial<BackfillChargerDefinitionLinksResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillChargerDefinitionLinksResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("linked", backfillChargerDefinitionLinksResult.linked);
    writer.writeNumberValue("midMeterChanged", backfillChargerDefinitionLinksResult.midMeterChanged);
    writer.writeNumberValue("withoutDefinition", backfillChargerDefinitionLinksResult.withoutDefinition);
    writer.writeAdditionalData(backfillChargerDefinitionLinksResult.additionalData);
}
/**
 * Serializes information the current object
 * @param BackfillSessionDatesResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBackfillSessionDatesResult(writer: SerializationWriter, backfillSessionDatesResult: Partial<BackfillSessionDatesResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!backfillSessionDatesResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("ambiguous", backfillSessionDatesResult.ambiguous);
    writer.writeNumberValue("filled", backfillSessionDatesResult.filled);
    writer.writeNumberValue("skipped", backfillSessionDatesResult.skipped);
    writer.writeAdditionalData(backfillSessionDatesResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CallAnswerer The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCallAnswerer(writer: SerializationWriter, callAnswerer: Partial<CallAnswerer> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!callAnswerer || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", callAnswerer.email);
    writer.writeStringValue("name", callAnswerer.name);
    writer.writeAdditionalData(callAnswerer.additionalData);
}
/**
 * Serializes information the current object
 * @param CallLineSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCallLineSummary(writer: SerializationWriter, callLineSummary: Partial<CallLineSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!callLineSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", callLineSummary.name);
    writer.writeStringValue("number", callLineSummary.number);
    writer.writeAdditionalData(callLineSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param CallSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCallSummary(writer: SerializationWriter, callSummary: Partial<CallSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!callSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("answeredBy", callSummary.answeredBy);
    writer.writeStringValue("calledBy", callSummary.calledBy);
    writer.writeStringValue("calledNumber", callSummary.calledNumber);
    writer.writeGuidValue("customerId", callSummary.customerId);
    writer.writeStringValue("customerName", callSummary.customerName);
    writer.writeEnumValue<CallDirection>("direction", callSummary.direction);
    writer.writeStringValue("duration", callSummary.duration);
    writer.writeDateValue("endedDate", callSummary.endedDate);
    writer.writeGuidValue("id", callSummary.id);
    writer.writeBooleanValue("isActive", callSummary.isActive);
    writer.writeStringValue("lineName", callSummary.lineName);
    writer.writeStringValue("phoneNumber", callSummary.phoneNumber);
    writer.writeDateValue("receivedDate", callSummary.receivedDate);
    writer.writeAdditionalData(callSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param CancelPendingEntriesCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCancelPendingEntriesCommand(writer: SerializationWriter, cancelPendingEntriesCommand: Partial<CancelPendingEntriesCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cancelPendingEntriesCommand || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<Guid>("entries", cancelPendingEntriesCommand.entries);
    writer.writeGuidValue("id", cancelPendingEntriesCommand.id);
    writer.writeAdditionalData(cancelPendingEntriesCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePoint The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePoint(writer: SerializationWriter, chargePoint: Partial<ChargePoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePoint || isSerializingDerivedType) { return; }
    writer.writeObjectValue<Charger>("charger", chargePoint.charger, serializeCharger);
    writer.writeStringValue("createdBy", chargePoint.createdBy);
    writer.writeDateValue("createdDate", chargePoint.createdDate);
    writer.writeGuidValue("id", chargePoint.id);
    writer.writeStringValue("lastModifiedBy", chargePoint.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", chargePoint.lastModifiedDate);
    writer.writeGuidValue("locationId", chargePoint.locationId);
    writer.writeStringValue("name", chargePoint.name);
    writer.writeAdditionalData(chargePoint.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointConnection The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointConnection(writer: SerializationWriter, chargePointConnection: Partial<ChargePointConnection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointConnection || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("actionRequired", chargePointConnection.actionRequired);
    writer.writeStringValue("chargerId", chargePointConnection.chargerId);
    writer.writeDateValue("connectedAt", chargePointConnection.connectedAt);
    writer.writeDateOnlyValue("connectedDate", chargePointConnection.connectedDate);
    writer.writeBooleanValue("deviceIdLocked", chargePointConnection.deviceIdLocked);
    writer.writeDateValue("firstSessionDate", chargePointConnection.firstSessionDate);
    writer.writeDateValue("lastFetchedDate", chargePointConnection.lastFetchedDate);
    writer.writeDateValue("lastSessionDate", chargePointConnection.lastSessionDate);
    writer.writeEnumValue<ConsumptionProvider>("provider", chargePointConnection.provider);
    writer.writeStringValue("reason", chargePointConnection.reason);
    writer.writeEnumValue<ConsumptionSource>("source", chargePointConnection.source);
    writer.writeEnumValue<ChargerConnectionStatus>("status", chargePointConnection.status);
    writer.writeDateValue("statusDate", chargePointConnection.statusDate);
    writer.writeAdditionalData(chargePointConnection.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointConsumption The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointConsumption(writer: SerializationWriter, chargePointConsumption: Partial<ChargePointConsumption> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointConsumption || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", chargePointConsumption.consumption);
    writer.writeStringValue("deviceId", chargePointConsumption.deviceId);
    writer.writeDateValue("lastConsumptionDate", chargePointConsumption.lastConsumptionDate);
    writer.writeNumberValue("units", chargePointConsumption.units);
    writer.writeAdditionalData(chargePointConsumption.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointConsumptionSources The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointConsumptionSources(writer: SerializationWriter, chargePointConsumptionSources: Partial<ChargePointConsumptionSources> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointConsumptionSources || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", chargePointConsumptionSources.from);
    writer.writeCollectionOfObjectValues<ConsumptionSourceTotals>("sources", chargePointConsumptionSources.sources, serializeConsumptionSourceTotals);
    writer.writeDateOnlyValue("to", chargePointConsumptionSources.to);
    writer.writeNumberValue("year", chargePointConsumptionSources.year);
    writer.writeAdditionalData(chargePointConsumptionSources.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointConsumptionWithProjection The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointConsumptionWithProjection(writer: SerializationWriter, chargePointConsumptionWithProjection: Partial<ChargePointConsumptionWithProjection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointConsumptionWithProjection || isSerializingDerivedType) { return; }
    writer.writeGuidValue("chargePointId", chargePointConsumptionWithProjection.chargePointId);
    writer.writeNumberValue("consumption", chargePointConsumptionWithProjection.consumption);
    writer.writeGuidValue("contractId", chargePointConsumptionWithProjection.contractId);
    writer.writeNumberValue("expectedConsumption", chargePointConsumptionWithProjection.expectedConsumption);
    writer.writeNumberValue("expectedPayoutAmount", chargePointConsumptionWithProjection.expectedPayoutAmount);
    writer.writeNumberValue("expectedUnits", chargePointConsumptionWithProjection.expectedUnits);
    writer.writeNumberValue("expectedYield", chargePointConsumptionWithProjection.expectedYield);
    writer.writeGuidValue("id", chargePointConsumptionWithProjection.id);
    writer.writeNumberValue("payoutAmount", chargePointConsumptionWithProjection.payoutAmount);
    writer.writeDateOnlyValue("periodFrom", chargePointConsumptionWithProjection.periodFrom);
    writer.writeDateOnlyValue("periodTo", chargePointConsumptionWithProjection.periodTo);
    writer.writeDateOnlyValue("projectionDate", chargePointConsumptionWithProjection.projectionDate);
    writer.writeNumberValue("registeredConsumption", chargePointConsumptionWithProjection.registeredConsumption);
    writer.writeNumberValue("registeredPayoutAmount", chargePointConsumptionWithProjection.registeredPayoutAmount);
    writer.writeDateOnlyValue("registeredTo", chargePointConsumptionWithProjection.registeredTo);
    writer.writeNumberValue("registeredUnits", chargePointConsumptionWithProjection.registeredUnits);
    writer.writeNumberValue("registeredYield", chargePointConsumptionWithProjection.registeredYield);
    writer.writeNumberValue("units", chargePointConsumptionWithProjection.units);
    writer.writeNumberValue("yield", chargePointConsumptionWithProjection.yield);
    writer.writeAdditionalData(chargePointConsumptionWithProjection.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointSummary(writer: SerializationWriter, chargePointSummary: Partial<ChargePointSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointSummary || isSerializingDerivedType) { return; }
    writer.writeObjectValue<ChargePointSummaryCharger>("charger", chargePointSummary.charger, serializeChargePointSummaryCharger);
    writer.writeStringValue("createdBy", chargePointSummary.createdBy);
    writer.writeDateValue("createdDate", chargePointSummary.createdDate);
    writer.writeGuidValue("id", chargePointSummary.id);
    writer.writeStringValue("lastModifiedBy", chargePointSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", chargePointSummary.lastModifiedDate);
    writer.writeGuidValue("locationId", chargePointSummary.locationId);
    writer.writeStringValue("name", chargePointSummary.name);
    writer.writeAdditionalData(chargePointSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointSummaryCharger The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointSummaryCharger(writer: SerializationWriter, chargePointSummaryCharger: Partial<ChargePointSummaryCharger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointSummaryCharger || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", chargePointSummaryCharger.deviceId);
    writer.writeStringValue("make", chargePointSummaryCharger.make);
    writer.writeEnumValue<MidMeterType>("midMeter", chargePointSummaryCharger.midMeter);
    writer.writeStringValue("model", chargePointSummaryCharger.model);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", chargePointSummaryCharger.verificationStatus);
    writer.writeAdditionalData(chargePointSummaryCharger.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargePointVolume The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargePointVolume(writer: SerializationWriter, chargePointVolume: Partial<ChargePointVolume> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargePointVolume || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", chargePointVolume.amount);
    writer.writeNumberValue("chargePoints", chargePointVolume.chargePoints);
    writer.writeNumberValue("consumption", chargePointVolume.consumption);
    writer.writeNumberValue("erePrice", chargePointVolume.erePrice);
    writer.writeNumberValue("expectedAmount", chargePointVolume.expectedAmount);
    writer.writeNumberValue("expectedConsumption", chargePointVolume.expectedConsumption);
    writer.writeNumberValue("expectedUnits", chargePointVolume.expectedUnits);
    writer.writeDateOnlyValue("from", chargePointVolume.from);
    writer.writeDateOnlyValue("projectionDate", chargePointVolume.projectionDate);
    writer.writeDateOnlyValue("to", chargePointVolume.to);
    writer.writeNumberValue("units", chargePointVolume.units);
    writer.writeNumberValue("year", chargePointVolume.year);
    writer.writeAdditionalData(chargePointVolume.additionalData);
}
/**
 * Serializes information the current object
 * @param Charger The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCharger(writer: SerializationWriter, charger: Partial<Charger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!charger || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", charger.deviceId);
    writer.writeStringValue("make", charger.make);
    writer.writeEnumValue<MidMeterType>("midMeter", charger.midMeter);
    writer.writeStringValue("model", charger.model);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", charger.verificationStatus);
    writer.writeAdditionalData(charger.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerCount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerCount(writer: SerializationWriter, chargerCount: Partial<ChargerCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerCount || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("date", chargerCount.date);
    writer.writeCollectionOfObjectValues<ChargerMakeCount>("makes", chargerCount.makes, serializeChargerMakeCount);
    writer.writeAdditionalData(chargerCount.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerDefinition The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerDefinition(writer: SerializationWriter, chargerDefinition: Partial<ChargerDefinition> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerDefinition || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ChargeType>("chargeType", chargerDefinition.chargeType);
    writer.writeObjectValue<ConformityStatementDto>("conformityStatement", chargerDefinition.conformityStatement, serializeConformityStatementDto);
    writer.writeStringValue("createdBy", chargerDefinition.createdBy);
    writer.writeDateValue("createdDate", chargerDefinition.createdDate);
    writer.writeStringValue("datasheetUrl", chargerDefinition.datasheetUrl);
    writer.writeGuidValue("id", chargerDefinition.id);
    writer.writeStringValue("lastModifiedBy", chargerDefinition.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", chargerDefinition.lastModifiedDate);
    writer.writeStringValue("make", chargerDefinition.make);
    writer.writeStringValue("meterMake", chargerDefinition.meterMake);
    writer.writeStringValue("meterModel", chargerDefinition.meterModel);
    writer.writeEnumValue<MidMeterType>("midMeter", chargerDefinition.midMeter);
    writer.writeStringValue("model", chargerDefinition.model);
    writer.writeStringValue("notes", chargerDefinition.notes);
    writer.writeStringValue("source", chargerDefinition.source);
    writer.writeAdditionalData(chargerDefinition.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerDefinitionSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerDefinitionSummary(writer: SerializationWriter, chargerDefinitionSummary: Partial<ChargerDefinitionSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerDefinitionSummary || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ChargeType>("chargeType", chargerDefinitionSummary.chargeType);
    writer.writeObjectValue<ConformityStatementDto>("conformityStatement", chargerDefinitionSummary.conformityStatement, serializeConformityStatementDto);
    writer.writeStringValue("createdBy", chargerDefinitionSummary.createdBy);
    writer.writeDateValue("createdDate", chargerDefinitionSummary.createdDate);
    writer.writeStringValue("datasheetUrl", chargerDefinitionSummary.datasheetUrl);
    writer.writeGuidValue("id", chargerDefinitionSummary.id);
    writer.writeStringValue("lastModifiedBy", chargerDefinitionSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", chargerDefinitionSummary.lastModifiedDate);
    writer.writeStringValue("make", chargerDefinitionSummary.make);
    writer.writeStringValue("meterMake", chargerDefinitionSummary.meterMake);
    writer.writeStringValue("meterModel", chargerDefinitionSummary.meterModel);
    writer.writeEnumValue<MidMeterType>("midMeter", chargerDefinitionSummary.midMeter);
    writer.writeStringValue("model", chargerDefinitionSummary.model);
    writer.writeStringValue("notes", chargerDefinitionSummary.notes);
    writer.writeStringValue("source", chargerDefinitionSummary.source);
    writer.writeAdditionalData(chargerDefinitionSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerMakeCount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerMakeCount(writer: SerializationWriter, chargerMakeCount: Partial<ChargerMakeCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerMakeCount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("chargePoints", chargerMakeCount.chargePoints);
    writer.writeStringValue("make", chargerMakeCount.make);
    writer.writeAdditionalData(chargerMakeCount.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerMakeVolume The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerMakeVolume(writer: SerializationWriter, chargerMakeVolume: Partial<ChargerMakeVolume> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerMakeVolume || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", chargerMakeVolume.consumption);
    writer.writeStringValue("make", chargerMakeVolume.make);
    writer.writeAdditionalData(chargerMakeVolume.additionalData);
}
/**
 * Serializes information the current object
 * @param ChargerVolume The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChargerVolume(writer: SerializationWriter, chargerVolume: Partial<ChargerVolume> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!chargerVolume || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", chargerVolume.from);
    writer.writeCollectionOfObjectValues<ChargerMakeVolume>("makes", chargerVolume.makes, serializeChargerMakeVolume);
    writer.writeDateOnlyValue("to", chargerVolume.to);
    writer.writeAdditionalData(chargerVolume.additionalData);
}
/**
 * Serializes information the current object
 * @param CommitPendingEntriesCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCommitPendingEntriesCommand(writer: SerializationWriter, commitPendingEntriesCommand: Partial<CommitPendingEntriesCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!commitPendingEntriesCommand || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<Guid>("entries", commitPendingEntriesCommand.entries);
    writer.writeGuidValue("id", commitPendingEntriesCommand.id);
    writer.writeAdditionalData(commitPendingEntriesCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CompanyRegistrationSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompanyRegistrationSummary(writer: SerializationWriter, companyRegistrationSummary: Partial<CompanyRegistrationSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!companyRegistrationSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("addressType", companyRegistrationSummary.addressType);
    writer.writeStringValue("city", companyRegistrationSummary.city);
    writer.writeStringValue("houseNumber", companyRegistrationSummary.houseNumber);
    writer.writeStringValue("name", companyRegistrationSummary.name);
    writer.writeStringValue("officeNumber", companyRegistrationSummary.officeNumber);
    writer.writeStringValue("officeType", companyRegistrationSummary.officeType);
    writer.writeStringValue("postcode", companyRegistrationSummary.postcode);
    writer.writeStringValue("registrationNumber", companyRegistrationSummary.registrationNumber);
    writer.writeStringValue("street", companyRegistrationSummary.street);
    writer.writeAdditionalData(companyRegistrationSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ConformityStatementDto The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConformityStatementDto(writer: SerializationWriter, conformityStatementDto: Partial<ConformityStatementDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!conformityStatementDto || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", conformityStatementDto.contentType);
    writer.writeStringValue("fileName", conformityStatementDto.fileName);
    writer.writeNumberValue("fileSize", conformityStatementDto.fileSize);
    writer.writeAdditionalData(conformityStatementDto.additionalData);
}
/**
 * Serializes information the current object
 * @param ConsumptionHistory The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConsumptionHistory(writer: SerializationWriter, consumptionHistory: Partial<ConsumptionHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!consumptionHistory || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", consumptionHistory.from);
    writer.writeEnumValue<ConsumptionGranularity>("granularity", consumptionHistory.granularity);
    writer.writeCollectionOfObjectValues<ConsumptionHistoryPoint>("points", consumptionHistory.points, serializeConsumptionHistoryPoint);
    writer.writeDateOnlyValue("to", consumptionHistory.to);
    writer.writeAdditionalData(consumptionHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param ConsumptionHistoryPoint The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConsumptionHistoryPoint(writer: SerializationWriter, consumptionHistoryPoint: Partial<ConsumptionHistoryPoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!consumptionHistoryPoint || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", consumptionHistoryPoint.consumption);
    writer.writeDateOnlyValue("periodStart", consumptionHistoryPoint.periodStart);
    writer.writeNumberValue("units", consumptionHistoryPoint.units);
    writer.writeAdditionalData(consumptionHistoryPoint.additionalData);
}
/**
 * Serializes information the current object
 * @param ConsumptionSourceTotals The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConsumptionSourceTotals(writer: SerializationWriter, consumptionSourceTotals: Partial<ConsumptionSourceTotals> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!consumptionSourceTotals || isSerializingDerivedType) { return; }
    writer.writeNumberValue("chargerCount", consumptionSourceTotals.chargerCount);
    writer.writeNumberValue("consumption", consumptionSourceTotals.consumption);
    writer.writeEnumValue<ConsumptionProvider>("provider", consumptionSourceTotals.provider);
    writer.writeEnumValue<ConsumptionSource>("source", consumptionSourceTotals.source);
    writer.writeAdditionalData(consumptionSourceTotals.additionalData);
}
/**
 * Serializes information the current object
 * @param Contract The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContract(writer: SerializationWriter, contract: Partial<Contract> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contract || isSerializingDerivedType) { return; }
    writer.writeObjectValue<ContractAffiliateCondition>("affiliateCondition", contract.affiliateCondition, serializeContractAffiliateCondition);
    writer.writeNumberValue("commissionPercentage", contract.commissionPercentage);
    writer.writeEnumValue<ComplianceStatus>("complianceStatus", contract.complianceStatus);
    writer.writeStringValue("contractReference", contract.contractReference);
    writer.writeDateOnlyValue("contractRevokedDate", contract.contractRevokedDate);
    writer.writeStringValue("contractSignedBy", contract.contractSignedBy);
    writer.writeDateOnlyValue("contractSignedDate", contract.contractSignedDate);
    writer.writeStringValue("createdBy", contract.createdBy);
    writer.writeDateValue("createdDate", contract.createdDate);
    writer.writeGuidValue("customerId", contract.customerId);
    writer.writeGuidValue("id", contract.id);
    writer.writeBooleanValue("isEligibleForPayout", contract.isEligibleForPayout);
    writer.writeBooleanValue("isEligibleForRegistration", contract.isEligibleForRegistration);
    writer.writeBooleanValue("isEligibleForTransaction", contract.isEligibleForTransaction);
    writer.writeStringValue("lastModifiedBy", contract.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", contract.lastModifiedDate);
    writer.writeGuidValue("locationId", contract.locationId);
    writer.writeDateOnlyValue("mandateRevokedDate", contract.mandateRevokedDate);
    writer.writeStringValue("mandateSignedBy", contract.mandateSignedBy);
    writer.writeDateOnlyValue("mandateSignedDate", contract.mandateSignedDate);
    writer.writeGuidValue("nextContractId", contract.nextContractId);
    writer.writeCollectionOfObjectValues<ContractComplianceItem>("openItems", contract.openItems, serializeContractComplianceItem);
    writer.writeGuidValue("previousContractId", contract.previousContractId);
    writer.writeDateOnlyValue("validFrom", contract.validFrom);
    writer.writeDateOnlyValue("validTo", contract.validTo);
    writer.writeAdditionalData(contract.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractAffiliateCondition The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractAffiliateCondition(writer: SerializationWriter, contractAffiliateCondition: Partial<ContractAffiliateCondition> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractAffiliateCondition || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", contractAffiliateCondition.affiliateCode);
    writer.writeNumberValue("discountPercentage", contractAffiliateCondition.discountPercentage);
    writer.writeNumberValue("kickbackPercentage", contractAffiliateCondition.kickbackPercentage);
    writer.writeStringValue("name", contractAffiliateCondition.name);
    writer.writeAdditionalData(contractAffiliateCondition.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractAffiliateCount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractAffiliateCount(writer: SerializationWriter, contractAffiliateCount: Partial<ContractAffiliateCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractAffiliateCount || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AffiliateContractCount>("affiliates", contractAffiliateCount.affiliates, serializeAffiliateContractCount);
    writer.writeNumberValue("contracts", contractAffiliateCount.contracts);
    writer.writeDateOnlyValue("date", contractAffiliateCount.date);
    writer.writeAdditionalData(contractAffiliateCount.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractComplianceItem The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractComplianceItem(writer: SerializationWriter, contractComplianceItem: Partial<ContractComplianceItem> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractComplianceItem || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ComplianceActor>("actor", contractComplianceItem.actor);
    writer.writeEnumValue<ComplianceItem>("item", contractComplianceItem.item);
    writer.writeAdditionalData(contractComplianceItem.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractConsumptionWithProjection The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractConsumptionWithProjection(writer: SerializationWriter, contractConsumptionWithProjection: Partial<ContractConsumptionWithProjection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractConsumptionWithProjection || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", contractConsumptionWithProjection.consumption);
    writer.writeNumberValue("expectedConsumption", contractConsumptionWithProjection.expectedConsumption);
    writer.writeNumberValue("expectedPayoutAmount", contractConsumptionWithProjection.expectedPayoutAmount);
    writer.writeNumberValue("expectedUnits", contractConsumptionWithProjection.expectedUnits);
    writer.writeNumberValue("expectedYield", contractConsumptionWithProjection.expectedYield);
    writer.writeGuidValue("id", contractConsumptionWithProjection.id);
    writer.writeNumberValue("payoutAmount", contractConsumptionWithProjection.payoutAmount);
    writer.writeDateOnlyValue("periodFrom", contractConsumptionWithProjection.periodFrom);
    writer.writeDateOnlyValue("periodTo", contractConsumptionWithProjection.periodTo);
    writer.writeDateOnlyValue("projectionDate", contractConsumptionWithProjection.projectionDate);
    writer.writeNumberValue("registeredConsumption", contractConsumptionWithProjection.registeredConsumption);
    writer.writeNumberValue("registeredPayoutAmount", contractConsumptionWithProjection.registeredPayoutAmount);
    writer.writeDateOnlyValue("registeredTo", contractConsumptionWithProjection.registeredTo);
    writer.writeNumberValue("registeredUnits", contractConsumptionWithProjection.registeredUnits);
    writer.writeNumberValue("registeredYield", contractConsumptionWithProjection.registeredYield);
    writer.writeNumberValue("units", contractConsumptionWithProjection.units);
    writer.writeNumberValue("yield", contractConsumptionWithProjection.yield);
    writer.writeAdditionalData(contractConsumptionWithProjection.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractEligibility The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractEligibility(writer: SerializationWriter, contractEligibility: Partial<ContractEligibility> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractEligibility || isSerializingDerivedType) { return; }
    writer.writeNumberValue("eligibleForPayout", contractEligibility.eligibleForPayout);
    writer.writeNumberValue("eligibleForRegistration", contractEligibility.eligibleForRegistration);
    writer.writeNumberValue("eligibleForTransaction", contractEligibility.eligibleForTransaction);
    writer.writeNumberValue("notEligible", contractEligibility.notEligible);
    writer.writeAdditionalData(contractEligibility.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractListItem The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractListItem(writer: SerializationWriter, contractListItem: Partial<ContractListItem> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractListItem || isSerializingDerivedType) { return; }
    writer.writeStringValue("address", contractListItem.address);
    writer.writeNumberValue("chargePointCount", contractListItem.chargePointCount);
    writer.writeEnumValue<ComplianceStatus>("complianceStatus", contractListItem.complianceStatus);
    writer.writeStringValue("contractReference", contractListItem.contractReference);
    writer.writeObjectValue<ContractListItemCustomer>("customer", contractListItem.customer, serializeContractListItemCustomer);
    writer.writeStringValue("eanCode", contractListItem.eanCode);
    writer.writeGuidValue("id", contractListItem.id);
    writer.writeGuidValue("locationId", contractListItem.locationId);
    writer.writeCollectionOfObjectValues<ContractComplianceItem>("openItems", contractListItem.openItems, serializeContractComplianceItem);
    writer.writeDateOnlyValue("validFrom", contractListItem.validFrom);
    writer.writeDateOnlyValue("validTo", contractListItem.validTo);
    writer.writeAdditionalData(contractListItem.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractListItemCustomer The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractListItemCustomer(writer: SerializationWriter, contractListItemCustomer: Partial<ContractListItemCustomer> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractListItemCustomer || isSerializingDerivedType) { return; }
    writer.writeStringValue("customerReference", contractListItemCustomer.customerReference);
    writer.writeEnumValue<CustomerType>("customerType", contractListItemCustomer.customerType);
    writer.writeGuidValue("id", contractListItemCustomer.id);
    writer.writeStringValue("name", contractListItemCustomer.name);
    writer.writeAdditionalData(contractListItemCustomer.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractOverview The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractOverview(writer: SerializationWriter, contractOverview: Partial<ContractOverview> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractOverview || isSerializingDerivedType) { return; }
    writer.writeNumberValue("commission", contractOverview.commission);
    writer.writeNumberValue("consumption", contractOverview.consumption);
    writer.writeNumberValue("costs", contractOverview.costs);
    writer.writeNumberValue("payoutAmount", contractOverview.payoutAmount);
    writer.writeDateOnlyValue("periodFrom", contractOverview.periodFrom);
    writer.writeDateOnlyValue("periodTo", contractOverview.periodTo);
    writer.writeGuidValue("registrationId", contractOverview.registrationId);
    writer.writeStringValue("registrationReference", contractOverview.registrationReference);
    writer.writeEnumValue<ContractOverviewStatus>("status", contractOverview.status);
    writer.writeNumberValue("units", contractOverview.units);
    writer.writeNumberValue("yield", contractOverview.yield);
    writer.writeAdditionalData(contractOverview.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractsCreatedInPeriod The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractsCreatedInPeriod(writer: SerializationWriter, contractsCreatedInPeriod: Partial<ContractsCreatedInPeriod> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractsCreatedInPeriod || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractsCreated", contractsCreatedInPeriod.contractsCreated);
    writer.writeDateOnlyValue("periodStart", contractsCreatedInPeriod.periodStart);
    writer.writeNumberValue("toDate", contractsCreatedInPeriod.toDate);
    writer.writeAdditionalData(contractsCreatedInPeriod.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractsToDate The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractsToDate(writer: SerializationWriter, contractsToDate: Partial<ContractsToDate> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractsToDate || isSerializingDerivedType) { return; }
    writer.writeNumberValue("current", contractsToDate.current);
    writer.writeNumberValue("last30Days", contractsToDate.last30Days);
    writer.writeNumberValue("last7Days", contractsToDate.last7Days);
    writer.writeNumberValue("today", contractsToDate.today);
    writer.writeNumberValue("total", contractsToDate.total);
    writer.writeAdditionalData(contractsToDate.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractsToDateHistory The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractsToDateHistory(writer: SerializationWriter, contractsToDateHistory: Partial<ContractsToDateHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractsToDateHistory || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", contractsToDateHistory.from);
    writer.writeEnumValue<ActivityGranularity>("granularity", contractsToDateHistory.granularity);
    writer.writeCollectionOfObjectValues<ContractsCreatedInPeriod>("points", contractsToDateHistory.points, serializeContractsCreatedInPeriod);
    writer.writeDateOnlyValue("to", contractsToDateHistory.to);
    writer.writeAdditionalData(contractsToDateHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractSummary(writer: SerializationWriter, contractSummary: Partial<ContractSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractSummary || isSerializingDerivedType) { return; }
    writer.writeObjectValue<ContractSummaryAffiliateCondition>("affiliateCondition", contractSummary.affiliateCondition, serializeContractSummaryAffiliateCondition);
    writer.writeNumberValue("chargePointCount", contractSummary.chargePointCount);
    writer.writeEnumValue<ComplianceStatus>("complianceStatus", contractSummary.complianceStatus);
    writer.writeStringValue("contractReference", contractSummary.contractReference);
    writer.writeStringValue("createdBy", contractSummary.createdBy);
    writer.writeDateValue("createdDate", contractSummary.createdDate);
    writer.writeObjectValue<ContractSummaryCustomer>("customer", contractSummary.customer, serializeContractSummaryCustomer);
    writer.writeGuidValue("id", contractSummary.id);
    writer.writeBooleanValue("isEligibleForPayout", contractSummary.isEligibleForPayout);
    writer.writeBooleanValue("isEligibleForRegistration", contractSummary.isEligibleForRegistration);
    writer.writeBooleanValue("isEligibleForTransaction", contractSummary.isEligibleForTransaction);
    writer.writeStringValue("lastModifiedBy", contractSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", contractSummary.lastModifiedDate);
    writer.writeGuidValue("locationId", contractSummary.locationId);
    writer.writeCollectionOfObjectValues<ContractComplianceItem>("openItems", contractSummary.openItems, serializeContractComplianceItem);
    writer.writeDateOnlyValue("validFrom", contractSummary.validFrom);
    writer.writeDateOnlyValue("validTo", contractSummary.validTo);
    writer.writeAdditionalData(contractSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractSummaryAffiliateCondition The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractSummaryAffiliateCondition(writer: SerializationWriter, contractSummaryAffiliateCondition: Partial<ContractSummaryAffiliateCondition> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractSummaryAffiliateCondition || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", contractSummaryAffiliateCondition.affiliateCode);
    writer.writeNumberValue("discountPercentage", contractSummaryAffiliateCondition.discountPercentage);
    writer.writeNumberValue("kickbackPercentage", contractSummaryAffiliateCondition.kickbackPercentage);
    writer.writeStringValue("name", contractSummaryAffiliateCondition.name);
    writer.writeAdditionalData(contractSummaryAffiliateCondition.additionalData);
}
/**
 * Serializes information the current object
 * @param ContractSummaryCustomer The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeContractSummaryCustomer(writer: SerializationWriter, contractSummaryCustomer: Partial<ContractSummaryCustomer> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!contractSummaryCustomer || isSerializingDerivedType) { return; }
    writer.writeStringValue("customerReference", contractSummaryCustomer.customerReference);
    writer.writeStringValue("externalCustomerId", contractSummaryCustomer.externalCustomerId);
    writer.writeGuidValue("id", contractSummaryCustomer.id);
    writer.writeStringValue("name", contractSummaryCustomer.name);
    writer.writeAdditionalData(contractSummaryCustomer.additionalData);
}
/**
 * Serializes information the current object
 * @param ConversionFactor The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConversionFactor(writer: SerializationWriter, conversionFactor: Partial<ConversionFactor> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!conversionFactor || isSerializingDerivedType) { return; }
    writer.writeStringValue("createdBy", conversionFactor.createdBy);
    writer.writeDateValue("createdDate", conversionFactor.createdDate);
    writer.writeNumberValue("expectedErePrice", conversionFactor.expectedErePrice);
    writer.writeGuidValue("id", conversionFactor.id);
    writer.writeStringValue("lastModifiedBy", conversionFactor.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", conversionFactor.lastModifiedDate);
    writer.writeNumberValue("netConsumptionFactor", conversionFactor.netConsumptionFactor);
    writer.writeNumberValue("renewableConsumptionFactor", conversionFactor.renewableConsumptionFactor);
    writer.writeNumberValue("year", conversionFactor.year);
    writer.writeAdditionalData(conversionFactor.additionalData);
}
/**
 * Serializes information the current object
 * @param ConversionFactorSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConversionFactorSummary(writer: SerializationWriter, conversionFactorSummary: Partial<ConversionFactorSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!conversionFactorSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("createdBy", conversionFactorSummary.createdBy);
    writer.writeDateValue("createdDate", conversionFactorSummary.createdDate);
    writer.writeNumberValue("expectedErePrice", conversionFactorSummary.expectedErePrice);
    writer.writeGuidValue("id", conversionFactorSummary.id);
    writer.writeStringValue("lastModifiedBy", conversionFactorSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", conversionFactorSummary.lastModifiedDate);
    writer.writeNumberValue("netConsumptionFactor", conversionFactorSummary.netConsumptionFactor);
    writer.writeNumberValue("renewableConsumptionFactor", conversionFactorSummary.renewableConsumptionFactor);
    writer.writeNumberValue("year", conversionFactorSummary.year);
    writer.writeAdditionalData(conversionFactorSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param ConvertCustomerToBusinessCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConvertCustomerToBusinessCommand(writer: SerializationWriter, convertCustomerToBusinessCommand: Partial<ConvertCustomerToBusinessCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!convertCustomerToBusinessCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", convertCustomerToBusinessCommand.affiliateId);
    writer.writeStringValue("companyName", convertCustomerToBusinessCommand.companyName);
    writer.writeStringValue("companyRegistrationNumber", convertCustomerToBusinessCommand.companyRegistrationNumber);
    writer.writeGuidValue("customerId", convertCustomerToBusinessCommand.customerId);
    writer.writeAdditionalData(convertCustomerToBusinessCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param ConvertCustomerToConsumerCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeConvertCustomerToConsumerCommand(writer: SerializationWriter, convertCustomerToConsumerCommand: Partial<ConvertCustomerToConsumerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!convertCustomerToConsumerCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", convertCustomerToConsumerCommand.affiliateId);
    writer.writeGuidValue("customerId", convertCustomerToConsumerCommand.customerId);
    writer.writeAdditionalData(convertCustomerToConsumerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateAccountCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateAccountCommand(writer: SerializationWriter, createAccountCommand: Partial<CreateAccountCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createAccountCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountNumber", createAccountCommand.accountNumber);
    writer.writeNumberValue("initialBalance", createAccountCommand.initialBalance);
    writer.writeGuidValue("ledgerId", createAccountCommand.ledgerId);
    writer.writeStringValue("name", createAccountCommand.name);
    writer.writeAdditionalData(createAccountCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateAffiliateCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateAffiliateCommand(writer: SerializationWriter, createAffiliateCommand: Partial<CreateAffiliateCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createAffiliateCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", createAffiliateCommand.affiliateCode);
    writer.writeObjectValue<AffiliateTermsDto>("businessCondition", createAffiliateCommand.businessCondition, serializeAffiliateTermsDto);
    writer.writeObjectValue<AffiliateTermsDto>("consumerCondition", createAffiliateCommand.consumerCondition, serializeAffiliateTermsDto);
    writer.writeStringValue("name", createAffiliateCommand.name);
    writer.writeStringValue("notes", createAffiliateCommand.notes);
    writer.writeAdditionalData(createAffiliateCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateBusinessCustomerCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateBusinessCustomerCommand(writer: SerializationWriter, createBusinessCustomerCommand: Partial<CreateBusinessCustomerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createBusinessCustomerCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", createBusinessCustomerCommand.affiliateId);
    writer.writeObjectValue<SignupCompanyRegistration>("companyRegistration", createBusinessCustomerCommand.companyRegistration, serializeSignupCompanyRegistration);
    writer.writeObjectValue<SignupContact>("contact", createBusinessCustomerCommand.contact, serializeSignupContact);
    writer.writeAdditionalData(createBusinessCustomerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateBusinessCustomerResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateBusinessCustomerResult(writer: SerializationWriter, createBusinessCustomerResult: Partial<CreateBusinessCustomerResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createBusinessCustomerResult || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", createBusinessCustomerResult.customerId);
    writer.writeAdditionalData(createBusinessCustomerResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateBusinessCustomerWithContractCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateBusinessCustomerWithContractCommand(writer: SerializationWriter, createBusinessCustomerWithContractCommand: Partial<CreateBusinessCustomerWithContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createBusinessCustomerWithContractCommand || isSerializingDerivedType) { return; }
    writer.writeObjectValue<SignupAddress>("address", createBusinessCustomerWithContractCommand.address, serializeSignupAddress);
    writer.writeGuidValue("affiliateId", createBusinessCustomerWithContractCommand.affiliateId);
    writer.writeObjectValue<SignupBankAccount>("bankAccount", createBusinessCustomerWithContractCommand.bankAccount, serializeSignupBankAccount);
    writer.writeCollectionOfObjectValues<SignupChargePoint>("chargePoints", createBusinessCustomerWithContractCommand.chargePoints, serializeSignupChargePoint);
    writer.writeObjectValue<SignupCompanyRegistration>("companyRegistration", createBusinessCustomerWithContractCommand.companyRegistration, serializeSignupCompanyRegistration);
    writer.writeObjectValue<SignupContact>("contact", createBusinessCustomerWithContractCommand.contact, serializeSignupContact);
    writer.writeDateOnlyValue("validFrom", createBusinessCustomerWithContractCommand.validFrom);
    writer.writeDateOnlyValue("validTo", createBusinessCustomerWithContractCommand.validTo);
    writer.writeAdditionalData(createBusinessCustomerWithContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateBusinessCustomerWithContractResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateBusinessCustomerWithContractResult(writer: SerializationWriter, createBusinessCustomerWithContractResult: Partial<CreateBusinessCustomerWithContractResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createBusinessCustomerWithContractResult || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<Guid>("chargePointIds", createBusinessCustomerWithContractResult.chargePointIds);
    writer.writeGuidValue("contractId", createBusinessCustomerWithContractResult.contractId);
    writer.writeGuidValue("customerId", createBusinessCustomerWithContractResult.customerId);
    writer.writeGuidValue("locationId", createBusinessCustomerWithContractResult.locationId);
    writer.writeAdditionalData(createBusinessCustomerWithContractResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateChargePointCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateChargePointCommand(writer: SerializationWriter, createChargePointCommand: Partial<CreateChargePointCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createChargePointCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", createChargePointCommand.deviceId);
    writer.writeGuidValue("locationId", createChargePointCommand.locationId);
    writer.writeStringValue("make", createChargePointCommand.make);
    writer.writeEnumValue<MidMeterType>("midMeter", createChargePointCommand.midMeter);
    writer.writeStringValue("model", createChargePointCommand.model);
    writer.writeStringValue("name", createChargePointCommand.name);
    writer.writeBooleanValue("skipVerification", createChargePointCommand.skipVerification);
    writer.writeBooleanValue("verified", createChargePointCommand.verified);
    writer.writeAdditionalData(createChargePointCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateChargerDefinitionCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateChargerDefinitionCommand(writer: SerializationWriter, createChargerDefinitionCommand: Partial<CreateChargerDefinitionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createChargerDefinitionCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ChargeType>("chargeType", createChargerDefinitionCommand.chargeType);
    writer.writeStringValue("datasheetUrl", createChargerDefinitionCommand.datasheetUrl);
    writer.writeStringValue("make", createChargerDefinitionCommand.make);
    writer.writeStringValue("meterMake", createChargerDefinitionCommand.meterMake);
    writer.writeStringValue("meterModel", createChargerDefinitionCommand.meterModel);
    writer.writeEnumValue<MidMeterType>("midMeter", createChargerDefinitionCommand.midMeter);
    writer.writeStringValue("model", createChargerDefinitionCommand.model);
    writer.writeStringValue("notes", createChargerDefinitionCommand.notes);
    writer.writeStringValue("source", createChargerDefinitionCommand.source);
    writer.writeAdditionalData(createChargerDefinitionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateConsumerCustomerCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateConsumerCustomerCommand(writer: SerializationWriter, createConsumerCustomerCommand: Partial<CreateConsumerCustomerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createConsumerCustomerCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", createConsumerCustomerCommand.affiliateId);
    writer.writeObjectValue<SignupContact>("contact", createConsumerCustomerCommand.contact, serializeSignupContact);
    writer.writeAdditionalData(createConsumerCustomerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateConsumerCustomerResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateConsumerCustomerResult(writer: SerializationWriter, createConsumerCustomerResult: Partial<CreateConsumerCustomerResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createConsumerCustomerResult || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", createConsumerCustomerResult.customerId);
    writer.writeAdditionalData(createConsumerCustomerResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateConsumerCustomerWithContractCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateConsumerCustomerWithContractCommand(writer: SerializationWriter, createConsumerCustomerWithContractCommand: Partial<CreateConsumerCustomerWithContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createConsumerCustomerWithContractCommand || isSerializingDerivedType) { return; }
    writer.writeObjectValue<SignupAddress>("address", createConsumerCustomerWithContractCommand.address, serializeSignupAddress);
    writer.writeGuidValue("affiliateId", createConsumerCustomerWithContractCommand.affiliateId);
    writer.writeObjectValue<SignupBankAccount>("bankAccount", createConsumerCustomerWithContractCommand.bankAccount, serializeSignupBankAccount);
    writer.writeCollectionOfObjectValues<SignupChargePoint>("chargePoints", createConsumerCustomerWithContractCommand.chargePoints, serializeSignupChargePoint);
    writer.writeObjectValue<SignupContact>("contact", createConsumerCustomerWithContractCommand.contact, serializeSignupContact);
    writer.writeDateOnlyValue("validFrom", createConsumerCustomerWithContractCommand.validFrom);
    writer.writeDateOnlyValue("validTo", createConsumerCustomerWithContractCommand.validTo);
    writer.writeAdditionalData(createConsumerCustomerWithContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateConsumerCustomerWithContractResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateConsumerCustomerWithContractResult(writer: SerializationWriter, createConsumerCustomerWithContractResult: Partial<CreateConsumerCustomerWithContractResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createConsumerCustomerWithContractResult || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<Guid>("chargePointIds", createConsumerCustomerWithContractResult.chargePointIds);
    writer.writeGuidValue("contractId", createConsumerCustomerWithContractResult.contractId);
    writer.writeGuidValue("customerId", createConsumerCustomerWithContractResult.customerId);
    writer.writeGuidValue("locationId", createConsumerCustomerWithContractResult.locationId);
    writer.writeAdditionalData(createConsumerCustomerWithContractResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateContractCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateContractCommand(writer: SerializationWriter, createContractCommand: Partial<CreateContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createContractCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("locationId", createContractCommand.locationId);
    writer.writeDateOnlyValue("validFrom", createContractCommand.validFrom);
    writer.writeDateOnlyValue("validTo", createContractCommand.validTo);
    writer.writeAdditionalData(createContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateConversionFactorCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateConversionFactorCommand(writer: SerializationWriter, createConversionFactorCommand: Partial<CreateConversionFactorCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createConversionFactorCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("expectedErePrice", createConversionFactorCommand.expectedErePrice);
    writer.writeNumberValue("netConsumptionFactor", createConversionFactorCommand.netConsumptionFactor);
    writer.writeNumberValue("renewableConsumptionFactor", createConversionFactorCommand.renewableConsumptionFactor);
    writer.writeNumberValue("year", createConversionFactorCommand.year);
    writer.writeAdditionalData(createConversionFactorCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateLedgerCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateLedgerCommand(writer: SerializationWriter, createLedgerCommand: Partial<CreateLedgerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createLedgerCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<CurrencyType>("currency", createLedgerCommand.currency);
    writer.writeStringValue("name", createLedgerCommand.name);
    writer.writeAdditionalData(createLedgerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateLocationCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateLocationCommand(writer: SerializationWriter, createLocationCommand: Partial<CreateLocationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createLocationCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ConnectionType>("connectionType", createLocationCommand.connectionType);
    writer.writeGuidValue("customerId", createLocationCommand.customerId);
    writer.writeStringValue("meteringPointCity", createLocationCommand.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", createLocationCommand.meteringPointEanCode);
    writer.writeStringValue("meteringPointGridOperator", createLocationCommand.meteringPointGridOperator);
    writer.writeStringValue("meteringPointGridOperatorEanCode", createLocationCommand.meteringPointGridOperatorEanCode);
    writer.writeStringValue("meteringPointHouseNumber", createLocationCommand.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", createLocationCommand.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", createLocationCommand.meteringPointStreet);
    writer.writeBooleanValue("meteringPointVerified", createLocationCommand.meteringPointVerified);
    writer.writeStringValue("name", createLocationCommand.name);
    writer.writeBooleanValue("skipMeteringPointVerification", createLocationCommand.skipMeteringPointVerification);
    writer.writeAdditionalData(createLocationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateLocationResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateLocationResult(writer: SerializationWriter, createLocationResult: Partial<CreateLocationResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createLocationResult || isSerializingDerivedType) { return; }
    writer.writeGuidValue("contractId", createLocationResult.contractId);
    writer.writeGuidValue("locationId", createLocationResult.locationId);
    writer.writeAdditionalData(createLocationResult.additionalData);
}
/**
 * Serializes information the current object
 * @param CreatePayoutCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreatePayoutCommand(writer: SerializationWriter, createPayoutCommand: Partial<CreatePayoutCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createPayoutCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("notes", createPayoutCommand.notes);
    writer.writeDateOnlyValue("payoutDate", createPayoutCommand.payoutDate);
    writer.writeNumberValue("payoutPercentage", createPayoutCommand.payoutPercentage);
    writer.writeGuidValue("transactionId", createPayoutCommand.transactionId);
    writer.writeAdditionalData(createPayoutCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateRegistrationCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateRegistrationCommand(writer: SerializationWriter, createRegistrationCommand: Partial<CreateRegistrationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createRegistrationCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("notes", createRegistrationCommand.notes);
    writer.writeDateOnlyValue("periodFrom", createRegistrationCommand.periodFrom);
    writer.writeDateOnlyValue("periodTo", createRegistrationCommand.periodTo);
    writer.writeDateOnlyValue("registrationDate", createRegistrationCommand.registrationDate);
    writer.writeAdditionalData(createRegistrationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateTransactionCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateTransactionCommand(writer: SerializationWriter, createTransactionCommand: Partial<CreateTransactionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createTransactionCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("costPercentage", createTransactionCommand.costPercentage);
    writer.writeStringValue("notes", createTransactionCommand.notes);
    writer.writeNumberValue("pricePerUnit", createTransactionCommand.pricePerUnit);
    writer.writeGuidValue("registrationId", createTransactionCommand.registrationId);
    writer.writeDateOnlyValue("transactionDate", createTransactionCommand.transactionDate);
    writer.writeAdditionalData(createTransactionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param CurrentUser The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCurrentUser(writer: SerializationWriter, currentUser: Partial<CurrentUser> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!currentUser || isSerializingDerivedType) { return; }
    writer.writeStringValue("apiBuildNumber", currentUser.apiBuildNumber);
    writer.writeStringValue("connectAppUrl", currentUser.connectAppUrl);
    writer.writeStringValue("email", currentUser.email);
    writer.writeStringValue("environment", currentUser.environment);
    writer.writeStringValue("id", currentUser.id);
    writer.writeStringValue("initials", currentUser.initials);
    writer.writeStringValue("name", currentUser.name);
    writer.writeCollectionOfPrimitiveValues<string>("permissions", currentUser.permissions);
    writer.writeCollectionOfPrimitiveValues<string>("roles", currentUser.roles);
    writer.writeCollectionOfPrimitiveValues<string>("scopes", currentUser.scopes);
    writer.writeAdditionalData(currentUser.additionalData);
}
/**
 * Serializes information the current object
 * @param Customer The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomer(writer: SerializationWriter, customer: Partial<Customer> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customer || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CustomerAddress>("address", customer.address, serializeCustomerAddress);
    writer.writeStringValue("affiliateCode", customer.affiliateCode);
    writer.writeGuidValue("affiliateId", customer.affiliateId);
    writer.writeObjectValue<CustomerBankAccount>("bankAccount", customer.bankAccount, serializeCustomerBankAccount);
    writer.writeObjectValue<CustomerCompanyRegistration>("companyRegistration", customer.companyRegistration, serializeCustomerCompanyRegistration);
    writer.writeObjectValue<CustomerContact>("contact", customer.contact, serializeCustomerContact);
    writer.writeStringValue("createdBy", customer.createdBy);
    writer.writeDateValue("createdDate", customer.createdDate);
    writer.writeStringValue("customerReference", customer.customerReference);
    writer.writeEnumValue<CustomerType>("customerType", customer.customerType);
    writer.writeStringValue("externalCustomerId", customer.externalCustomerId);
    writer.writeGuidValue("id", customer.id);
    writer.writeStringValue("lastModifiedBy", customer.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", customer.lastModifiedDate);
    writer.writeDateValue("lastSeenAt", customer.lastSeenAt);
    writer.writeEnumValue<LegacyCompliancyStatus>("legacyCompliancyStatus", customer.legacyCompliancyStatus);
    writer.writeStringValue("name", customer.name);
    writer.writeStringValue("notes", customer.notes);
    writer.writeCollectionOfPrimitiveValues<string>("tags", customer.tags);
    writer.writeAdditionalData(customer.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerActivity The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerActivity(writer: SerializationWriter, customerActivity: Partial<CustomerActivity> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerActivity || isSerializingDerivedType) { return; }
    writer.writeNumberValue("last30Days", customerActivity.last30Days);
    writer.writeNumberValue("last7Days", customerActivity.last7Days);
    writer.writeNumberValue("never", customerActivity.never);
    writer.writeNumberValue("onlineNow", customerActivity.onlineNow);
    writer.writeNumberValue("today", customerActivity.today);
    writer.writeAdditionalData(customerActivity.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerActivityHistory The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerActivityHistory(writer: SerializationWriter, customerActivityHistory: Partial<CustomerActivityHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerActivityHistory || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", customerActivityHistory.from);
    writer.writeEnumValue<ActivityGranularity>("granularity", customerActivityHistory.granularity);
    writer.writeCollectionOfObjectValues<ActiveCustomersInPeriod>("points", customerActivityHistory.points, serializeActiveCustomersInPeriod);
    writer.writeDateOnlyValue("to", customerActivityHistory.to);
    writer.writeAdditionalData(customerActivityHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerAddress The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerAddress(writer: SerializationWriter, customerAddress: Partial<CustomerAddress> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerAddress || isSerializingDerivedType) { return; }
    writer.writeEnumValue<AddressType>("addressType", customerAddress.addressType);
    writer.writeStringValue("city", customerAddress.city);
    writer.writeStringValue("houseNumber", customerAddress.houseNumber);
    writer.writeStringValue("postcode", customerAddress.postcode);
    writer.writeStringValue("street", customerAddress.street);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", customerAddress.verificationStatus);
    writer.writeAdditionalData(customerAddress.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerBankAccount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerBankAccount(writer: SerializationWriter, customerBankAccount: Partial<CustomerBankAccount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerBankAccount || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountHolder", customerBankAccount.accountHolder);
    writer.writeStringValue("accountNumber", customerBankAccount.accountNumber);
    writer.writeStringValue("bankName", customerBankAccount.bankName);
    writer.writeStringValue("bic", customerBankAccount.bic);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", customerBankAccount.verificationStatus);
    writer.writeAdditionalData(customerBankAccount.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerCompanyRegistration The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerCompanyRegistration(writer: SerializationWriter, customerCompanyRegistration: Partial<CustomerCompanyRegistration> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerCompanyRegistration || isSerializingDerivedType) { return; }
    writer.writeStringValue("officeNumber", customerCompanyRegistration.officeNumber);
    writer.writeEnumValue<OfficeType>("officeType", customerCompanyRegistration.officeType);
    writer.writeStringValue("registrationName", customerCompanyRegistration.registrationName);
    writer.writeStringValue("registrationNumber", customerCompanyRegistration.registrationNumber);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", customerCompanyRegistration.verificationStatus);
    writer.writeAdditionalData(customerCompanyRegistration.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerConsumptionWithProjection The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerConsumptionWithProjection(writer: SerializationWriter, customerConsumptionWithProjection: Partial<CustomerConsumptionWithProjection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerConsumptionWithProjection || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", customerConsumptionWithProjection.consumption);
    writer.writeNumberValue("contractCount", customerConsumptionWithProjection.contractCount);
    writer.writeGuidValue("customerId", customerConsumptionWithProjection.customerId);
    writer.writeNumberValue("expectedConsumption", customerConsumptionWithProjection.expectedConsumption);
    writer.writeNumberValue("expectedPayoutAmount", customerConsumptionWithProjection.expectedPayoutAmount);
    writer.writeNumberValue("expectedUnits", customerConsumptionWithProjection.expectedUnits);
    writer.writeNumberValue("expectedYield", customerConsumptionWithProjection.expectedYield);
    writer.writeGuidValue("id", customerConsumptionWithProjection.id);
    writer.writeNumberValue("payoutAmount", customerConsumptionWithProjection.payoutAmount);
    writer.writeDateOnlyValue("periodFrom", customerConsumptionWithProjection.periodFrom);
    writer.writeDateOnlyValue("periodTo", customerConsumptionWithProjection.periodTo);
    writer.writeDateOnlyValue("projectionDate", customerConsumptionWithProjection.projectionDate);
    writer.writeNumberValue("registeredConsumption", customerConsumptionWithProjection.registeredConsumption);
    writer.writeNumberValue("registeredPayoutAmount", customerConsumptionWithProjection.registeredPayoutAmount);
    writer.writeDateOnlyValue("registeredTo", customerConsumptionWithProjection.registeredTo);
    writer.writeNumberValue("registeredUnits", customerConsumptionWithProjection.registeredUnits);
    writer.writeNumberValue("registeredYield", customerConsumptionWithProjection.registeredYield);
    writer.writeNumberValue("units", customerConsumptionWithProjection.units);
    writer.writeNumberValue("yield", customerConsumptionWithProjection.yield);
    writer.writeAdditionalData(customerConsumptionWithProjection.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerContact The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerContact(writer: SerializationWriter, customerContact: Partial<CustomerContact> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerContact || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", customerContact.email);
    writer.writeStringValue("firstName", customerContact.firstName);
    writer.writeStringValue("lastName", customerContact.lastName);
    writer.writeStringValue("name", customerContact.name);
    writer.writeStringValue("phone", customerContact.phone);
    writer.writeAdditionalData(customerContact.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerOAuthConnection The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerOAuthConnection(writer: SerializationWriter, customerOAuthConnection: Partial<CustomerOAuthConnection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerOAuthConnection || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<OAuthConnectionCharger>("chargers", customerOAuthConnection.chargers, serializeOAuthConnectionCharger);
    writer.writeDateValue("connectedDate", customerOAuthConnection.connectedDate);
    writer.writeGuidValue("id", customerOAuthConnection.id);
    writer.writeBooleanValue("isAuthorizationExpired", customerOAuthConnection.isAuthorizationExpired);
    writer.writeBooleanValue("isRemovable", customerOAuthConnection.isRemovable);
    writer.writeEnumValue<OAuthProviderType>("provider", customerOAuthConnection.provider);
    writer.writeAdditionalData(customerOAuthConnection.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomersCreatedInPeriod The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomersCreatedInPeriod(writer: SerializationWriter, customersCreatedInPeriod: Partial<CustomersCreatedInPeriod> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customersCreatedInPeriod || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customersCreated", customersCreatedInPeriod.customersCreated);
    writer.writeDateOnlyValue("periodStart", customersCreatedInPeriod.periodStart);
    writer.writeNumberValue("toDate", customersCreatedInPeriod.toDate);
    writer.writeAdditionalData(customersCreatedInPeriod.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomersToDate The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomersToDate(writer: SerializationWriter, customersToDate: Partial<CustomersToDate> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customersToDate || isSerializingDerivedType) { return; }
    writer.writeNumberValue("last30Days", customersToDate.last30Days);
    writer.writeNumberValue("last7Days", customersToDate.last7Days);
    writer.writeNumberValue("today", customersToDate.today);
    writer.writeNumberValue("total", customersToDate.total);
    writer.writeAdditionalData(customersToDate.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomersToDateHistory The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomersToDateHistory(writer: SerializationWriter, customersToDateHistory: Partial<CustomersToDateHistory> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customersToDateHistory || isSerializingDerivedType) { return; }
    writer.writeDateOnlyValue("from", customersToDateHistory.from);
    writer.writeEnumValue<ActivityGranularity>("granularity", customersToDateHistory.granularity);
    writer.writeCollectionOfObjectValues<CustomersCreatedInPeriod>("points", customersToDateHistory.points, serializeCustomersCreatedInPeriod);
    writer.writeDateOnlyValue("to", customersToDateHistory.to);
    writer.writeAdditionalData(customersToDateHistory.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummary(writer: SerializationWriter, customerSummary: Partial<CustomerSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummary || isSerializingDerivedType) { return; }
    writer.writeObjectValue<CustomerSummaryAddress>("address", customerSummary.address, serializeCustomerSummaryAddress);
    writer.writeCollectionOfPrimitiveValues<string>("affiliateCodes", customerSummary.affiliateCodes);
    writer.writeCollectionOfObjectValues<CustomerSummaryCharger>("chargers", customerSummary.chargers, serializeCustomerSummaryCharger);
    writer.writeObjectValue<CustomerSummaryCompanyRegistration>("companyRegistration", customerSummary.companyRegistration, serializeCustomerSummaryCompanyRegistration);
    writer.writeObjectValue<CustomerSummaryContact>("contact", customerSummary.contact, serializeCustomerSummaryContact);
    writer.writeNumberValue("contractCount", customerSummary.contractCount);
    writer.writeStringValue("createdBy", customerSummary.createdBy);
    writer.writeDateValue("createdDate", customerSummary.createdDate);
    writer.writeObjectValue<CustomerSummaryCurrentContract>("currentContract", customerSummary.currentContract, serializeCustomerSummaryCurrentContract);
    writer.writeNumberValue("currentContractCount", customerSummary.currentContractCount);
    writer.writeStringValue("customerReference", customerSummary.customerReference);
    writer.writeEnumValue<CustomerType>("customerType", customerSummary.customerType);
    writer.writeStringValue("externalCustomerId", customerSummary.externalCustomerId);
    writer.writeGuidValue("id", customerSummary.id);
    writer.writeStringValue("lastModifiedBy", customerSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", customerSummary.lastModifiedDate);
    writer.writeDateValue("lastSeenAt", customerSummary.lastSeenAt);
    writer.writeNumberValue("locationCount", customerSummary.locationCount);
    writer.writeStringValue("name", customerSummary.name);
    writer.writeCollectionOfPrimitiveValues<string>("tags", customerSummary.tags);
    writer.writeAdditionalData(customerSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummaryAddress The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummaryAddress(writer: SerializationWriter, customerSummaryAddress: Partial<CustomerSummaryAddress> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummaryAddress || isSerializingDerivedType) { return; }
    writer.writeEnumValue<AddressType>("addressType", customerSummaryAddress.addressType);
    writer.writeStringValue("city", customerSummaryAddress.city);
    writer.writeStringValue("houseNumber", customerSummaryAddress.houseNumber);
    writer.writeStringValue("postcode", customerSummaryAddress.postcode);
    writer.writeStringValue("street", customerSummaryAddress.street);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", customerSummaryAddress.verificationStatus);
    writer.writeAdditionalData(customerSummaryAddress.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummaryCharger The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummaryCharger(writer: SerializationWriter, customerSummaryCharger: Partial<CustomerSummaryCharger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummaryCharger || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", customerSummaryCharger.deviceId);
    writer.writeStringValue("make", customerSummaryCharger.make);
    writer.writeEnumValue<MidMeterType>("midMeter", customerSummaryCharger.midMeter);
    writer.writeStringValue("model", customerSummaryCharger.model);
    writer.writeAdditionalData(customerSummaryCharger.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummaryCompanyRegistration The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummaryCompanyRegistration(writer: SerializationWriter, customerSummaryCompanyRegistration: Partial<CustomerSummaryCompanyRegistration> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummaryCompanyRegistration || isSerializingDerivedType) { return; }
    writer.writeStringValue("officeNumber", customerSummaryCompanyRegistration.officeNumber);
    writer.writeEnumValue<OfficeType>("officeType", customerSummaryCompanyRegistration.officeType);
    writer.writeStringValue("registrationName", customerSummaryCompanyRegistration.registrationName);
    writer.writeStringValue("registrationNumber", customerSummaryCompanyRegistration.registrationNumber);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", customerSummaryCompanyRegistration.verificationStatus);
    writer.writeAdditionalData(customerSummaryCompanyRegistration.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummaryContact The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummaryContact(writer: SerializationWriter, customerSummaryContact: Partial<CustomerSummaryContact> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummaryContact || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", customerSummaryContact.email);
    writer.writeStringValue("name", customerSummaryContact.name);
    writer.writeStringValue("phoneNumber", customerSummaryContact.phoneNumber);
    writer.writeAdditionalData(customerSummaryContact.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerSummaryCurrentContract The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerSummaryCurrentContract(writer: SerializationWriter, customerSummaryCurrentContract: Partial<CustomerSummaryCurrentContract> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerSummaryCurrentContract || isSerializingDerivedType) { return; }
    writer.writeStringValue("contractReference", customerSummaryCurrentContract.contractReference);
    writer.writeGuidValue("id", customerSummaryCurrentContract.id);
    writer.writeBooleanValue("isEligibleForPayout", customerSummaryCurrentContract.isEligibleForPayout);
    writer.writeBooleanValue("isEligibleForRegistration", customerSummaryCurrentContract.isEligibleForRegistration);
    writer.writeBooleanValue("isEligibleForTransaction", customerSummaryCurrentContract.isEligibleForTransaction);
    writer.writeDateOnlyValue("validFrom", customerSummaryCurrentContract.validFrom);
    writer.writeDateOnlyValue("validTo", customerSummaryCurrentContract.validTo);
    writer.writeAdditionalData(customerSummaryCurrentContract.additionalData);
}
/**
 * Serializes information the current object
 * @param CustomerTagCount The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCustomerTagCount(writer: SerializationWriter, customerTagCount: Partial<CustomerTagCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!customerTagCount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customers", customerTagCount.customers);
    writer.writeCollectionOfObjectValues<TagNamespaceCount>("groups", customerTagCount.groups, serializeTagNamespaceCount);
    writer.writeAdditionalData(customerTagCount.additionalData);
}
/**
 * Serializes information the current object
 * @param DataSharingGrantSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDataSharingGrantSummary(writer: SerializationWriter, dataSharingGrantSummary: Partial<DataSharingGrantSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dataSharingGrantSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("applicationName", dataSharingGrantSummary.applicationName);
    writer.writeStringValue("clientId", dataSharingGrantSummary.clientId);
    writer.writeGuidValue("customerId", dataSharingGrantSummary.customerId);
    writer.writeDateValue("grantedAt", dataSharingGrantSummary.grantedAt);
    writer.writeGuidValue("id", dataSharingGrantSummary.id);
    writer.writeBooleanValue("isActive", dataSharingGrantSummary.isActive);
    writer.writeStringValue("lastModifiedBy", dataSharingGrantSummary.lastModifiedBy);
    writer.writeDateValue("revokedAt", dataSharingGrantSummary.revokedAt);
    writer.writeAdditionalData(dataSharingGrantSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param DocumentChargePoint The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentChargePoint(writer: SerializationWriter, documentChargePoint: Partial<DocumentChargePoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!documentChargePoint || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", documentChargePoint.id);
    writer.writeStringValue("name", documentChargePoint.name);
    writer.writeAdditionalData(documentChargePoint.additionalData);
}
/**
 * Serializes information the current object
 * @param DocumentRejectionReasons The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentRejectionReasons(writer: SerializationWriter, documentRejectionReasons: Partial<DocumentRejectionReasons> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!documentRejectionReasons || isSerializingDerivedType) { return; }
    if(documentRejectionReasons.reasons)
    writer.writeCollectionOfEnumValues<RejectionReason>("reasons", documentRejectionReasons.reasons);
    writer.writeEnumValue<ContractDocumentType>("type", documentRejectionReasons.type);
    writer.writeAdditionalData(documentRejectionReasons.additionalData);
}
/**
 * Serializes information the current object
 * @param DocumentReview The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentReview(writer: SerializationWriter, documentReview: Partial<DocumentReview> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!documentReview || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ApprovalStatus>("approvalStatus", documentReview.approvalStatus);
    writer.writeStringValue("reviewedBy", documentReview.reviewedBy);
    writer.writeDateValue("reviewedDate", documentReview.reviewedDate);
    writer.writeAdditionalData(documentReview.additionalData);
}
/**
 * Serializes information the current object
 * @param DocumentSummary The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDocumentSummary(writer: SerializationWriter, documentSummary: Partial<DocumentSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!documentSummary || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ApprovalStatus>("approvalStatus", documentSummary.approvalStatus);
    writer.writeGuidValue("chargePointId", documentSummary.chargePointId);
    writer.writeCollectionOfObjectValues<DocumentChargePoint>("chargePoints", documentSummary.chargePoints, serializeDocumentChargePoint);
    writer.writeStringValue("contentType", documentSummary.contentType);
    writer.writeGuidValue("contractId", documentSummary.contractId);
    writer.writeStringValue("contractReference", documentSummary.contractReference);
    writer.writeStringValue("createdBy", documentSummary.createdBy);
    writer.writeDateValue("createdDate", documentSummary.createdDate);
    writer.writeGuidValue("customerId", documentSummary.customerId);
    writer.writeStringValue("fileName", documentSummary.fileName);
    writer.writeNumberValue("fileSize", documentSummary.fileSize);
    writer.writeGuidValue("id", documentSummary.id);
    writer.writeGuidValue("locationId", documentSummary.locationId);
    writer.writeStringValue("locationName", documentSummary.locationName);
    writer.writeStringValue("rejectionNote", documentSummary.rejectionNote);
    writer.writeEnumValue<RejectionReason>("rejectionReason", documentSummary.rejectionReason);
    writer.writeEnumValue<ContractDocumentType>("type", documentSummary.type);
    writer.writeAdditionalData(documentSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param EnqueueBackfillChargerMakesAndModelsResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnqueueBackfillChargerMakesAndModelsResult(writer: SerializationWriter, enqueueBackfillChargerMakesAndModelsResult: Partial<EnqueueBackfillChargerMakesAndModelsResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!enqueueBackfillChargerMakesAndModelsResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("connections", enqueueBackfillChargerMakesAndModelsResult.connections);
    writer.writeAdditionalData(enqueueBackfillChargerMakesAndModelsResult.additionalData);
}
/**
 * Serializes information the current object
 * @param EnqueueFetchChargePointConsumptionCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnqueueFetchChargePointConsumptionCommand(writer: SerializationWriter, enqueueFetchChargePointConsumptionCommand: Partial<EnqueueFetchChargePointConsumptionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!enqueueFetchChargePointConsumptionCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<OAuthProviderType>("provider", enqueueFetchChargePointConsumptionCommand.provider);
    writer.writeBooleanValue("refetch", enqueueFetchChargePointConsumptionCommand.refetch);
    writer.writeAdditionalData(enqueueFetchChargePointConsumptionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param EnqueueFetchChargePointConsumptionResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEnqueueFetchChargePointConsumptionResult(writer: SerializationWriter, enqueueFetchChargePointConsumptionResult: Partial<EnqueueFetchChargePointConsumptionResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!enqueueFetchChargePointConsumptionResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("fetchedCount", enqueueFetchChargePointConsumptionResult.fetchedCount);
    writer.writeAdditionalData(enqueueFetchChargePointConsumptionResult.additionalData);
}
/**
 * Serializes information the current object
 * @param FetchChargePointConsumptionCommand The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFetchChargePointConsumptionCommand(writer: SerializationWriter, fetchChargePointConsumptionCommand: Partial<FetchChargePointConsumptionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fetchChargePointConsumptionCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("chargerId", fetchChargePointConsumptionCommand.chargerId);
    writer.writeStringValue("externalCustomerId", fetchChargePointConsumptionCommand.externalCustomerId);
    writer.writeEnumValue<OAuthProviderType>("provider", fetchChargePointConsumptionCommand.provider);
    writer.writeAdditionalData(fetchChargePointConsumptionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param FetchChargePointConsumptionResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFetchChargePointConsumptionResult(writer: SerializationWriter, fetchChargePointConsumptionResult: Partial<FetchChargePointConsumptionResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fetchChargePointConsumptionResult || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("accessDenied", fetchChargePointConsumptionResult.accessDenied);
    writer.writeNumberValue("consumptionTotal", fetchChargePointConsumptionResult.consumptionTotal);
    writer.writeDateValue("lastIngestedAt", fetchChargePointConsumptionResult.lastIngestedAt);
    writer.writeBooleanValue("notConnected", fetchChargePointConsumptionResult.notConnected);
    writer.writeBooleanValue("rateLimited", fetchChargePointConsumptionResult.rateLimited);
    writer.writeNumberValue("sessionCount", fetchChargePointConsumptionResult.sessionCount);
    writer.writeNumberValue("skippedDuplicateCount", fetchChargePointConsumptionResult.skippedDuplicateCount);
    writer.writeNumberValue("skippedInvalidCount", fetchChargePointConsumptionResult.skippedInvalidCount);
    writer.writeAdditionalData(fetchChargePointConsumptionResult.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestAffiliateCustomerOrchestrationResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestAffiliateCustomerOrchestrationResult(writer: SerializationWriter, ingestAffiliateCustomerOrchestrationResult: Partial<IngestAffiliateCustomerOrchestrationResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestAffiliateCustomerOrchestrationResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("acceptedCount", ingestAffiliateCustomerOrchestrationResult.acceptedCount);
    writer.writeNumberValue("customerCount", ingestAffiliateCustomerOrchestrationResult.customerCount);
    writer.writeCollectionOfObjectValues<IngestAffiliateCustomerReport>("customers", ingestAffiliateCustomerOrchestrationResult.customers, serializeIngestAffiliateCustomerReport);
    writer.writeNumberValue("rowCount", ingestAffiliateCustomerOrchestrationResult.rowCount);
    writer.writeNumberValue("scheduledCount", ingestAffiliateCustomerOrchestrationResult.scheduledCount);
    writer.writeStringValue("tag", ingestAffiliateCustomerOrchestrationResult.tag);
    writer.writeAdditionalData(ingestAffiliateCustomerOrchestrationResult.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestAffiliateCustomerReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestAffiliateCustomerReport(writer: SerializationWriter, ingestAffiliateCustomerReport: Partial<IngestAffiliateCustomerReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestAffiliateCustomerReport || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", ingestAffiliateCustomerReport.email);
    writer.writeStringValue("name", ingestAffiliateCustomerReport.name);
    writer.writeEnumValue<IngestAffiliateCustomerOutcome>("outcome", ingestAffiliateCustomerReport.outcome);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestAffiliateCustomerReport.reasons);
    writer.writeCollectionOfPrimitiveValues<number>("rows", ingestAffiliateCustomerReport.rows);
    writer.writeAdditionalData(ingestAffiliateCustomerReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestBusinessCustomerReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestBusinessCustomerReport(writer: SerializationWriter, ingestBusinessCustomerReport: Partial<IngestBusinessCustomerReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestBusinessCustomerReport || isSerializingDerivedType) { return; }
    writer.writeStringValue("companyName", ingestBusinessCustomerReport.companyName);
    writer.writeEnumValue<IngestOutcome>("customer", ingestBusinessCustomerReport.customer);
    writer.writeStringValue("email", ingestBusinessCustomerReport.email);
    writer.writeStringValue("externalCustomerId", ingestBusinessCustomerReport.externalCustomerId);
    writer.writeCollectionOfObjectValues<IngestBusinessLocationReport>("locations", ingestBusinessCustomerReport.locations, serializeIngestBusinessLocationReport);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestBusinessCustomerReport.reasons);
    writer.writeStringValue("registrationNumber", ingestBusinessCustomerReport.registrationNumber);
    writer.writeCollectionOfPrimitiveValues<string>("rowNumbers", ingestBusinessCustomerReport.rowNumbers);
    writer.writeCollectionOfPrimitiveValues<number>("rows", ingestBusinessCustomerReport.rows);
    writer.writeCollectionOfPrimitiveValues<string>("tags", ingestBusinessCustomerReport.tags);
    writer.writeAdditionalData(ingestBusinessCustomerReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestBusinessCustomerWithContractOrchestrationResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestBusinessCustomerWithContractOrchestrationResult(writer: SerializationWriter, ingestBusinessCustomerWithContractOrchestrationResult: Partial<IngestBusinessCustomerWithContractOrchestrationResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestBusinessCustomerWithContractOrchestrationResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customerCount", ingestBusinessCustomerWithContractOrchestrationResult.customerCount);
    writer.writeCollectionOfObjectValues<IngestBusinessCustomerReport>("customers", ingestBusinessCustomerWithContractOrchestrationResult.customers, serializeIngestBusinessCustomerReport);
    writer.writeNumberValue("rowCount", ingestBusinessCustomerWithContractOrchestrationResult.rowCount);
    writer.writeNumberValue("scheduledCount", ingestBusinessCustomerWithContractOrchestrationResult.scheduledCount);
    writer.writeAdditionalData(ingestBusinessCustomerWithContractOrchestrationResult.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestBusinessLocationReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestBusinessLocationReport(writer: SerializationWriter, ingestBusinessLocationReport: Partial<IngestBusinessLocationReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestBusinessLocationReport || isSerializingDerivedType) { return; }
    writer.writeEnumValue<IngestOutcome>("chargePoints", ingestBusinessLocationReport.chargePoints);
    writer.writeEnumValue<IngestOutcome>("contract", ingestBusinessLocationReport.contract);
    writer.writeCollectionOfPrimitiveValues<string>("deviceIds", ingestBusinessLocationReport.deviceIds);
    writer.writeEnumValue<IngestOutcome>("location", ingestBusinessLocationReport.location);
    writer.writeStringValue("name", ingestBusinessLocationReport.name);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestBusinessLocationReport.reasons);
    writer.writeNumberValue("row", ingestBusinessLocationReport.row);
    writer.writeStringValue("rowNumber", ingestBusinessLocationReport.rowNumber);
    writer.writeAdditionalData(ingestBusinessLocationReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestChargePointReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestChargePointReport(writer: SerializationWriter, ingestChargePointReport: Partial<IngestChargePointReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestChargePointReport || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", ingestChargePointReport.deviceId);
    writer.writeEnumValue<IngestOutcome>("outcome", ingestChargePointReport.outcome);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestChargePointReport.reasons);
    writer.writeNumberValue("row", ingestChargePointReport.row);
    writer.writeAdditionalData(ingestChargePointReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestConsumerCustomerReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestConsumerCustomerReport(writer: SerializationWriter, ingestConsumerCustomerReport: Partial<IngestConsumerCustomerReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestConsumerCustomerReport || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<IngestChargePointReport>("chargePoints", ingestConsumerCustomerReport.chargePoints, serializeIngestChargePointReport);
    writer.writeEnumValue<IngestOutcome>("contract", ingestConsumerCustomerReport.contract);
    writer.writeEnumValue<IngestOutcome>("customer", ingestConsumerCustomerReport.customer);
    writer.writeStringValue("email", ingestConsumerCustomerReport.email);
    writer.writeStringValue("externalCustomerId", ingestConsumerCustomerReport.externalCustomerId);
    writer.writeEnumValue<LegacyCompliancyStatus>("legacyCompliancyStatus", ingestConsumerCustomerReport.legacyCompliancyStatus);
    writer.writeStringValue("legacyCustomerId", ingestConsumerCustomerReport.legacyCustomerId);
    writer.writeStringValue("name", ingestConsumerCustomerReport.name);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestConsumerCustomerReport.reasons);
    writer.writeCollectionOfPrimitiveValues<number>("rows", ingestConsumerCustomerReport.rows);
    writer.writeCollectionOfPrimitiveValues<string>("tags", ingestConsumerCustomerReport.tags);
    writer.writeAdditionalData(ingestConsumerCustomerReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestConsumerCustomerWithContractOrchestrationResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestConsumerCustomerWithContractOrchestrationResult(writer: SerializationWriter, ingestConsumerCustomerWithContractOrchestrationResult: Partial<IngestConsumerCustomerWithContractOrchestrationResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestConsumerCustomerWithContractOrchestrationResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customerCount", ingestConsumerCustomerWithContractOrchestrationResult.customerCount);
    writer.writeCollectionOfObjectValues<IngestConsumerCustomerReport>("customers", ingestConsumerCustomerWithContractOrchestrationResult.customers, serializeIngestConsumerCustomerReport);
    writer.writeNumberValue("rowCount", ingestConsumerCustomerWithContractOrchestrationResult.rowCount);
    writer.writeNumberValue("scheduledCount", ingestConsumerCustomerWithContractOrchestrationResult.scheduledCount);
    writer.writeAdditionalData(ingestConsumerCustomerWithContractOrchestrationResult.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestManualChargePointConsumptionResult The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestManualChargePointConsumptionResult(writer: SerializationWriter, ingestManualChargePointConsumptionResult: Partial<IngestManualChargePointConsumptionResult> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestManualChargePointConsumptionResult || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumptionTotal", ingestManualChargePointConsumptionResult.consumptionTotal);
    writer.writeCollectionOfObjectValues<IngestManualConsumptionCustomerReport>("customers", ingestManualChargePointConsumptionResult.customers, serializeIngestManualConsumptionCustomerReport);
    writer.writeNumberValue("ingestedCount", ingestManualChargePointConsumptionResult.ingestedCount);
    writer.writeNumberValue("rowCount", ingestManualChargePointConsumptionResult.rowCount);
    writer.writeNumberValue("skippedDuplicateCount", ingestManualChargePointConsumptionResult.skippedDuplicateCount);
    writer.writeNumberValue("skippedInvalidCount", ingestManualChargePointConsumptionResult.skippedInvalidCount);
    writer.writeAdditionalData(ingestManualChargePointConsumptionResult.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestManualConsumptionCustomerReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestManualConsumptionCustomerReport(writer: SerializationWriter, ingestManualConsumptionCustomerReport: Partial<IngestManualConsumptionCustomerReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestManualConsumptionCustomerReport || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", ingestManualConsumptionCustomerReport.email);
    writer.writeStringValue("externalCustomerId", ingestManualConsumptionCustomerReport.externalCustomerId);
    writer.writeStringValue("legacyCustomerId", ingestManualConsumptionCustomerReport.legacyCustomerId);
    writer.writeStringValue("name", ingestManualConsumptionCustomerReport.name);
    writer.writeCollectionOfObjectValues<IngestManualConsumptionReadingReport>("readings", ingestManualConsumptionCustomerReport.readings, serializeIngestManualConsumptionReadingReport);
    writer.writeAdditionalData(ingestManualConsumptionCustomerReport.additionalData);
}
/**
 * Serializes information the current object
 * @param IngestManualConsumptionReadingReport The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIngestManualConsumptionReadingReport(writer: SerializationWriter, ingestManualConsumptionReadingReport: Partial<IngestManualConsumptionReadingReport> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ingestManualConsumptionReadingReport || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", ingestManualConsumptionReadingReport.consumption);
    writer.writeStringValue("consumptionId", ingestManualConsumptionReadingReport.consumptionId);
    writer.writeStringValue("deviceId", ingestManualConsumptionReadingReport.deviceId);
    writer.writeCollectionOfPrimitiveValues<string>("notes", ingestManualConsumptionReadingReport.notes);
    writer.writeEnumValue<ManualReadingOutcome>("outcome", ingestManualConsumptionReadingReport.outcome);
    writer.writeCollectionOfPrimitiveValues<string>("reasons", ingestManualConsumptionReadingReport.reasons);
    writer.writeDateValue("receivedAt", ingestManualConsumptionReadingReport.receivedAt);
    writer.writeNumberValue("row", ingestManualConsumptionReadingReport.row);
    writer.writeDateValue("timestamp", ingestManualConsumptionReadingReport.timestamp);
    writer.writeAdditionalData(ingestManualConsumptionReadingReport.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Ledger The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLedger(writer: SerializationWriter, ledger: Partial<Ledger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ledger || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<LedgerAccount>("accounts", ledger.accounts, serializeLedgerAccount);
    writer.writeNumberValue("accountsCount", ledger.accountsCount);
    writer.writeStringValue("createdBy", ledger.createdBy);
    writer.writeDateValue("createdDate", ledger.createdDate);
    writer.writeEnumValue<CurrencyType>("currency", ledger.currency);
    writer.writeGuidValue("id", ledger.id);
    writer.writeStringValue("lastModifiedBy", ledger.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", ledger.lastModifiedDate);
    writer.writeStringValue("name", ledger.name);
    writer.writeNumberValue("totalBalance", ledger.totalBalance);
    writer.writeNumberValue("totalPendingBalance", ledger.totalPendingBalance);
    writer.writeAdditionalData(ledger.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LedgerAccount The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLedgerAccount(writer: SerializationWriter, ledgerAccount: Partial<LedgerAccount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ledgerAccount || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountNumber", ledgerAccount.accountNumber);
    writer.writeNumberValue("balance", ledgerAccount.balance);
    writer.writeGuidValue("contractId", ledgerAccount.contractId);
    writer.writeStringValue("contractReference", ledgerAccount.contractReference);
    writer.writeStringValue("customerEmail", ledgerAccount.customerEmail);
    writer.writeGuidValue("customerId", ledgerAccount.customerId);
    writer.writeStringValue("customerName", ledgerAccount.customerName);
    writer.writeGuidValue("id", ledgerAccount.id);
    writer.writeGuidValue("locationId", ledgerAccount.locationId);
    writer.writeStringValue("meteringPointCity", ledgerAccount.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", ledgerAccount.meteringPointEanCode);
    writer.writeStringValue("meteringPointHouseNumber", ledgerAccount.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", ledgerAccount.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", ledgerAccount.meteringPointStreet);
    writer.writeStringValue("name", ledgerAccount.name);
    writer.writeNumberValue("pendingBalance", ledgerAccount.pendingBalance);
    writer.writeAdditionalData(ledgerAccount.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LedgerSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLedgerSummary(writer: SerializationWriter, ledgerSummary: Partial<LedgerSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!ledgerSummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("accountsCount", ledgerSummary.accountsCount);
    writer.writeStringValue("createdBy", ledgerSummary.createdBy);
    writer.writeDateValue("createdDate", ledgerSummary.createdDate);
    writer.writeEnumValue<CurrencyType>("currency", ledgerSummary.currency);
    writer.writeGuidValue("id", ledgerSummary.id);
    writer.writeStringValue("lastModifiedBy", ledgerSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", ledgerSummary.lastModifiedDate);
    writer.writeStringValue("name", ledgerSummary.name);
    writer.writeNumberValue("totalBalance", ledgerSummary.totalBalance);
    writer.writeNumberValue("totalPendingBalance", ledgerSummary.totalPendingBalance);
    writer.writeAdditionalData(ledgerSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LinkCallToCustomerCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLinkCallToCustomerCommand(writer: SerializationWriter, linkCallToCustomerCommand: Partial<LinkCallToCustomerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!linkCallToCustomerCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("callId", linkCallToCustomerCommand.callId);
    writer.writeGuidValue("customerId", linkCallToCustomerCommand.customerId);
    writer.writeBooleanValue("replacePhoneNumber", linkCallToCustomerCommand.replacePhoneNumber);
    writer.writeAdditionalData(linkCallToCustomerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Location The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocation(writer: SerializationWriter, location: Partial<Location> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!location || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<LocationChargePoint>("chargePoints", location.chargePoints, serializeLocationChargePoint);
    writer.writeEnumValue<ConnectionType>("connectionType", location.connectionType);
    writer.writeCollectionOfObjectValues<LocationContract>("contracts", location.contracts, serializeLocationContract);
    writer.writeStringValue("createdBy", location.createdBy);
    writer.writeDateValue("createdDate", location.createdDate);
    writer.writeGuidValue("customerId", location.customerId);
    writer.writeObjectValue<LocationInstallation>("essInstallation", location.essInstallation, serializeLocationInstallation);
    writer.writeBooleanValue("hasEssInstallation", location.hasEssInstallation);
    writer.writeBooleanValue("hasPvInstallation", location.hasPvInstallation);
    writer.writeGuidValue("id", location.id);
    writer.writeStringValue("lastModifiedBy", location.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", location.lastModifiedDate);
    writer.writeObjectValue<LocationMeteringPoint>("meteringPoint", location.meteringPoint, serializeLocationMeteringPoint);
    writer.writeStringValue("name", location.name);
    writer.writeObjectValue<LocationInstallation>("pvInstallation", location.pvInstallation, serializeLocationInstallation);
    writer.writeAdditionalData(location.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationAddress The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationAddress(writer: SerializationWriter, locationAddress: Partial<LocationAddress> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationAddress || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", locationAddress.city);
    writer.writeStringValue("houseNumber", locationAddress.houseNumber);
    writer.writeStringValue("postcode", locationAddress.postcode);
    writer.writeStringValue("street", locationAddress.street);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", locationAddress.verificationStatus);
    writer.writeAdditionalData(locationAddress.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationChargePoint The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationChargePoint(writer: SerializationWriter, locationChargePoint: Partial<LocationChargePoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationChargePoint || isSerializingDerivedType) { return; }
    writer.writeObjectValue<LocationCharger>("charger", locationChargePoint.charger, serializeLocationCharger);
    writer.writeGuidValue("id", locationChargePoint.id);
    writer.writeStringValue("name", locationChargePoint.name);
    writer.writeAdditionalData(locationChargePoint.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationCharger The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationCharger(writer: SerializationWriter, locationCharger: Partial<LocationCharger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationCharger || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", locationCharger.deviceId);
    writer.writeStringValue("make", locationCharger.make);
    writer.writeEnumValue<MidMeterType>("midMeter", locationCharger.midMeter);
    writer.writeStringValue("model", locationCharger.model);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", locationCharger.verificationStatus);
    writer.writeAdditionalData(locationCharger.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationConsumptionWithProjection The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationConsumptionWithProjection(writer: SerializationWriter, locationConsumptionWithProjection: Partial<LocationConsumptionWithProjection> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationConsumptionWithProjection || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", locationConsumptionWithProjection.consumption);
    writer.writeGuidValue("contractId", locationConsumptionWithProjection.contractId);
    writer.writeNumberValue("expectedConsumption", locationConsumptionWithProjection.expectedConsumption);
    writer.writeNumberValue("expectedPayoutAmount", locationConsumptionWithProjection.expectedPayoutAmount);
    writer.writeNumberValue("expectedUnits", locationConsumptionWithProjection.expectedUnits);
    writer.writeNumberValue("expectedYield", locationConsumptionWithProjection.expectedYield);
    writer.writeGuidValue("id", locationConsumptionWithProjection.id);
    writer.writeGuidValue("locationId", locationConsumptionWithProjection.locationId);
    writer.writeNumberValue("payoutAmount", locationConsumptionWithProjection.payoutAmount);
    writer.writeDateOnlyValue("periodFrom", locationConsumptionWithProjection.periodFrom);
    writer.writeDateOnlyValue("periodTo", locationConsumptionWithProjection.periodTo);
    writer.writeDateOnlyValue("projectionDate", locationConsumptionWithProjection.projectionDate);
    writer.writeNumberValue("registeredConsumption", locationConsumptionWithProjection.registeredConsumption);
    writer.writeNumberValue("registeredPayoutAmount", locationConsumptionWithProjection.registeredPayoutAmount);
    writer.writeDateOnlyValue("registeredTo", locationConsumptionWithProjection.registeredTo);
    writer.writeNumberValue("registeredUnits", locationConsumptionWithProjection.registeredUnits);
    writer.writeNumberValue("registeredYield", locationConsumptionWithProjection.registeredYield);
    writer.writeNumberValue("units", locationConsumptionWithProjection.units);
    writer.writeNumberValue("yield", locationConsumptionWithProjection.yield);
    writer.writeAdditionalData(locationConsumptionWithProjection.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationContract The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationContract(writer: SerializationWriter, locationContract: Partial<LocationContract> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationContract || isSerializingDerivedType) { return; }
    writer.writeObjectValue<LocationContractAffiliateCondition>("affiliateCondition", locationContract.affiliateCondition, serializeLocationContractAffiliateCondition);
    writer.writeEnumValue<ComplianceStatus>("complianceStatus", locationContract.complianceStatus);
    writer.writeStringValue("contractReference", locationContract.contractReference);
    writer.writeDateOnlyValue("contractRevokedDate", locationContract.contractRevokedDate);
    writer.writeDateOnlyValue("contractSignedDate", locationContract.contractSignedDate);
    writer.writeGuidValue("id", locationContract.id);
    writer.writeBooleanValue("isEligibleForPayout", locationContract.isEligibleForPayout);
    writer.writeBooleanValue("isEligibleForRegistration", locationContract.isEligibleForRegistration);
    writer.writeBooleanValue("isEligibleForTransaction", locationContract.isEligibleForTransaction);
    writer.writeDateOnlyValue("mandateRevokedDate", locationContract.mandateRevokedDate);
    writer.writeDateOnlyValue("mandateSignedDate", locationContract.mandateSignedDate);
    writer.writeCollectionOfObjectValues<ContractComplianceItem>("openItems", locationContract.openItems, serializeContractComplianceItem);
    writer.writeDateOnlyValue("validFrom", locationContract.validFrom);
    writer.writeDateOnlyValue("validTo", locationContract.validTo);
    writer.writeAdditionalData(locationContract.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationContractAffiliateCondition The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationContractAffiliateCondition(writer: SerializationWriter, locationContractAffiliateCondition: Partial<LocationContractAffiliateCondition> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationContractAffiliateCondition || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", locationContractAffiliateCondition.affiliateCode);
    writer.writeNumberValue("discountPercentage", locationContractAffiliateCondition.discountPercentage);
    writer.writeStringValue("name", locationContractAffiliateCondition.name);
    writer.writeAdditionalData(locationContractAffiliateCondition.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationInstallation The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationInstallation(writer: SerializationWriter, locationInstallation: Partial<LocationInstallation> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationInstallation || isSerializingDerivedType) { return; }
    writer.writeNumberValue("capacity", locationInstallation.capacity);
    writer.writeStringValue("make", locationInstallation.make);
    writer.writeStringValue("model", locationInstallation.model);
    writer.writeStringValue("notes", locationInstallation.notes);
    writer.writeAdditionalData(locationInstallation.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationMeteringPoint The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationMeteringPoint(writer: SerializationWriter, locationMeteringPoint: Partial<LocationMeteringPoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationMeteringPoint || isSerializingDerivedType) { return; }
    writer.writeObjectValue<LocationAddress>("address", locationMeteringPoint.address, serializeLocationAddress);
    writer.writeStringValue("eanCode", locationMeteringPoint.eanCode);
    writer.writeStringValue("gridOperator", locationMeteringPoint.gridOperator);
    writer.writeStringValue("gridOperatorEanCode", locationMeteringPoint.gridOperatorEanCode);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", locationMeteringPoint.verificationStatus);
    writer.writeAdditionalData(locationMeteringPoint.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationSummary(writer: SerializationWriter, locationSummary: Partial<LocationSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationSummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("chargePointCount", locationSummary.chargePointCount);
    writer.writeNumberValue("contractCount", locationSummary.contractCount);
    writer.writeGuidValue("currentContractId", locationSummary.currentContractId);
    writer.writeGuidValue("customerId", locationSummary.customerId);
    writer.writeBooleanValue("hasEssInstallation", locationSummary.hasEssInstallation);
    writer.writeBooleanValue("hasPvInstallation", locationSummary.hasPvInstallation);
    writer.writeGuidValue("id", locationSummary.id);
    writer.writeObjectValue<LocationSummaryMeteringPoint>("meteringPoint", locationSummary.meteringPoint, serializeLocationSummaryMeteringPoint);
    writer.writeStringValue("name", locationSummary.name);
    writer.writeNumberValue("pendingChargePointCount", locationSummary.pendingChargePointCount);
    writer.writeAdditionalData(locationSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationSummaryAddress The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationSummaryAddress(writer: SerializationWriter, locationSummaryAddress: Partial<LocationSummaryAddress> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationSummaryAddress || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", locationSummaryAddress.city);
    writer.writeStringValue("houseNumber", locationSummaryAddress.houseNumber);
    writer.writeStringValue("postcode", locationSummaryAddress.postcode);
    writer.writeStringValue("street", locationSummaryAddress.street);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", locationSummaryAddress.verificationStatus);
    writer.writeAdditionalData(locationSummaryAddress.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param LocationSummaryMeteringPoint The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeLocationSummaryMeteringPoint(writer: SerializationWriter, locationSummaryMeteringPoint: Partial<LocationSummaryMeteringPoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!locationSummaryMeteringPoint || isSerializingDerivedType) { return; }
    writer.writeObjectValue<LocationSummaryAddress>("address", locationSummaryMeteringPoint.address, serializeLocationSummaryAddress);
    writer.writeStringValue("eanCode", locationSummaryMeteringPoint.eanCode);
    writer.writeStringValue("gridOperator", locationSummaryMeteringPoint.gridOperator);
    writer.writeStringValue("gridOperatorEanCode", locationSummaryMeteringPoint.gridOperatorEanCode);
    writer.writeEnumValue<VerificationStatus>("verificationStatus", locationSummaryMeteringPoint.verificationStatus);
    writer.writeAdditionalData(locationSummaryMeteringPoint.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MandateSigningCount The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMandateSigningCount(writer: SerializationWriter, mandateSigningCount: Partial<MandateSigningCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!mandateSigningCount || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<YearMandateSigningCount>("years", mandateSigningCount.years, serializeYearMandateSigningCount);
    writer.writeAdditionalData(mandateSigningCount.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ManualConsumptionEntry The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeManualConsumptionEntry(writer: SerializationWriter, manualConsumptionEntry: Partial<ManualConsumptionEntry> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!manualConsumptionEntry || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", manualConsumptionEntry.consumption);
    writer.writeStringValue("id", manualConsumptionEntry.id);
    writer.writeEnumValue<ConsumptionProvider>("provider", manualConsumptionEntry.provider);
    writer.writeDateValue("receivedAt", manualConsumptionEntry.receivedAt);
    writer.writeEnumValue<ConsumptionSource>("source", manualConsumptionEntry.source);
    writer.writeBooleanValue("superseded", manualConsumptionEntry.superseded);
    writer.writeDateValue("timestamp", manualConsumptionEntry.timestamp);
    writer.writeAdditionalData(manualConsumptionEntry.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MessageDetail The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMessageDetail(writer: SerializationWriter, messageDetail: Partial<MessageDetail> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!messageDetail || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("bodyAvailable", messageDetail.bodyAvailable);
    writer.writeGuidValue("customerId", messageDetail.customerId);
    writer.writeStringValue("htmlBody", messageDetail.htmlBody);
    writer.writeGuidValue("id", messageDetail.id);
    writer.writeStringValue("recipient", messageDetail.recipient);
    writer.writeDateValue("sentDate", messageDetail.sentDate);
    writer.writeStringValue("subject", messageDetail.subject);
    writer.writeStringValue("textBody", messageDetail.textBody);
    writer.writeAdditionalData(messageDetail.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MessageSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMessageSummary(writer: SerializationWriter, messageSummary: Partial<MessageSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!messageSummary || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", messageSummary.customerId);
    writer.writeGuidValue("id", messageSummary.id);
    writer.writeStringValue("recipient", messageSummary.recipient);
    writer.writeDateValue("sentDate", messageSummary.sentDate);
    writer.writeStringValue("subject", messageSummary.subject);
    writer.writeAdditionalData(messageSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MeteringPointSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMeteringPointSummary(writer: SerializationWriter, meteringPointSummary: Partial<MeteringPointSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!meteringPointSummary || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", meteringPointSummary.city);
    writer.writeStringValue("eanCode", meteringPointSummary.eanCode);
    writer.writeStringValue("gridOperator", meteringPointSummary.gridOperator);
    writer.writeStringValue("gridOperatorEanCode", meteringPointSummary.gridOperatorEanCode);
    writer.writeStringValue("houseNumber", meteringPointSummary.houseNumber);
    writer.writeStringValue("postcode", meteringPointSummary.postcode);
    writer.writeBooleanValue("specialMeteringPoint", meteringPointSummary.specialMeteringPoint);
    writer.writeStringValue("street", meteringPointSummary.street);
    writer.writeAdditionalData(meteringPointSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MoveChargePointCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMoveChargePointCommand(writer: SerializationWriter, moveChargePointCommand: Partial<MoveChargePointCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!moveChargePointCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", moveChargePointCommand.id);
    writer.writeGuidValue("locationId", moveChargePointCommand.locationId);
    writer.writeAdditionalData(moveChargePointCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param OAuthConnectionCharger The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeOAuthConnectionCharger(writer: SerializationWriter, oAuthConnectionCharger: Partial<OAuthConnectionCharger> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!oAuthConnectionCharger || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", oAuthConnectionCharger.deviceId);
    writer.writeBooleanValue("isActive", oAuthConnectionCharger.isActive);
    writer.writeStringValue("make", oAuthConnectionCharger.make);
    writer.writeStringValue("model", oAuthConnectionCharger.model);
    writer.writeStringValue("name", oAuthConnectionCharger.name);
    writer.writeAdditionalData(oAuthConnectionCharger.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfAccountEntrySummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfAccountEntrySummary(writer: SerializationWriter, paginatedListOfAccountEntrySummary: Partial<PaginatedListOfAccountEntrySummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfAccountEntrySummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfAccountEntrySummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfAccountEntrySummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<AccountEntrySummary>("items", paginatedListOfAccountEntrySummary.items, serializeAccountEntrySummary);
    writer.writeNumberValue("pageNumber", paginatedListOfAccountEntrySummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfAccountEntrySummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfAccountEntrySummary.totalPages);
    writer.writeAdditionalData(paginatedListOfAccountEntrySummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfAccountSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfAccountSummary(writer: SerializationWriter, paginatedListOfAccountSummary: Partial<PaginatedListOfAccountSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfAccountSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfAccountSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfAccountSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<AccountSummary>("items", paginatedListOfAccountSummary.items, serializeAccountSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfAccountSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfAccountSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfAccountSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfAccountSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfAffiliateSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfAffiliateSummary(writer: SerializationWriter, paginatedListOfAffiliateSummary: Partial<PaginatedListOfAffiliateSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfAffiliateSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfAffiliateSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfAffiliateSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<AffiliateSummary>("items", paginatedListOfAffiliateSummary.items, serializeAffiliateSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfAffiliateSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfAffiliateSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfAffiliateSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfAffiliateSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfAuditEntrySummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfAuditEntrySummary(writer: SerializationWriter, paginatedListOfAuditEntrySummary: Partial<PaginatedListOfAuditEntrySummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfAuditEntrySummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfAuditEntrySummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfAuditEntrySummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<AuditEntrySummary>("items", paginatedListOfAuditEntrySummary.items, serializeAuditEntrySummary);
    writer.writeNumberValue("pageNumber", paginatedListOfAuditEntrySummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfAuditEntrySummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfAuditEntrySummary.totalPages);
    writer.writeAdditionalData(paginatedListOfAuditEntrySummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfCallSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfCallSummary(writer: SerializationWriter, paginatedListOfCallSummary: Partial<PaginatedListOfCallSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfCallSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfCallSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfCallSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<CallSummary>("items", paginatedListOfCallSummary.items, serializeCallSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfCallSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfCallSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfCallSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfCallSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfChargePointSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfChargePointSummary(writer: SerializationWriter, paginatedListOfChargePointSummary: Partial<PaginatedListOfChargePointSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfChargePointSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfChargePointSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfChargePointSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ChargePointSummary>("items", paginatedListOfChargePointSummary.items, serializeChargePointSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfChargePointSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfChargePointSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfChargePointSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfChargePointSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfChargerDefinitionSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfChargerDefinitionSummary(writer: SerializationWriter, paginatedListOfChargerDefinitionSummary: Partial<PaginatedListOfChargerDefinitionSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfChargerDefinitionSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfChargerDefinitionSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfChargerDefinitionSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ChargerDefinitionSummary>("items", paginatedListOfChargerDefinitionSummary.items, serializeChargerDefinitionSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfChargerDefinitionSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfChargerDefinitionSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfChargerDefinitionSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfChargerDefinitionSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfContractListItem The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfContractListItem(writer: SerializationWriter, paginatedListOfContractListItem: Partial<PaginatedListOfContractListItem> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfContractListItem || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfContractListItem.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfContractListItem.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ContractListItem>("items", paginatedListOfContractListItem.items, serializeContractListItem);
    writer.writeNumberValue("pageNumber", paginatedListOfContractListItem.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfContractListItem.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfContractListItem.totalPages);
    writer.writeAdditionalData(paginatedListOfContractListItem.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfContractSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfContractSummary(writer: SerializationWriter, paginatedListOfContractSummary: Partial<PaginatedListOfContractSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfContractSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfContractSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfContractSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ContractSummary>("items", paginatedListOfContractSummary.items, serializeContractSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfContractSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfContractSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfContractSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfContractSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfConversionFactorSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfConversionFactorSummary(writer: SerializationWriter, paginatedListOfConversionFactorSummary: Partial<PaginatedListOfConversionFactorSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfConversionFactorSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfConversionFactorSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfConversionFactorSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ConversionFactorSummary>("items", paginatedListOfConversionFactorSummary.items, serializeConversionFactorSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfConversionFactorSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfConversionFactorSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfConversionFactorSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfConversionFactorSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfCustomerSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfCustomerSummary(writer: SerializationWriter, paginatedListOfCustomerSummary: Partial<PaginatedListOfCustomerSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfCustomerSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfCustomerSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfCustomerSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<CustomerSummary>("items", paginatedListOfCustomerSummary.items, serializeCustomerSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfCustomerSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfCustomerSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfCustomerSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfCustomerSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfDocumentSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfDocumentSummary(writer: SerializationWriter, paginatedListOfDocumentSummary: Partial<PaginatedListOfDocumentSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfDocumentSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfDocumentSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfDocumentSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<DocumentSummary>("items", paginatedListOfDocumentSummary.items, serializeDocumentSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfDocumentSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfDocumentSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfDocumentSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfDocumentSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfLedgerSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfLedgerSummary(writer: SerializationWriter, paginatedListOfLedgerSummary: Partial<PaginatedListOfLedgerSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfLedgerSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfLedgerSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfLedgerSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<LedgerSummary>("items", paginatedListOfLedgerSummary.items, serializeLedgerSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfLedgerSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfLedgerSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfLedgerSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfLedgerSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfLocationSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfLocationSummary(writer: SerializationWriter, paginatedListOfLocationSummary: Partial<PaginatedListOfLocationSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfLocationSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfLocationSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfLocationSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<LocationSummary>("items", paginatedListOfLocationSummary.items, serializeLocationSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfLocationSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfLocationSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfLocationSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfLocationSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfMessageSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfMessageSummary(writer: SerializationWriter, paginatedListOfMessageSummary: Partial<PaginatedListOfMessageSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfMessageSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfMessageSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfMessageSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<MessageSummary>("items", paginatedListOfMessageSummary.items, serializeMessageSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfMessageSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfMessageSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfMessageSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfMessageSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfPayoutSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfPayoutSummary(writer: SerializationWriter, paginatedListOfPayoutSummary: Partial<PaginatedListOfPayoutSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfPayoutSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfPayoutSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfPayoutSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<PayoutSummary>("items", paginatedListOfPayoutSummary.items, serializePayoutSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfPayoutSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfPayoutSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfPayoutSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfPayoutSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfRegistrationSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfRegistrationSummary(writer: SerializationWriter, paginatedListOfRegistrationSummary: Partial<PaginatedListOfRegistrationSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfRegistrationSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfRegistrationSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfRegistrationSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<RegistrationSummary>("items", paginatedListOfRegistrationSummary.items, serializeRegistrationSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfRegistrationSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfRegistrationSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfRegistrationSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfRegistrationSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedListOfTransactionSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedListOfTransactionSummary(writer: SerializationWriter, paginatedListOfTransactionSummary: Partial<PaginatedListOfTransactionSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedListOfTransactionSummary || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedListOfTransactionSummary.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedListOfTransactionSummary.hasPreviousPage);
    writer.writeCollectionOfObjectValues<TransactionSummary>("items", paginatedListOfTransactionSummary.items, serializeTransactionSummary);
    writer.writeNumberValue("pageNumber", paginatedListOfTransactionSummary.pageNumber);
    writer.writeNumberValue("totalCount", paginatedListOfTransactionSummary.totalCount);
    writer.writeNumberValue("totalPages", paginatedListOfTransactionSummary.totalPages);
    writer.writeAdditionalData(paginatedListOfTransactionSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Payout The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePayout(writer: SerializationWriter, payout: Partial<Payout> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!payout || isSerializingDerivedType) { return; }
    writer.writeStringValue("createdBy", payout.createdBy);
    writer.writeDateValue("createdDate", payout.createdDate);
    writer.writeGuidValue("id", payout.id);
    writer.writeStringValue("lastModifiedBy", payout.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", payout.lastModifiedDate);
    writer.writeCollectionOfObjectValues<PayoutLine>("lines", payout.lines, serializePayoutLine);
    writer.writeStringValue("notes", payout.notes);
    writer.writeDateOnlyValue("payoutDate", payout.payoutDate);
    writer.writeStringValue("payoutReference", payout.payoutReference);
    writer.writeNumberValue("totalAmount", payout.totalAmount);
    writer.writeNumberValue("totalCommission", payout.totalCommission);
    writer.writeNumberValue("totalDiscount", payout.totalDiscount);
    writer.writeNumberValue("totalNetYield", payout.totalNetYield);
    writer.writeGuidValue("transactionId", payout.transactionId);
    writer.writeStringValue("transactionReference", payout.transactionReference);
    writer.writeAdditionalData(payout.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PayoutLine The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePayoutLine(writer: SerializationWriter, payoutLine: Partial<PayoutLine> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!payoutLine || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", payoutLine.amount);
    writer.writeNumberValue("commission", payoutLine.commission);
    writer.writeGuidValue("contractId", payoutLine.contractId);
    writer.writeStringValue("contractReference", payoutLine.contractReference);
    writer.writeStringValue("customerEmail", payoutLine.customerEmail);
    writer.writeGuidValue("customerId", payoutLine.customerId);
    writer.writeStringValue("customerName", payoutLine.customerName);
    writer.writeStringValue("customerReference", payoutLine.customerReference);
    writer.writeNumberValue("discount", payoutLine.discount);
    writer.writeGuidValue("id", payoutLine.id);
    writer.writeGuidValue("locationId", payoutLine.locationId);
    writer.writeStringValue("meteringPointCity", payoutLine.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", payoutLine.meteringPointEanCode);
    writer.writeStringValue("meteringPointHouseNumber", payoutLine.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", payoutLine.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", payoutLine.meteringPointStreet);
    writer.writeNumberValue("netYield", payoutLine.netYield);
    writer.writeNumberValue("percentage", payoutLine.percentage);
    writer.writeAdditionalData(payoutLine.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PayoutSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePayoutSummary(writer: SerializationWriter, payoutSummary: Partial<PayoutSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!payoutSummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("contractCount", payoutSummary.contractCount);
    writer.writeStringValue("createdBy", payoutSummary.createdBy);
    writer.writeDateValue("createdDate", payoutSummary.createdDate);
    writer.writeGuidValue("id", payoutSummary.id);
    writer.writeStringValue("lastModifiedBy", payoutSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", payoutSummary.lastModifiedDate);
    writer.writeDateOnlyValue("payoutDate", payoutSummary.payoutDate);
    writer.writeStringValue("payoutReference", payoutSummary.payoutReference);
    writer.writeNumberValue("totalAmount", payoutSummary.totalAmount);
    writer.writeNumberValue("totalCommission", payoutSummary.totalCommission);
    writer.writeNumberValue("totalDiscount", payoutSummary.totalDiscount);
    writer.writeNumberValue("totalNetYield", payoutSummary.totalNetYield);
    writer.writeAdditionalData(payoutSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProblemDetails The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProblemDetails(writer: SerializationWriter, problemDetails: Partial<ProblemDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!problemDetails || isSerializingDerivedType) { return; }
    writer.writeStringValue("detail", problemDetails.detail);
    writer.writeObjectValue<ProblemDetails_errors>("errors", problemDetails.errors, serializeProblemDetails_errors);
    writer.writeStringValue("instance", problemDetails.instance);
    writer.writeNumberValue("status", problemDetails.status);
    writer.writeStringValue("title", problemDetails.title);
    writer.writeStringValue("traceId", problemDetails.traceId);
    writer.writeStringValue("type", problemDetails.type);
    writer.writeAdditionalData(problemDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProblemDetails_errors The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProblemDetails_errors(writer: SerializationWriter, problemDetails_errors: Partial<ProblemDetails_errors> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!problemDetails_errors || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(problemDetails_errors.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ProlongContractCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeProlongContractCommand(writer: SerializationWriter, prolongContractCommand: Partial<ProlongContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!prolongContractCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", prolongContractCommand.id);
    writer.writeDateOnlyValue("validFrom", prolongContractCommand.validFrom);
    writer.writeDateOnlyValue("validTo", prolongContractCommand.validTo);
    writer.writeAdditionalData(prolongContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Registration The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegistration(writer: SerializationWriter, registration: Partial<Registration> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!registration || isSerializingDerivedType) { return; }
    writer.writeStringValue("createdBy", registration.createdBy);
    writer.writeDateValue("createdDate", registration.createdDate);
    writer.writeGuidValue("id", registration.id);
    writer.writeStringValue("lastModifiedBy", registration.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", registration.lastModifiedDate);
    writer.writeCollectionOfObjectValues<RegistrationLine>("lines", registration.lines, serializeRegistrationLine);
    writer.writeStringValue("notes", registration.notes);
    writer.writeDateOnlyValue("periodFrom", registration.periodFrom);
    writer.writeDateOnlyValue("periodTo", registration.periodTo);
    writer.writeDateOnlyValue("registrationDate", registration.registrationDate);
    writer.writeStringValue("registrationReference", registration.registrationReference);
    writer.writeNumberValue("totalConsumption", registration.totalConsumption);
    writer.writeNumberValue("totalUnits", registration.totalUnits);
    writer.writeAdditionalData(registration.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RegistrationLine The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegistrationLine(writer: SerializationWriter, registrationLine: Partial<RegistrationLine> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!registrationLine || isSerializingDerivedType) { return; }
    writer.writeNumberValue("consumption", registrationLine.consumption);
    writer.writeEnumValue<ConsumptionType>("consumptionType", registrationLine.consumptionType);
    writer.writeGuidValue("contractId", registrationLine.contractId);
    writer.writeStringValue("contractReference", registrationLine.contractReference);
    writer.writeStringValue("customerEmail", registrationLine.customerEmail);
    writer.writeGuidValue("customerId", registrationLine.customerId);
    writer.writeStringValue("customerName", registrationLine.customerName);
    writer.writeStringValue("customerReference", registrationLine.customerReference);
    writer.writeGuidValue("id", registrationLine.id);
    writer.writeGuidValue("locationId", registrationLine.locationId);
    writer.writeStringValue("meteringPointCity", registrationLine.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", registrationLine.meteringPointEanCode);
    writer.writeStringValue("meteringPointHouseNumber", registrationLine.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", registrationLine.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", registrationLine.meteringPointStreet);
    writer.writeNumberValue("units", registrationLine.units);
    writer.writeAdditionalData(registrationLine.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RegistrationSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRegistrationSummary(writer: SerializationWriter, registrationSummary: Partial<RegistrationSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!registrationSummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("blockedContractCount", registrationSummary.blockedContractCount);
    writer.writeNumberValue("contractCount", registrationSummary.contractCount);
    writer.writeStringValue("createdBy", registrationSummary.createdBy);
    writer.writeDateValue("createdDate", registrationSummary.createdDate);
    writer.writeGuidValue("id", registrationSummary.id);
    writer.writeStringValue("lastModifiedBy", registrationSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", registrationSummary.lastModifiedDate);
    writer.writeNumberValue("pendingContractCount", registrationSummary.pendingContractCount);
    writer.writeDateOnlyValue("periodFrom", registrationSummary.periodFrom);
    writer.writeDateOnlyValue("periodTo", registrationSummary.periodTo);
    writer.writeDateOnlyValue("registrationDate", registrationSummary.registrationDate);
    writer.writeStringValue("registrationReference", registrationSummary.registrationReference);
    writer.writeNumberValue("totalConsumption", registrationSummary.totalConsumption);
    writer.writeNumberValue("totalUnits", registrationSummary.totalUnits);
    writer.writeAdditionalData(registrationSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevokeContractSigningCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevokeContractSigningCommand(writer: SerializationWriter, revokeContractSigningCommand: Partial<RevokeContractSigningCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revokeContractSigningCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("contractId", revokeContractSigningCommand.contractId);
    writer.writeDateOnlyValue("revokedDate", revokeContractSigningCommand.revokedDate);
    writer.writeAdditionalData(revokeContractSigningCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevokeMandateSigningCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevokeMandateSigningCommand(writer: SerializationWriter, revokeMandateSigningCommand: Partial<RevokeMandateSigningCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revokeMandateSigningCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("contractId", revokeMandateSigningCommand.contractId);
    writer.writeDateOnlyValue("revokedDate", revokeMandateSigningCommand.revokedDate);
    writer.writeAdditionalData(revokeMandateSigningCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ServiceProviderSettings The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeServiceProviderSettings(writer: SerializationWriter, serviceProviderSettings: Partial<ServiceProviderSettings> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!serviceProviderSettings || isSerializingDerivedType) { return; }
    writer.writeStringValue("addressCity", serviceProviderSettings.addressCity);
    writer.writeStringValue("addressHouseNumber", serviceProviderSettings.addressHouseNumber);
    writer.writeStringValue("addressPostcode", serviceProviderSettings.addressPostcode);
    writer.writeStringValue("addressStreet", serviceProviderSettings.addressStreet);
    writer.writeStringValue("bankAccountHolder", serviceProviderSettings.bankAccountHolder);
    writer.writeStringValue("bankAccountNumber", serviceProviderSettings.bankAccountNumber);
    writer.writeNumberValue("commissionPercentage", serviceProviderSettings.commissionPercentage);
    writer.writeStringValue("companyRegistrationName", serviceProviderSettings.companyRegistrationName);
    writer.writeStringValue("companyRegistrationNumber", serviceProviderSettings.companyRegistrationNumber);
    writer.writeStringValue("contactEmail", serviceProviderSettings.contactEmail);
    writer.writeStringValue("contactFirstName", serviceProviderSettings.contactFirstName);
    writer.writeStringValue("contactLastName", serviceProviderSettings.contactLastName);
    writer.writeStringValue("contactPhone", serviceProviderSettings.contactPhone);
    writer.writeStringValue("createdBy", serviceProviderSettings.createdBy);
    writer.writeDateValue("createdDate", serviceProviderSettings.createdDate);
    writer.writeGuidValue("id", serviceProviderSettings.id);
    writer.writeStringValue("lastModifiedBy", serviceProviderSettings.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", serviceProviderSettings.lastModifiedDate);
    writer.writeStringValue("name", serviceProviderSettings.name);
    writer.writeStringValue("supportEmail", serviceProviderSettings.supportEmail);
    writer.writeNumberValue("vatPercentage", serviceProviderSettings.vatPercentage);
    writer.writeAdditionalData(serviceProviderSettings.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SessionConsumptionEntry The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSessionConsumptionEntry(writer: SerializationWriter, sessionConsumptionEntry: Partial<SessionConsumptionEntry> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!sessionConsumptionEntry || isSerializingDerivedType) { return; }
    writer.writeStringValue("chargerId", sessionConsumptionEntry.chargerId);
    writer.writeNumberValue("consumption", sessionConsumptionEntry.consumption);
    writer.writeStringValue("duration", sessionConsumptionEntry.duration);
    writer.writeStringValue("id", sessionConsumptionEntry.id);
    writer.writeEnumValue<ConsumptionProvider>("provider", sessionConsumptionEntry.provider);
    writer.writeDateValue("receivedAt", sessionConsumptionEntry.receivedAt);
    writer.writeEnumValue<ConsumptionSource>("source", sessionConsumptionEntry.source);
    writer.writeDateValue("startedAt", sessionConsumptionEntry.startedAt);
    writer.writeDateValue("stoppedAt", sessionConsumptionEntry.stoppedAt);
    writer.writeDateValue("timestamp", sessionConsumptionEntry.timestamp);
    writer.writeAdditionalData(sessionConsumptionEntry.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignContractCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignContractCommand(writer: SerializationWriter, signContractCommand: Partial<SignContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signContractCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("contractId", signContractCommand.contractId);
    writer.writeByteArrayValue("signature", signContractCommand.signature);
    writer.writeStringValue("signatureContentType", signContractCommand.signatureContentType);
    writer.writeNumberValue("signatureFileSize", signContractCommand.signatureFileSize);
    writer.writeStringValue("signedBy", signContractCommand.signedBy);
    writer.writeDateOnlyValue("signedDate", signContractCommand.signedDate);
    writer.writeAdditionalData(signContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignMandateCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignMandateCommand(writer: SerializationWriter, signMandateCommand: Partial<SignMandateCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signMandateCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("contractId", signMandateCommand.contractId);
    writer.writeByteArrayValue("signature", signMandateCommand.signature);
    writer.writeStringValue("signatureContentType", signMandateCommand.signatureContentType);
    writer.writeNumberValue("signatureFileSize", signMandateCommand.signatureFileSize);
    writer.writeStringValue("signedBy", signMandateCommand.signedBy);
    writer.writeDateOnlyValue("signedDate", signMandateCommand.signedDate);
    writer.writeAdditionalData(signMandateCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignupAddress The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignupAddress(writer: SerializationWriter, signupAddress: Partial<SignupAddress> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signupAddress || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", signupAddress.city);
    writer.writeStringValue("eanCode", signupAddress.eanCode);
    writer.writeStringValue("gridOperator", signupAddress.gridOperator);
    writer.writeStringValue("gridOperatorEanCode", signupAddress.gridOperatorEanCode);
    writer.writeStringValue("houseNumber", signupAddress.houseNumber);
    writer.writeStringValue("postcode", signupAddress.postcode);
    writer.writeStringValue("street", signupAddress.street);
    writer.writeBooleanValue("verified", signupAddress.verified);
    writer.writeAdditionalData(signupAddress.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignupBankAccount The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignupBankAccount(writer: SerializationWriter, signupBankAccount: Partial<SignupBankAccount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signupBankAccount || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountHolder", signupBankAccount.accountHolder);
    writer.writeStringValue("accountNumber", signupBankAccount.accountNumber);
    writer.writeAdditionalData(signupBankAccount.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignupChargePoint The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignupChargePoint(writer: SerializationWriter, signupChargePoint: Partial<SignupChargePoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signupChargePoint || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", signupChargePoint.deviceId);
    writer.writeStringValue("make", signupChargePoint.make);
    writer.writeStringValue("model", signupChargePoint.model);
    writer.writeStringValue("name", signupChargePoint.name);
    writer.writeAdditionalData(signupChargePoint.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignupCompanyRegistration The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignupCompanyRegistration(writer: SerializationWriter, signupCompanyRegistration: Partial<SignupCompanyRegistration> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signupCompanyRegistration || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", signupCompanyRegistration.name);
    writer.writeStringValue("number", signupCompanyRegistration.number);
    writer.writeStringValue("officeNumber", signupCompanyRegistration.officeNumber);
    writer.writeEnumValue<OfficeType>("officeType", signupCompanyRegistration.officeType);
    writer.writeBooleanValue("verified", signupCompanyRegistration.verified);
    writer.writeAdditionalData(signupCompanyRegistration.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SignupContact The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSignupContact(writer: SerializationWriter, signupContact: Partial<SignupContact> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!signupContact || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", signupContact.email);
    writer.writeStringValue("firstName", signupContact.firstName);
    writer.writeStringValue("lastName", signupContact.lastName);
    writer.writeStringValue("phone", signupContact.phone);
    writer.writeAdditionalData(signupContact.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TagCustomerCount The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagCustomerCount(writer: SerializationWriter, tagCustomerCount: Partial<TagCustomerCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tagCustomerCount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customers", tagCustomerCount.customers);
    writer.writeStringValue("tag", tagCustomerCount.tag);
    writer.writeAdditionalData(tagCustomerCount.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TagNamespaceCount The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagNamespaceCount(writer: SerializationWriter, tagNamespaceCount: Partial<TagNamespaceCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tagNamespaceCount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("customers", tagNamespaceCount.customers);
    writer.writeStringValue("namespace", tagNamespaceCount.namespace);
    writer.writeCollectionOfObjectValues<TagCustomerCount>("tags", tagNamespaceCount.tags, serializeTagCustomerCount);
    writer.writeAdditionalData(tagNamespaceCount.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param Transaction The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTransaction(writer: SerializationWriter, transaction: Partial<Transaction> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!transaction || isSerializingDerivedType) { return; }
    writer.writeNumberValue("costPercentage", transaction.costPercentage);
    writer.writeStringValue("createdBy", transaction.createdBy);
    writer.writeDateValue("createdDate", transaction.createdDate);
    writer.writeGuidValue("id", transaction.id);
    writer.writeStringValue("lastModifiedBy", transaction.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", transaction.lastModifiedDate);
    writer.writeCollectionOfObjectValues<TransactionLine>("lines", transaction.lines, serializeTransactionLine);
    writer.writeStringValue("notes", transaction.notes);
    writer.writeNumberValue("pricePerUnit", transaction.pricePerUnit);
    writer.writeGuidValue("registrationId", transaction.registrationId);
    writer.writeStringValue("registrationReference", transaction.registrationReference);
    writer.writeNumberValue("totalAmount", transaction.totalAmount);
    writer.writeNumberValue("totalCosts", transaction.totalCosts);
    writer.writeNumberValue("totalUnits", transaction.totalUnits);
    writer.writeNumberValue("totalYield", transaction.totalYield);
    writer.writeDateOnlyValue("transactionDate", transaction.transactionDate);
    writer.writeStringValue("transactionReference", transaction.transactionReference);
    writer.writeAdditionalData(transaction.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TransactionLine The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTransactionLine(writer: SerializationWriter, transactionLine: Partial<TransactionLine> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!transactionLine || isSerializingDerivedType) { return; }
    writer.writeNumberValue("amount", transactionLine.amount);
    writer.writeGuidValue("contractId", transactionLine.contractId);
    writer.writeStringValue("contractReference", transactionLine.contractReference);
    writer.writeNumberValue("costs", transactionLine.costs);
    writer.writeStringValue("customerEmail", transactionLine.customerEmail);
    writer.writeGuidValue("customerId", transactionLine.customerId);
    writer.writeStringValue("customerName", transactionLine.customerName);
    writer.writeStringValue("customerReference", transactionLine.customerReference);
    writer.writeGuidValue("id", transactionLine.id);
    writer.writeGuidValue("locationId", transactionLine.locationId);
    writer.writeStringValue("meteringPointCity", transactionLine.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", transactionLine.meteringPointEanCode);
    writer.writeStringValue("meteringPointHouseNumber", transactionLine.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", transactionLine.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", transactionLine.meteringPointStreet);
    writer.writeNumberValue("units", transactionLine.units);
    writer.writeNumberValue("yield", transactionLine.yield);
    writer.writeAdditionalData(transactionLine.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TransactionSummary The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTransactionSummary(writer: SerializationWriter, transactionSummary: Partial<TransactionSummary> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!transactionSummary || isSerializingDerivedType) { return; }
    writer.writeNumberValue("blockedContractCount", transactionSummary.blockedContractCount);
    writer.writeNumberValue("contractCount", transactionSummary.contractCount);
    writer.writeStringValue("createdBy", transactionSummary.createdBy);
    writer.writeDateValue("createdDate", transactionSummary.createdDate);
    writer.writeGuidValue("id", transactionSummary.id);
    writer.writeStringValue("lastModifiedBy", transactionSummary.lastModifiedBy);
    writer.writeDateValue("lastModifiedDate", transactionSummary.lastModifiedDate);
    writer.writeNumberValue("pendingContractCount", transactionSummary.pendingContractCount);
    writer.writeNumberValue("totalAmount", transactionSummary.totalAmount);
    writer.writeNumberValue("totalCosts", transactionSummary.totalCosts);
    writer.writeNumberValue("totalUnits", transactionSummary.totalUnits);
    writer.writeNumberValue("totalYield", transactionSummary.totalYield);
    writer.writeDateOnlyValue("transactionDate", transactionSummary.transactionDate);
    writer.writeStringValue("transactionReference", transactionSummary.transactionReference);
    writer.writeAdditionalData(transactionSummary.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateAccountCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateAccountCommand(writer: SerializationWriter, updateAccountCommand: Partial<UpdateAccountCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateAccountCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateAccountCommand.id);
    writer.writeStringValue("name", updateAccountCommand.name);
    writer.writeAdditionalData(updateAccountCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateAffiliateCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateAffiliateCommand(writer: SerializationWriter, updateAffiliateCommand: Partial<UpdateAffiliateCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateAffiliateCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("affiliateCode", updateAffiliateCommand.affiliateCode);
    writer.writeObjectValue<AffiliateTermsDto>("businessCondition", updateAffiliateCommand.businessCondition, serializeAffiliateTermsDto);
    writer.writeObjectValue<AffiliateTermsDto>("consumerCondition", updateAffiliateCommand.consumerCondition, serializeAffiliateTermsDto);
    writer.writeGuidValue("id", updateAffiliateCommand.id);
    writer.writeStringValue("name", updateAffiliateCommand.name);
    writer.writeStringValue("notes", updateAffiliateCommand.notes);
    writer.writeAdditionalData(updateAffiliateCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateChargePointCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateChargePointCommand(writer: SerializationWriter, updateChargePointCommand: Partial<UpdateChargePointCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateChargePointCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("deviceId", updateChargePointCommand.deviceId);
    writer.writeGuidValue("id", updateChargePointCommand.id);
    writer.writeStringValue("make", updateChargePointCommand.make);
    writer.writeEnumValue<MidMeterType>("midMeter", updateChargePointCommand.midMeter);
    writer.writeStringValue("model", updateChargePointCommand.model);
    writer.writeStringValue("name", updateChargePointCommand.name);
    writer.writeBooleanValue("skipVerification", updateChargePointCommand.skipVerification);
    writer.writeBooleanValue("verified", updateChargePointCommand.verified);
    writer.writeAdditionalData(updateChargePointCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateChargerDefinitionCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateChargerDefinitionCommand(writer: SerializationWriter, updateChargerDefinitionCommand: Partial<UpdateChargerDefinitionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateChargerDefinitionCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ChargeType>("chargeType", updateChargerDefinitionCommand.chargeType);
    writer.writeStringValue("datasheetUrl", updateChargerDefinitionCommand.datasheetUrl);
    writer.writeGuidValue("id", updateChargerDefinitionCommand.id);
    writer.writeStringValue("make", updateChargerDefinitionCommand.make);
    writer.writeStringValue("meterMake", updateChargerDefinitionCommand.meterMake);
    writer.writeStringValue("meterModel", updateChargerDefinitionCommand.meterModel);
    writer.writeEnumValue<MidMeterType>("midMeter", updateChargerDefinitionCommand.midMeter);
    writer.writeStringValue("model", updateChargerDefinitionCommand.model);
    writer.writeStringValue("notes", updateChargerDefinitionCommand.notes);
    writer.writeStringValue("source", updateChargerDefinitionCommand.source);
    writer.writeAdditionalData(updateChargerDefinitionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateContractAffiliateConditionCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateContractAffiliateConditionCommand(writer: SerializationWriter, updateContractAffiliateConditionCommand: Partial<UpdateContractAffiliateConditionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateContractAffiliateConditionCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", updateContractAffiliateConditionCommand.affiliateId);
    writer.writeGuidValue("contractId", updateContractAffiliateConditionCommand.contractId);
    writer.writeAdditionalData(updateContractAffiliateConditionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateContractCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateContractCommand(writer: SerializationWriter, updateContractCommand: Partial<UpdateContractCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateContractCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateContractCommand.id);
    writer.writeDateOnlyValue("validFrom", updateContractCommand.validFrom);
    writer.writeDateOnlyValue("validTo", updateContractCommand.validTo);
    writer.writeAdditionalData(updateContractCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateContractCommissionPercentageCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateContractCommissionPercentageCommand(writer: SerializationWriter, updateContractCommissionPercentageCommand: Partial<UpdateContractCommissionPercentageCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateContractCommissionPercentageCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("commissionPercentage", updateContractCommissionPercentageCommand.commissionPercentage);
    writer.writeGuidValue("contractId", updateContractCommissionPercentageCommand.contractId);
    writer.writeAdditionalData(updateContractCommissionPercentageCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateConversionFactorCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateConversionFactorCommand(writer: SerializationWriter, updateConversionFactorCommand: Partial<UpdateConversionFactorCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateConversionFactorCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("expectedErePrice", updateConversionFactorCommand.expectedErePrice);
    writer.writeGuidValue("id", updateConversionFactorCommand.id);
    writer.writeNumberValue("netConsumptionFactor", updateConversionFactorCommand.netConsumptionFactor);
    writer.writeNumberValue("renewableConsumptionFactor", updateConversionFactorCommand.renewableConsumptionFactor);
    writer.writeNumberValue("year", updateConversionFactorCommand.year);
    writer.writeAdditionalData(updateConversionFactorCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerAddressCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerAddressCommand(writer: SerializationWriter, updateCustomerAddressCommand: Partial<UpdateCustomerAddressCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerAddressCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<AddressType>("addressType", updateCustomerAddressCommand.addressType);
    writer.writeStringValue("city", updateCustomerAddressCommand.city);
    writer.writeGuidValue("customerId", updateCustomerAddressCommand.customerId);
    writer.writeStringValue("houseNumber", updateCustomerAddressCommand.houseNumber);
    writer.writeStringValue("postcode", updateCustomerAddressCommand.postcode);
    writer.writeBooleanValue("skipAddressVerification", updateCustomerAddressCommand.skipAddressVerification);
    writer.writeStringValue("street", updateCustomerAddressCommand.street);
    writer.writeBooleanValue("verified", updateCustomerAddressCommand.verified);
    writer.writeAdditionalData(updateCustomerAddressCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerAffiliateCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerAffiliateCommand(writer: SerializationWriter, updateCustomerAffiliateCommand: Partial<UpdateCustomerAffiliateCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerAffiliateCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("affiliateId", updateCustomerAffiliateCommand.affiliateId);
    writer.writeGuidValue("customerId", updateCustomerAffiliateCommand.customerId);
    writer.writeAdditionalData(updateCustomerAffiliateCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerBankAccountCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerBankAccountCommand(writer: SerializationWriter, updateCustomerBankAccountCommand: Partial<UpdateCustomerBankAccountCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerBankAccountCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountHolder", updateCustomerBankAccountCommand.accountHolder);
    writer.writeStringValue("accountNumber", updateCustomerBankAccountCommand.accountNumber);
    writer.writeGuidValue("customerId", updateCustomerBankAccountCommand.customerId);
    writer.writeBooleanValue("verified", updateCustomerBankAccountCommand.verified);
    writer.writeAdditionalData(updateCustomerBankAccountCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerCompanyRegistrationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerCompanyRegistrationCommand(writer: SerializationWriter, updateCustomerCompanyRegistrationCommand: Partial<UpdateCustomerCompanyRegistrationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerCompanyRegistrationCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("companyName", updateCustomerCompanyRegistrationCommand.companyName);
    writer.writeStringValue("companyRegistrationNumber", updateCustomerCompanyRegistrationCommand.companyRegistrationNumber);
    writer.writeGuidValue("customerId", updateCustomerCompanyRegistrationCommand.customerId);
    writer.writeBooleanValue("skipCompanyRegistrationVerification", updateCustomerCompanyRegistrationCommand.skipCompanyRegistrationVerification);
    writer.writeAdditionalData(updateCustomerCompanyRegistrationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerContactCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerContactCommand(writer: SerializationWriter, updateCustomerContactCommand: Partial<UpdateCustomerContactCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerContactCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", updateCustomerContactCommand.customerId);
    writer.writeStringValue("email", updateCustomerContactCommand.email);
    writer.writeStringValue("firstName", updateCustomerContactCommand.firstName);
    writer.writeStringValue("lastName", updateCustomerContactCommand.lastName);
    writer.writeStringValue("phone", updateCustomerContactCommand.phone);
    writer.writeAdditionalData(updateCustomerContactCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerNotesCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerNotesCommand(writer: SerializationWriter, updateCustomerNotesCommand: Partial<UpdateCustomerNotesCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerNotesCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", updateCustomerNotesCommand.customerId);
    writer.writeStringValue("notes", updateCustomerNotesCommand.notes);
    writer.writeAdditionalData(updateCustomerNotesCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateCustomerTagsCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateCustomerTagsCommand(writer: SerializationWriter, updateCustomerTagsCommand: Partial<UpdateCustomerTagsCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateCustomerTagsCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("customerId", updateCustomerTagsCommand.customerId);
    writer.writeCollectionOfPrimitiveValues<string>("tags", updateCustomerTagsCommand.tags);
    writer.writeAdditionalData(updateCustomerTagsCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateDocumentApprovalCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateDocumentApprovalCommand(writer: SerializationWriter, updateDocumentApprovalCommand: Partial<UpdateDocumentApprovalCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateDocumentApprovalCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateDocumentApprovalCommand.id);
    writer.writeStringValue("rejectionNote", updateDocumentApprovalCommand.rejectionNote);
    writer.writeEnumValue<RejectionReason>("rejectionReason", updateDocumentApprovalCommand.rejectionReason);
    writer.writeEnumValue<ApprovalStatus>("status", updateDocumentApprovalCommand.status);
    writer.writeAdditionalData(updateDocumentApprovalCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateLedgerCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateLedgerCommand(writer: SerializationWriter, updateLedgerCommand: Partial<UpdateLedgerCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateLedgerCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateLedgerCommand.id);
    writer.writeStringValue("name", updateLedgerCommand.name);
    writer.writeAdditionalData(updateLedgerCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateLocationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateLocationCommand(writer: SerializationWriter, updateLocationCommand: Partial<UpdateLocationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateLocationCommand || isSerializingDerivedType) { return; }
    writer.writeEnumValue<ConnectionType>("connectionType", updateLocationCommand.connectionType);
    writer.writeGuidValue("id", updateLocationCommand.id);
    writer.writeStringValue("meteringPointCity", updateLocationCommand.meteringPointCity);
    writer.writeStringValue("meteringPointEanCode", updateLocationCommand.meteringPointEanCode);
    writer.writeStringValue("meteringPointGridOperator", updateLocationCommand.meteringPointGridOperator);
    writer.writeStringValue("meteringPointGridOperatorEanCode", updateLocationCommand.meteringPointGridOperatorEanCode);
    writer.writeStringValue("meteringPointHouseNumber", updateLocationCommand.meteringPointHouseNumber);
    writer.writeStringValue("meteringPointPostcode", updateLocationCommand.meteringPointPostcode);
    writer.writeStringValue("meteringPointStreet", updateLocationCommand.meteringPointStreet);
    writer.writeBooleanValue("meteringPointVerified", updateLocationCommand.meteringPointVerified);
    writer.writeStringValue("name", updateLocationCommand.name);
    writer.writeBooleanValue("skipMeteringPointVerification", updateLocationCommand.skipMeteringPointVerification);
    writer.writeAdditionalData(updateLocationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateLocationEssInstallationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateLocationEssInstallationCommand(writer: SerializationWriter, updateLocationEssInstallationCommand: Partial<UpdateLocationEssInstallationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateLocationEssInstallationCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("capacity", updateLocationEssInstallationCommand.capacity);
    writer.writeGuidValue("id", updateLocationEssInstallationCommand.id);
    writer.writeStringValue("make", updateLocationEssInstallationCommand.make);
    writer.writeStringValue("model", updateLocationEssInstallationCommand.model);
    writer.writeStringValue("notes", updateLocationEssInstallationCommand.notes);
    writer.writeAdditionalData(updateLocationEssInstallationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateLocationPvInstallationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateLocationPvInstallationCommand(writer: SerializationWriter, updateLocationPvInstallationCommand: Partial<UpdateLocationPvInstallationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateLocationPvInstallationCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("capacity", updateLocationPvInstallationCommand.capacity);
    writer.writeGuidValue("id", updateLocationPvInstallationCommand.id);
    writer.writeStringValue("make", updateLocationPvInstallationCommand.make);
    writer.writeStringValue("model", updateLocationPvInstallationCommand.model);
    writer.writeStringValue("notes", updateLocationPvInstallationCommand.notes);
    writer.writeAdditionalData(updateLocationPvInstallationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdatePayoutCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdatePayoutCommand(writer: SerializationWriter, updatePayoutCommand: Partial<UpdatePayoutCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updatePayoutCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updatePayoutCommand.id);
    writer.writeStringValue("notes", updatePayoutCommand.notes);
    writer.writeDateOnlyValue("payoutDate", updatePayoutCommand.payoutDate);
    writer.writeAdditionalData(updatePayoutCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateRegistrationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateRegistrationCommand(writer: SerializationWriter, updateRegistrationCommand: Partial<UpdateRegistrationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateRegistrationCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateRegistrationCommand.id);
    writer.writeStringValue("notes", updateRegistrationCommand.notes);
    writer.writeDateOnlyValue("registrationDate", updateRegistrationCommand.registrationDate);
    writer.writeAdditionalData(updateRegistrationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsAddressCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsAddressCommand(writer: SerializationWriter, updateServiceProviderSettingsAddressCommand: Partial<UpdateServiceProviderSettingsAddressCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsAddressCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("city", updateServiceProviderSettingsAddressCommand.city);
    writer.writeStringValue("houseNumber", updateServiceProviderSettingsAddressCommand.houseNumber);
    writer.writeStringValue("postcode", updateServiceProviderSettingsAddressCommand.postcode);
    writer.writeStringValue("street", updateServiceProviderSettingsAddressCommand.street);
    writer.writeAdditionalData(updateServiceProviderSettingsAddressCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsBankAccountCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsBankAccountCommand(writer: SerializationWriter, updateServiceProviderSettingsBankAccountCommand: Partial<UpdateServiceProviderSettingsBankAccountCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsBankAccountCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("accountHolder", updateServiceProviderSettingsBankAccountCommand.accountHolder);
    writer.writeStringValue("accountNumber", updateServiceProviderSettingsBankAccountCommand.accountNumber);
    writer.writeAdditionalData(updateServiceProviderSettingsBankAccountCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsCompanyRegistrationCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsCompanyRegistrationCommand(writer: SerializationWriter, updateServiceProviderSettingsCompanyRegistrationCommand: Partial<UpdateServiceProviderSettingsCompanyRegistrationCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsCompanyRegistrationCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("companyName", updateServiceProviderSettingsCompanyRegistrationCommand.companyName);
    writer.writeStringValue("companyRegistrationNumber", updateServiceProviderSettingsCompanyRegistrationCommand.companyRegistrationNumber);
    writer.writeAdditionalData(updateServiceProviderSettingsCompanyRegistrationCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsContactCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsContactCommand(writer: SerializationWriter, updateServiceProviderSettingsContactCommand: Partial<UpdateServiceProviderSettingsContactCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsContactCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", updateServiceProviderSettingsContactCommand.email);
    writer.writeStringValue("firstName", updateServiceProviderSettingsContactCommand.firstName);
    writer.writeStringValue("lastName", updateServiceProviderSettingsContactCommand.lastName);
    writer.writeStringValue("phone", updateServiceProviderSettingsContactCommand.phone);
    writer.writeAdditionalData(updateServiceProviderSettingsContactCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsPayoutDetailsCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsPayoutDetailsCommand(writer: SerializationWriter, updateServiceProviderSettingsPayoutDetailsCommand: Partial<UpdateServiceProviderSettingsPayoutDetailsCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsPayoutDetailsCommand || isSerializingDerivedType) { return; }
    writer.writeNumberValue("commissionPercentage", updateServiceProviderSettingsPayoutDetailsCommand.commissionPercentage);
    writer.writeNumberValue("vatPercentage", updateServiceProviderSettingsPayoutDetailsCommand.vatPercentage);
    writer.writeAdditionalData(updateServiceProviderSettingsPayoutDetailsCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateServiceProviderSettingsSupportEmailCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateServiceProviderSettingsSupportEmailCommand(writer: SerializationWriter, updateServiceProviderSettingsSupportEmailCommand: Partial<UpdateServiceProviderSettingsSupportEmailCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateServiceProviderSettingsSupportEmailCommand || isSerializingDerivedType) { return; }
    writer.writeStringValue("supportEmail", updateServiceProviderSettingsSupportEmailCommand.supportEmail);
    writer.writeAdditionalData(updateServiceProviderSettingsSupportEmailCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateTransactionCommand The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateTransactionCommand(writer: SerializationWriter, updateTransactionCommand: Partial<UpdateTransactionCommand> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateTransactionCommand || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", updateTransactionCommand.id);
    writer.writeStringValue("notes", updateTransactionCommand.notes);
    writer.writeDateOnlyValue("transactionDate", updateTransactionCommand.transactionDate);
    writer.writeAdditionalData(updateTransactionCommand.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 * @param YearMandateSigningCount The instance to serialize from.
 */
// @ts-ignore
export function serializeYearMandateSigningCount(writer: SerializationWriter, yearMandateSigningCount: Partial<YearMandateSigningCount> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!yearMandateSigningCount || isSerializingDerivedType) { return; }
    writer.writeNumberValue("signed", yearMandateSigningCount.signed);
    writer.writeNumberValue("unsigned", yearMandateSigningCount.unsigned);
    writer.writeNumberValue("year", yearMandateSigningCount.year);
    writer.writeAdditionalData(yearMandateSigningCount.additionalData);
}
export interface ServiceProviderSettings extends AdditionalDataHolder, Parsable {
    /**
     * The addressCity property
     */
    addressCity?: string | null;
    /**
     * The addressHouseNumber property
     */
    addressHouseNumber?: string | null;
    /**
     * The addressPostcode property
     */
    addressPostcode?: string | null;
    /**
     * The addressStreet property
     */
    addressStreet?: string | null;
    /**
     * The bankAccountHolder property
     */
    bankAccountHolder?: string | null;
    /**
     * The bankAccountNumber property
     */
    bankAccountNumber?: string | null;
    /**
     * The commissionPercentage property
     */
    commissionPercentage?: number | null;
    /**
     * The companyRegistrationName property
     */
    companyRegistrationName?: string | null;
    /**
     * The companyRegistrationNumber property
     */
    companyRegistrationNumber?: string | null;
    /**
     * The contactEmail property
     */
    contactEmail?: string | null;
    /**
     * The contactFirstName property
     */
    contactFirstName?: string | null;
    /**
     * The contactLastName property
     */
    contactLastName?: string | null;
    /**
     * The contactPhone property
     */
    contactPhone?: string | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The supportEmail property
     */
    supportEmail?: string | null;
    /**
     * The vatPercentage property
     */
    vatPercentage?: number | null;
}
export interface SessionConsumptionEntry extends AdditionalDataHolder, Parsable {
    /**
     * The chargerId property
     */
    chargerId?: string | null;
    /**
     * The consumption property
     */
    consumption?: number | null;
    /**
     * The duration property
     */
    duration?: string | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The provider property
     */
    provider?: ConsumptionProvider | null;
    /**
     * The receivedAt property
     */
    receivedAt?: Date | null;
    /**
     * The source property
     */
    source?: ConsumptionSource | null;
    /**
     * The startedAt property
     */
    startedAt?: Date | null;
    /**
     * The stoppedAt property
     */
    stoppedAt?: Date | null;
    /**
     * The timestamp property
     */
    timestamp?: Date | null;
}
export type SettlementEligibility = (typeof SettlementEligibilityObject)[keyof typeof SettlementEligibilityObject];
export interface SignContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The signature property
     */
    signature?: ArrayBuffer | null;
    /**
     * The signatureContentType property
     */
    signatureContentType?: string | null;
    /**
     * The signatureFileSize property
     */
    signatureFileSize?: number | null;
    /**
     * The signedBy property
     */
    signedBy?: string | null;
    /**
     * The signedDate property
     */
    signedDate?: DateOnly | null;
}
export interface SignMandateCommand extends AdditionalDataHolder, Parsable {
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The signature property
     */
    signature?: ArrayBuffer | null;
    /**
     * The signatureContentType property
     */
    signatureContentType?: string | null;
    /**
     * The signatureFileSize property
     */
    signatureFileSize?: number | null;
    /**
     * The signedBy property
     */
    signedBy?: string | null;
    /**
     * The signedDate property
     */
    signedDate?: DateOnly | null;
}
export interface SignupAddress extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The eanCode property
     */
    eanCode?: string | null;
    /**
     * The gridOperator property
     */
    gridOperator?: string | null;
    /**
     * The gridOperatorEanCode property
     */
    gridOperatorEanCode?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
export interface SignupBankAccount extends AdditionalDataHolder, Parsable {
    /**
     * The accountHolder property
     */
    accountHolder?: string | null;
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
}
export interface SignupChargePoint extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface SignupCompanyRegistration extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The number property
     */
    number?: string | null;
    /**
     * The officeNumber property
     */
    officeNumber?: string | null;
    /**
     * The officeType property
     */
    officeType?: OfficeType | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
export interface SignupContact extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
}
export interface TagCustomerCount extends AdditionalDataHolder, Parsable {
    /**
     * The customers property
     */
    customers?: number | null;
    /**
     * The tag property
     */
    tag?: string | null;
}
export interface TagNamespaceCount extends AdditionalDataHolder, Parsable {
    /**
     * The customers property
     */
    customers?: number | null;
    /**
     * The namespace property
     */
    namespace?: string | null;
    /**
     * The tags property
     */
    tags?: TagCustomerCount[] | null;
}
export interface Transaction extends AdditionalDataHolder, Parsable {
    /**
     * The costPercentage property
     */
    costPercentage?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The lines property
     */
    lines?: TransactionLine[] | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The pricePerUnit property
     */
    pricePerUnit?: number | null;
    /**
     * The registrationId property
     */
    registrationId?: Guid | null;
    /**
     * The registrationReference property
     */
    registrationReference?: string | null;
    /**
     * The totalAmount property
     */
    totalAmount?: number | null;
    /**
     * The totalCosts property
     */
    totalCosts?: number | null;
    /**
     * The totalUnits property
     */
    totalUnits?: number | null;
    /**
     * The totalYield property
     */
    totalYield?: number | null;
    /**
     * The transactionDate property
     */
    transactionDate?: DateOnly | null;
    /**
     * The transactionReference property
     */
    transactionReference?: string | null;
}
export interface TransactionLine extends AdditionalDataHolder, Parsable {
    /**
     * The amount property
     */
    amount?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
    /**
     * The contractReference property
     */
    contractReference?: string | null;
    /**
     * The costs property
     */
    costs?: number | null;
    /**
     * The customerEmail property
     */
    customerEmail?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The customerName property
     */
    customerName?: string | null;
    /**
     * The customerReference property
     */
    customerReference?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The locationId property
     */
    locationId?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The units property
     */
    units?: number | null;
    /**
     * The yield property
     */
    yield?: number | null;
}
export interface TransactionSummary extends AdditionalDataHolder, Parsable {
    /**
     * The blockedContractCount property
     */
    blockedContractCount?: number | null;
    /**
     * The contractCount property
     */
    contractCount?: number | null;
    /**
     * The createdBy property
     */
    createdBy?: string | null;
    /**
     * The createdDate property
     */
    createdDate?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The lastModifiedBy property
     */
    lastModifiedBy?: string | null;
    /**
     * The lastModifiedDate property
     */
    lastModifiedDate?: Date | null;
    /**
     * The pendingContractCount property
     */
    pendingContractCount?: number | null;
    /**
     * The totalAmount property
     */
    totalAmount?: number | null;
    /**
     * The totalCosts property
     */
    totalCosts?: number | null;
    /**
     * The totalUnits property
     */
    totalUnits?: number | null;
    /**
     * The totalYield property
     */
    totalYield?: number | null;
    /**
     * The transactionDate property
     */
    transactionDate?: DateOnly | null;
    /**
     * The transactionReference property
     */
    transactionReference?: string | null;
}
export interface UpdateAccountCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface UpdateAffiliateCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateCode property
     */
    affiliateCode?: string | null;
    /**
     * The businessCondition property
     */
    businessCondition?: AffiliateTermsDto | null;
    /**
     * The consumerCondition property
     */
    consumerCondition?: AffiliateTermsDto | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface UpdateChargePointCommand extends AdditionalDataHolder, Parsable {
    /**
     * The deviceId property
     */
    deviceId?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The skipVerification property
     */
    skipVerification?: boolean | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
export interface UpdateChargerDefinitionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The chargeType property
     */
    chargeType?: ChargeType | null;
    /**
     * The datasheetUrl property
     */
    datasheetUrl?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The meterMake property
     */
    meterMake?: string | null;
    /**
     * The meterModel property
     */
    meterModel?: string | null;
    /**
     * The midMeter property
     */
    midMeter?: MidMeterType | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The source property
     */
    source?: string | null;
}
export interface UpdateContractAffiliateConditionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
}
export interface UpdateContractCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The validFrom property
     */
    validFrom?: DateOnly | null;
    /**
     * The validTo property
     */
    validTo?: DateOnly | null;
}
export interface UpdateContractCommissionPercentageCommand extends AdditionalDataHolder, Parsable {
    /**
     * The commissionPercentage property
     */
    commissionPercentage?: number | null;
    /**
     * The contractId property
     */
    contractId?: Guid | null;
}
export interface UpdateConversionFactorCommand extends AdditionalDataHolder, Parsable {
    /**
     * The expectedErePrice property
     */
    expectedErePrice?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The netConsumptionFactor property
     */
    netConsumptionFactor?: number | null;
    /**
     * The renewableConsumptionFactor property
     */
    renewableConsumptionFactor?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export interface UpdateCustomerAddressCommand extends AdditionalDataHolder, Parsable {
    /**
     * The addressType property
     */
    addressType?: AddressType | null;
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The skipAddressVerification property
     */
    skipAddressVerification?: boolean | null;
    /**
     * The street property
     */
    street?: string | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
export interface UpdateCustomerAffiliateCommand extends AdditionalDataHolder, Parsable {
    /**
     * The affiliateId property
     */
    affiliateId?: Guid | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
}
export interface UpdateCustomerBankAccountCommand extends AdditionalDataHolder, Parsable {
    /**
     * The accountHolder property
     */
    accountHolder?: string | null;
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The verified property
     */
    verified?: boolean | null;
}
export interface UpdateCustomerCompanyRegistrationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyRegistrationNumber property
     */
    companyRegistrationNumber?: string | null;
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The skipCompanyRegistrationVerification property
     */
    skipCompanyRegistrationVerification?: boolean | null;
}
export interface UpdateCustomerContactCommand extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
}
export interface UpdateCustomerNotesCommand extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface UpdateCustomerTagsCommand extends AdditionalDataHolder, Parsable {
    /**
     * The customerId property
     */
    customerId?: Guid | null;
    /**
     * The tags property
     */
    tags?: string[] | null;
}
export interface UpdateDocumentApprovalCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The rejectionNote property
     */
    rejectionNote?: string | null;
    /**
     * The rejectionReason property
     */
    rejectionReason?: RejectionReason | null;
    /**
     * The status property
     */
    status?: ApprovalStatus | null;
}
export interface UpdateLedgerCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface UpdateLocationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The connectionType property
     */
    connectionType?: ConnectionType | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The meteringPointCity property
     */
    meteringPointCity?: string | null;
    /**
     * The meteringPointEanCode property
     */
    meteringPointEanCode?: string | null;
    /**
     * The meteringPointGridOperator property
     */
    meteringPointGridOperator?: string | null;
    /**
     * The meteringPointGridOperatorEanCode property
     */
    meteringPointGridOperatorEanCode?: string | null;
    /**
     * The meteringPointHouseNumber property
     */
    meteringPointHouseNumber?: string | null;
    /**
     * The meteringPointPostcode property
     */
    meteringPointPostcode?: string | null;
    /**
     * The meteringPointStreet property
     */
    meteringPointStreet?: string | null;
    /**
     * The meteringPointVerified property
     */
    meteringPointVerified?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The skipMeteringPointVerification property
     */
    skipMeteringPointVerification?: boolean | null;
}
export interface UpdateLocationEssInstallationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface UpdateLocationPvInstallationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The capacity property
     */
    capacity?: number | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The make property
     */
    make?: string | null;
    /**
     * The model property
     */
    model?: string | null;
    /**
     * The notes property
     */
    notes?: string | null;
}
export interface UpdatePayoutCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The payoutDate property
     */
    payoutDate?: DateOnly | null;
}
export interface UpdateRegistrationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The registrationDate property
     */
    registrationDate?: DateOnly | null;
}
export interface UpdateServiceProviderSettingsAddressCommand extends AdditionalDataHolder, Parsable {
    /**
     * The city property
     */
    city?: string | null;
    /**
     * The houseNumber property
     */
    houseNumber?: string | null;
    /**
     * The postcode property
     */
    postcode?: string | null;
    /**
     * The street property
     */
    street?: string | null;
}
export interface UpdateServiceProviderSettingsBankAccountCommand extends AdditionalDataHolder, Parsable {
    /**
     * The accountHolder property
     */
    accountHolder?: string | null;
    /**
     * The accountNumber property
     */
    accountNumber?: string | null;
}
export interface UpdateServiceProviderSettingsCompanyRegistrationCommand extends AdditionalDataHolder, Parsable {
    /**
     * The companyName property
     */
    companyName?: string | null;
    /**
     * The companyRegistrationNumber property
     */
    companyRegistrationNumber?: string | null;
}
export interface UpdateServiceProviderSettingsContactCommand extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The firstName property
     */
    firstName?: string | null;
    /**
     * The lastName property
     */
    lastName?: string | null;
    /**
     * The phone property
     */
    phone?: string | null;
}
export interface UpdateServiceProviderSettingsPayoutDetailsCommand extends AdditionalDataHolder, Parsable {
    /**
     * The commissionPercentage property
     */
    commissionPercentage?: number | null;
    /**
     * The vatPercentage property
     */
    vatPercentage?: number | null;
}
export interface UpdateServiceProviderSettingsSupportEmailCommand extends AdditionalDataHolder, Parsable {
    /**
     * The supportEmail property
     */
    supportEmail?: string | null;
}
export interface UpdateTransactionCommand extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The notes property
     */
    notes?: string | null;
    /**
     * The transactionDate property
     */
    transactionDate?: DateOnly | null;
}
export type VerificationStatus = (typeof VerificationStatusObject)[keyof typeof VerificationStatusObject];
export interface YearMandateSigningCount extends AdditionalDataHolder, Parsable {
    /**
     * The signed property
     */
    signed?: number | null;
    /**
     * The unsigned property
     */
    unsigned?: number | null;
    /**
     * The year property
     */
    year?: number | null;
}
export const AccountEntryTypeObject = {
    Balance: "Balance",
    Credit: "Credit",
    Debit: "Debit",
} as const;
export const ActivityGranularityObject = {
    Day: "Day",
    Week: "Week",
} as const;
export const AddressTypeObject = {
    VisitingAddress: "VisitingAddress",
    PostalAddress: "PostalAddress",
} as const;
export const ApprovalStatusObject = {
    Pending: "Pending",
    Approved: "Approved",
    Rejected: "Rejected",
} as const;
export const AuditEntryTypeObject = {
    Change: "Change",
    Event: "Event",
} as const;
export const BackfillChargePointDeviceIdOutcomeObject = {
    Fixed: "Fixed",
    AlreadyCorrect: "AlreadyCorrect",
    Conflict: "Conflict",
    Undecided: "Undecided",
} as const;
export const CallDirectionObject = {
    Incoming: "Incoming",
    Outgoing: "Outgoing",
} as const;
export const ChargerConnectionStatusObject = {
    NotConnected: "NotConnected",
    WaitingForSetup: "WaitingForSetup",
    WaitingForConnection: "WaitingForConnection",
    Failed: "Failed",
    WaitingForFirstSession: "WaitingForFirstSession",
    Connected: "Connected",
    Disabled: "Disabled",
    AuthorizationExpired: "AuthorizationExpired",
    AccessDenied: "AccessDenied",
    LinkedToOtherAccount: "LinkedToOtherAccount",
} as const;
export const ChargeTypeObject = {
    AC: "AC",
    DC: "DC",
} as const;
export const ComplianceActorObject = {
    Customer: "Customer",
    Provider: "Provider",
} as const;
export const ComplianceItemObject = {
    MeteringPointNotVerified: "MeteringPointNotVerified",
    SupplierDocumentMissing: "SupplierDocumentMissing",
    SupplierDocumentAwaitingApproval: "SupplierDocumentAwaitingApproval",
    ConformityStatementMissing: "ConformityStatementMissing",
    ChargerNotVerified: "ChargerNotVerified",
    MidChargePointMissing: "MidChargePointMissing",
    MandateNotSigned: "MandateNotSigned",
    MandateAwaitingApproval: "MandateAwaitingApproval",
    ContractNotSigned: "ContractNotSigned",
} as const;
export const ComplianceStatusObject = {
    Compliant: "Compliant",
    Pending: "Pending",
    NotCompliant: "NotCompliant",
} as const;
export const ConnectionTypeObject = {
    SmallVolume: "SmallVolume",
    LargeVolume: "LargeVolume",
} as const;
export const ConsumptionGranularityObject = {
    Day: "Day",
    Month: "Month",
    Quarter: "Quarter",
} as const;
export const ConsumptionProviderObject = {
    Zaptec: "Zaptec",
    Easee: "Easee",
    Volttime: "Volttime",
    NexBlue: "NexBlue",
    Enphase: "Enphase",
    Heijmans: "Heijmans",
    PlugChoice: "PlugChoice",
    Tesla: "Tesla",
} as const;
export const ConsumptionSourceObject = {
    Api: "Api",
    Ocpp: "Ocpp",
    File: "File",
    Manual: "Manual",
} as const;
export const ConsumptionTypeObject = {
    NetConsumption: "NetConsumption",
    RenewableConsumption: "RenewableConsumption",
} as const;
export const ContractDocumentTypeObject = {
    Other: "Other",
    Contract: "Contract",
    Mandate: "Mandate",
    EnergySupplierContract: "EnergySupplierContract",
    EnergySupplierInvoice: "EnergySupplierInvoice",
    ChargePointInvoice: "ChargePointInvoice",
    ChargePointPhoto: "ChargePointPhoto",
    ChargePointSessions: "ChargePointSessions",
    CompanyRegistrationExtract: "CompanyRegistrationExtract",
    EnergySupplierDocument: "EnergySupplierDocument",
    ChargePointSessionExport: "ChargePointSessionExport",
    ChargePointSessionScreenshot: "ChargePointSessionScreenshot",
    ReimbursementStatement: "ReimbursementStatement",
    GridOperatorDocument: "GridOperatorDocument",
} as const;
export const ContractOverviewStatusObject = {
    Registered: "Registered",
    Sold: "Sold",
    PaidOut: "PaidOut",
} as const;
export const CurrencyTypeObject = {
    EUR: "EUR",
    ERE: "ERE",
} as const;
export const CustomerTypeObject = {
    Consumer: "Consumer",
    Business: "Business",
} as const;
export const DeviceIdMatchReasonObject = {
    None: "None",
    ApiConnectionPrevails: "ApiConnectionPrevails",
    NoDeviceId: "NoDeviceId",
    NoChargePoint: "NoChargePoint",
    NoChargePointOfTheMake: "NoChargePointOfTheMake",
    SeveralChargePoints: "SeveralChargePoints",
    SeveralDeviceIds: "SeveralDeviceIds",
    DeviceIdAtTheLocation: "DeviceIdAtTheLocation",
    DeviceIdOnAnotherCustomer: "DeviceIdOnAnotherCustomer",
} as const;
export const FileTypeObject = {
    Csv: "Csv",
    Excel: "Excel",
} as const;
export const IngestAffiliateCustomerOutcomeObject = {
    Create: "Create",
    Skip: "Skip",
    Reject: "Reject",
} as const;
export const IngestOutcomeObject = {
    Create: "Create",
    Update: "Update",
    Skip: "Skip",
    None: "None",
    Reject: "Reject",
} as const;
export const LegacyCompliancyStatusObject = {
    Unknown: "Unknown",
    NotCompliant: "NotCompliant",
    CompliantBySystem: "CompliantBySystem",
    CompliantManually: "CompliantManually",
} as const;
export const ManualReadingOutcomeObject = {
    Ingest: "Ingest",
    Duplicate: "Duplicate",
    Reject: "Reject",
} as const;
export const MidMeterTypeObject = {
    Undefined: "Undefined",
    Integrated: "Integrated",
    Optional: "Optional",
    None: "None",
} as const;
export const OAuthProviderTypeObject = {
    Unknown: "Unknown",
    Zaptec: "Zaptec",
    Easee: "Easee",
    Volttime: "Volttime",
    NexBlue: "NexBlue",
    Enphase: "Enphase",
    Heijmans: "Heijmans",
    PlugChoice: "PlugChoice",
    Tesla: "Tesla",
} as const;
export const OfficeTypeObject = {
    MainOffice: "MainOffice",
    BranchOffice: "BranchOffice",
    Undefined: "Undefined",
} as const;
export const RejectionReasonObject = {
    Other: "Other",
    MissingOrInvalidDocument: "MissingOrInvalidDocument",
    InvalidNameOrAddress: "InvalidNameOrAddress",
    MissingOrInvalidSignatoryAuthority: "MissingOrInvalidSignatoryAuthority",
    MissingOrInvalidEanCode: "MissingOrInvalidEanCode",
    MissingOrInvalidConsumption: "MissingOrInvalidConsumption",
    MissingOrInvalidChargePoint: "MissingOrInvalidChargePoint",
} as const;
export const SettlementEligibilityObject = {
    NoCurrentContract: "NoCurrentContract",
    NotEligible: "NotEligible",
    Registration: "Registration",
    Transaction: "Transaction",
    Payout: "Payout",
} as const;
export const VerificationStatusObject = {
    Pending: "Pending",
    Verified: "Verified",
    Skipped: "Skipped",
} as const;
/* tslint:enable */
/* eslint-enable */
